export const fr = {
  admin: {
    title: "IRES Admin",
    noAvailableSections: "Aucune fonction n’est activée pour toi ici.",
    // A refresh failed while a cached answer was shown (AdminReadCache.ts).
    refreshFailed: "Impossible d’actualiser : les dernières données chargées sont affichées.",
    // Authoring screens on a phone (PhoneEditingHint.vue).
    phoneEditingHint: "Pour modifier, utilise une tablette ou un ordinateur portable.",
      renoReview: {
        title: "Contrôle rapide RENO",
        filters: "Filtres",
        deviceTypes: "Types d’appareil",
        startAtSerial: "À partir de l’appareil",
        allDeviceTypes: "Tous",
        anyDevice: "Tous",
        anyClient: "Tous",
        noClients: "Aucun client trouvé",
        monthsSuffix: "mois",
        ageOrActive: "Période / statut",
        maxAgeMonths: "Uniquement les séchages des",
        fromDate: "À partir du",
        activeOnly: "Uniquement les séchages en cours",
        noAgeLimit: "Sans limite",
        matchingDryings: "Séchages correspondants",
        countCapped: "plus de {0}",
        countApprox: "env. {0}",
        countNone: "aucun",
        countLoading: "chargement …",
        alreadyReviewed: "Déjà passés en revue",
        ratingModeAll: "Tous",
        ratingModeUnrated: "Uniquement non encore évalués",
        ratingModeOnly: "Uniquement ceux que j’ai évalués",
        hideSeen: "Masquer ceux que j’ai regardés",
        startReview: "Démarrer le contrôle",
        noMatches: "Aucun séchage ne correspond à ces filtres.",
        loading: "Chargement …",
        device: "Appareil",
        drying: "Séchage",
        client: "Client",
        program: "Programme",
        dryingPosition: "Séchage {0} sur {1} pour cet appareil",
        chainStart: "Début",
        chainEnd: "Fin",
        previous: "Précédent",
        next: "Suivant",
        atFirst: "Tu es au premier séchage.",
        atLast: "Tu as passé en revue tous les séchages.",
        backToFilters: "Modifier les filtres",
        startAtSerialHint: "Aucun résultat à partir de l’appareil « {0} ». Vérifie le numéro de série.",
        loadFailed: "Le séchage n’a pas pu être chargé.",
        hidden: {
          title: "Séchages masqués",
          none: "Tu n’as masqué aucun séchage.",
          hiddenAt: "Masqué le",
          restore: "Afficher à nouveau",
          restored: "Le séchage revient dans ton contrôle.",
          restoreFailed: "Le séchage n’a pas pu être réaffiché.",
          loadMore: "Charger plus",
        },
        rating: {
          suppress: "Ne plus afficher",
          previously: "Ta dernière évaluation : {0}.",
          suppressFailed: "Le séchage n’a pas pu être masqué.",
          saveFailed: "Ton évaluation n’a pas pu être enregistrée.",
        },
        note: {
          commentPlaceholder: "Commentaire (optionnel)",
          chainSuspect: "Vérifier la chaîne",
          onlyChainSuspect: "Vérifier la chaîne",
          onlyWithComment: "Commentaire",
          saveFailed: "Ton commentaire n’a pas pu être enregistré.",
        },
        marks: {
          filterLabel: "Mes marques",
          onlySuppressed: "Masqué",
        },
      },
    categories: {
      clients: "Clients",
      production: "Production",
      mira: "Mira",
    },
    sections: {
      clients: {
        title: "Clients",
        description: "Rechercher tous les clients et les filtrer par type, contrat et statut.",
      },
      externalSystems: {
        title: "Systèmes externes",
        description: "Tous les systèmes ERP et partenaires avec leur propriétaire, les mandants liés et leur statut.",
      },
      userSearch: {
        title: "Rechercher des utilisateurs",
        description: "Trouve un utilisateur dans tous les clients : par adresse e-mail, nom, nom court ou matricule.",
      },
      sharedUsers: {
        title: "Utilisateurs partagés",
        description: "Les adresses e-mail partagées et les utilisateurs partagés des groupes, avec le nettoyage des entrées obsolètes.",
      },
      deviceReports: {
        title: "Rapports de test",
        description: "Consulter les rapports de test de production d’un appareil.",
      },
      pdfTemplates: {
        title: "Modèles PDF",
        description: "Modèles PDF partagés que les mandants peuvent reprendre. Les modèles d’un mandant se trouvent dans sa vue détaillée.",
      },
      infoConfig: {
        title: "Descriptions",
        description: "Toutes les versions des formulaires de projet, leurs cibles et la publication vérifiée de nouvelles versions.",
      },
      miraInsurers: {
        title: "Assureurs",
        description: "Les assureurs auxquels Mira attribue les projets, avec leurs graphies.",
      },
      miraInsurerReview: {
        title: "Assureurs non identifiés",
        description: "Noms d’assureurs que Mira n’a pas pu attribuer, regroupés pour que tu les attribues.",
      },
      miraCompanies: {
        title: "Entreprises",
        description: "Les clients qui comptent comme une seule entreprise dans la comparaison de marché de Mira.",
      },
      miraExceptions: {
        title: "Exceptions Mira",
        description: "Clôtures et accords saisis en retard, que Mira retire des durées.",
      },
    },
    externalSystems: {
      search: "Rechercher des systèmes externes",
      none: "Aucun système externe.",
      moreClients: "{0} et {1} autres",
      filters: {
        ALL: "Tous",
      },
    },
    miraCompanies: {
      title: "Entreprises",
      search: "Chercher une entreprise ou un client",
      create: "Nouvelle entreprise",
      hint: "Une entreprise à plusieurs clients compte une seule fois dans la comparaison de marché de Mira, avec une valeur sur tous ses clients. Un groupe (client maître) compte déjà une fois de lui-même ; un client sans entreprise compte pour lui seul.",
      loadFailed: "Les entreprises n’ont pas pu être chargées.",
      none: "Aucune entreprise",
      saved: "Entreprise enregistrée",
      retiredChip: "Retirée",
      effectNote: "S’applique à la comparaison de marché de tous les clients à partir du prochain passage nocturne de Mira.",
      lastChange: "dernière modification le {0} par {1}",
      clientCount: "{0} clients",
      moreClients: "{0} et {1} autres",
      takenBy: "appartient déjà à {0}",
      masterNote: "Client maître : inclut les clients de son groupe",
      inGroup: "inclus avec le client maître",
      isViewingClient: "montre l’entreprise dans Mira",
      viewerTakenBy: "montre déjà l’entreprise {0}",
      viewingClientLine: "Vue dans Mira : {0}",
      groupChip: "Groupe",
      groupMembers: "Inclus par le client maître : {0} clients",
      filters: {
        ACTIVE: "Actives",
        RETIRED: "Retirées",
        ALL: "Toutes",
      },
      fields: {
        name: "Nom",
        clients: "Clients",
        retired: "Retirée",
        viewingClient: "Vue dans Mira",
        memberGroupView: "Les mandants se comparent à la société",
      },
      hints: {
        clients: "Au moins deux, ou un client maître seul. Un client maître inclut les clients de son groupe ; chaque groupe est déjà une entreprise de lui-même.",
        retired: "Une entreprise retirée ne compte plus ; ses clients comptent alors de nouveau pour eux seuls.",
        viewingClient: "Un client qui montre l’entreprise dans Mira comme un groupe. Il ne compte pas parmi ses clients.",
        memberGroupView: "Chaque mandant de la société voit dans Mira, sous « Groupe », sa valeur à côté de celle de toute la société, comme les mandants d’un groupe. Activé d’office pour un groupe.",
      },
      fieldErrors: {
        required: "Champ obligatoire",
        clients: "Au moins deux clients ou un client maître",
      },
      dialog: {
        viewTitle: "Entreprise",
        editTitle: "Modifier l’entreprise",
        createTitle: "Nouvelle entreprise",
      },
      errors: {
        NO_COMPANY: "Cette entreprise n’existe plus.",
        NO_CLIENT: "L’un des clients n’existe plus.",
        CHANGED_MEANWHILE: "L’entreprise a été modifiée entre-temps. La liste est rechargée.",
        INVALID_NAME: "Le nom est obligatoire.",
        INVALID_ACCOUNTS: "Choisis au moins deux clients ou un client maître.",
        CONFLICT: "{0} appartient déjà à une autre entreprise.",
        INVALID_VIEWER: "Le client de la vue n’existe plus.",
        VIEWER_IS_ACCOUNT: "Le client de la vue ne doit pas faire partie des clients de l’entreprise.",
        VIEWER_IS_GROUP: "Un client maître avec son propre groupe ne peut pas montrer une entreprise.",
        VIEWER_TAKEN: "Ce client montre déjà l’entreprise {0}.",
        FAILED: "L’enregistrement a échoué.",
      },
    },
    miraExceptions: {
      title: "Exceptions Mira",
      search: "Chercher un client ou un motif",
      create: "Nouvelle exception",
      hint: "Quand un client a saisi un événement après coup (accords saisis en bloc plus tard, anciens projets clôturés d’un coup), Mira retire ces projets des durées qui reposent sur cet événement et indique leur nombre sur la tuile. Les comptages restent inchangés.",
      loadFailed: "Les exceptions n’ont pas pu être chargées.",
      none: "Aucune exception",
      saved: "Exception enregistrée",
      retiredChip: "Retirée",
      effectNote: "S’applique aux indicateurs de ce client (et de son groupe ou entreprise) à partir du prochain passage nocturne de Mira.",
      lastChange: "dernière modification le {0} par {1}",
      filters: {
        ACTIVE: "Actives",
        RETIRED: "Retirées",
        ALL: "Toutes",
      },
      columns: {
        range: "Période",
      },
      fields: {
        client: "Client",
        event: "Saisi en retard",
        from: "Du",
        to: "Au",
        reason: "Motif",
        retired: "Retirée",
      },
      events: {
        PROJECT_END: "Clôture du projet",
        OFFER_ANSWER: "Accord (réponse de l’assureur)",
      },
      eventFigures: {
        PROJECT_END: "Retire les projets clôturés dans la période après au moins 30 jours sans travail saisi de la durée moyenne de projet et du délai jusqu’à la clôture, avec un accord saisi à la clôture.",
        OFFER_ANSWER: "Retire les accords saisis dans la période à la clôture du projet (projets séchés ou longtemps inactifs) du délai d’accord, de l’expertise jusqu’à l’accord et de l’accord jusqu’au début du séchage / de la remise en état.",
      },
      hints: {
        reason: "Visible uniquement dans IRES Admin Client.",
        retired: "Une exception retirée ne s’applique plus ; les projets comptent alors de nouveau.",
      },
      fieldErrors: {
        required: "Champ obligatoire",
        range: "La fin précède le début.",
      },
      dialog: {
        viewTitle: "Exception Mira",
        editTitle: "Modifier l’exception Mira",
        createTitle: "Nouvelle exception Mira",
      },
      suggestions: {
        title: "Suggestions de Mira",
        hint: "Jours où un client a saisi en retard de nombreuses clôtures ou de nombreux accords, trouvés lors du passage nocturne de Mira. Reprendre en crée une exception, Écarter masque la suggestion.",
        entriesTitle: "Exceptions",
        takeOver: "Reprendre",
        dismissAction: "Écarter",
        dismissed: "Suggestion écartée",
        groupCount: "{0} suggestion | {0} suggestions",
        columns: {
          late: "En retard / total",
          mean: "Moyenne avec → sans",
          median: "Médiane avec → sans",
        },
        eventsShort: {
          PROJECT_END: "Clôture du projet",
          OFFER_ANSWER: "Accord",
        },
        change: "{0} → {1} jours",
        figure: {
          PROJECT_END: "Durée des projets {0} : moyenne {1} jours, sans ces clôtures {2} jours (médiane {3} → {4})",
          OFFER_ANSWER: "Délai d’accord {0} : moyenne {1} jours, sans ces accords {2} jours (médiane {3} → {4})",
        },
        dismiss: {
          title: "Écarter la suggestion",
          action: "Écarter",
          reason: "Motif",
        },
        errors: {
          NO_SUGGESTION: "Cette suggestion n’existe plus. La liste est rechargée.",
          CHANGED_MEANWHILE: "La suggestion a été modifiée entre-temps. La liste est rechargée.",
          INVALID_REASON: "Indique un motif.",
          FAILED: "L’écartement a échoué.",
        },
      },
      errors: {
        NO_EXCEPTION: "Cette exception n’existe plus.",
        NO_CLIENT: "Ce client n’existe pas.",
        CHANGED_MEANWHILE: "L’exception a été modifiée entre-temps. La liste est rechargée.",
        INVALID_EVENT: "Choisis ce qui a été saisi en retard.",
        INVALID_RANGE: "La période n’est pas valide.",
        INVALID_REASON: "Indique un motif.",
        FAILED: "L’enregistrement a échoué.",
      },
    },
    miraInsurers: {
      title: "Assureurs",
      search: "Rechercher un assureur",
      create: "Nouvel assureur",
      loadFailed: "Les assureurs n’ont pas pu être chargés.",
      none: "Aucun assureur",
      saved: "Assureur enregistré",
      retiredChip: "Retiré",
      effectNote: "S’applique aux indicateurs d’assureurs de tous les clients dès la prochaine exécution nocturne de Mira.",
      mdisKey: "Clé MDIS : {0}",
      lastChange: "modifié le {0} par {1}",
      filters: {
        ACTIVE: "Actifs",
        RETIRED: "Retirés",
        ALL: "Tous",
      },
      columns: {
        origin: "Origine",
        spellings: "Graphies",
      },
      origins: {
        MDIS: "De la liste d’assureurs de MDIS",
        IRES: "Ajouté par IRES",
      },
      originsShort: {
        MDIS: "MDIS",
        IRES: "IRES",
      },
      fields: {
        key: "Clé",
        shortName: "Nom court",
        name: "Nom",
        spellings: "Autres graphies",
        words: "Mots de reconnaissance",
        retired: "Retiré",
      },
      hints: {
        key: "2 à 12 majuscules ou chiffres. Tu peux la modifier à tout moment ; les chiffres de Mira restent les mêmes.",
        spellings: "Une par ligne. Majuscules / minuscules, umlauts et ponctuation ne comptent pas.",
        words: "Un par ligne, trois caractères au moins : reconnaît l’assureur partout où le mot apparaît dans le nom.",
        retired: "Un assureur retiré ne reconnaît plus rien ; ses projets comptent alors comme non identifiés.",
      },
      fieldErrors: {
        key: "2 à 12 majuscules ou chiffres",
        required: "Champ obligatoire",
      },
      dialog: {
        viewTitle: "Assureur",
        editTitle: "Modifier l’assureur",
        createTitle: "Nouvel assureur",
      },
      errors: {
        KEY_TAKEN: "Cette clé existe déjà.",
        NO_INSURER: "Cet assureur n’existe pas ou est retiré.",
        CHANGED_MEANWHILE: "L’assureur a été modifié entre-temps. La liste est rechargée.",
        INVALID_KEY: "La clé n’est pas valide.",
        INVALID_NAME: "Le nom court et le nom sont obligatoires.",
        INVALID_SPELLINGS: "Les graphies ne sont pas valides.",
        INVALID_TEXTS: "Choisis au moins une graphie.",
        INVALID_MERGE: "Un assureur ne peut pas être fusionné dans lui-même.",
        CONFLICT: "« {0} » appartiendrait à plusieurs assureurs ({1}).",
        CONFLICT_NOT_INSURER: "« {0} » ne peut pas appartenir à {1} et compter comme « Aucun assureur » à la fois.",
        FAILED: "L’enregistrement a échoué.",
      },
      rowActions: "Actions",
      mergedInto: "Fusionné dans {0}",
      move: {
        menu: "Déplacer des graphies",
        title: "Déplacer des graphies de {0}",
        spellings: "Graphies",
        words: "Mots de reconnaissance",
        toInsurer: "Vers un autre assureur",
        toNewInsurer: "Vers un nouvel assureur",
        notInsurer: "Aucun assureur",
        release: "De nouveau ouvert (non identifié)",
        insurer: "Assureur",
        action: "Déplacer",
        done: "Déplacé",
        effectInsurer: "S’applique à tous les clients : dès la prochaine exécution nocturne, les projets avec ces graphies ne comptent plus pour {0}, mais pour {1}.",
        effectNotInsurer: "S’applique à tous les clients : dès la prochaine exécution nocturne, les projets avec ces graphies ne comptent plus pour {0}, mais comme « Aucun assureur ».",
        effectRelease: "S’applique à tous les clients : dès la prochaine exécution nocturne, les projets avec ces graphies ne comptent plus pour {0}, mais comme non identifiés. Ils n’apparaissent sous Assureurs non identifiés qu’après cette exécution.",
      },
      merge: {
        menu: "Fusionner",
        title: "Fusionner des assureurs",
        intro: "{0} ({1}) est fusionné dans un autre assureur.",
        into: "Fusionner dans",
        action: "Fusionner",
        done: "Fusionné",
        effect: "S’applique à tous les clients : {0} est retiré. Ses noms, clés, graphies et mots de reconnaissance appartiennent alors à {1}, et ses projets comptent pour {1} dès la prochaine exécution nocturne.",
      },
    },
    miraInsurerReview: {
      title: "Assureurs non identifiés",
      search: "Rechercher une graphie",
      loadedAt: "État : {0}",
      suggestionsAt: "Suggestions du {0}",
      loadFailed: "La liste n’a pas pu être chargée.",
      views: {
        OPEN: "Ouverts",
        SUGGESTED: "Avec suggestion",
        NOT_INSURER: "Aucun assureur",
      },
      headings: {
        OPEN: "Groupes",
        SUGGESTED: "Groupes avec suggestion",
        NOT_INSURER: "Aucun assureur",
      },
      hints: {
        OPEN: "Les noms que Mira n’a pas pu attribuer à un assureur lors de sa dernière exécution nocturne, regroupés, les plus grands d’abord. Une décision s’applique dans Mira dès la prochaine exécution.",
        SUGGESTED: "Groupes pour lesquels Mira a une suggestion. La coche ouvre la boîte de dialogue déjà remplie ; rien n’est enregistré avant son bouton. La croix écarte la suggestion.",
        NOT_INSURER: "Graphies décidées comme « Aucun assureur ». Dans Mira, elles ne comptent ni comme reconnues ni comme non identifiées.",
      },
      none: {
        OPEN: "Aucun groupe ouvert",
        SUGGESTED: "Aucune suggestion ouverte",
        NOT_INSURER: "Aucune graphie encore décidée comme « Aucun assureur »",
      },
      columns: {
        spellings: "Graphies",
        projects: "Projets",
        clients: "Clients",
      },
      moreSpellings: "{0} et {1} autres",
      droppedTexts: "{0} graphies peu utilisées ne tenaient pas dans la liste et manquent ici.",
      release: "Annuler",
      releaseConfirm: {
        title: "Annuler la décision",
        message: "« {0} » compte alors de nouveau comme non identifié dès la prochaine exécution de Mira.",
      },
      released: "Décision annulée",
      decided: "Décidé",
      decision: {
        title: "Attribuer le groupe",
        spellings: "Graphies",
        spellingWithCount: "{0} (un projet) | {0} ({1} projets)",
        toInsurer: "Attribuer à un assureur",
        toNewInsurer: "Attribuer à un nouvel assureur",
        notInsurer: "Aucun assureur (inconnu, courtier, banque, test …)",
        insurer: "Assureur",
        apply: "Attribuer",
        next: "Suivant",
        nextNewInsurer: "À l’étape suivante, tu crées l’assureur. Les graphies y sont déjà saisies.",
        effectInsurer: "S’applique à tous les clients : dès la prochaine exécution nocturne, les projets avec ces graphies comptent pour {0}.",
        effectNotInsurer: "S’applique à tous les clients : dès la prochaine exécution nocturne, les projets avec ces graphies comptent comme « Aucun assureur » et plus dans le taux d’attribution.",
      },
      suggestion: {
        insurer: "Suggestion : {0} ({1})",
        newInsurer: "Suggestion : nouvel assureur {0} ({1})",
        notInsurer: "Suggestion : Aucun assureur",
        unsure: "incertain",
        takeOver: "Reprendre",
        dismissAction: "Écarter",
        dismissed: "Suggestion écartée",
        dismiss: {
          title: "Écarter la suggestion",
          action: "Écarter",
          reason: "Motif",
        },
        errors: {
          NO_SUGGESTION: "Cette suggestion n’existe plus. La liste est rechargée.",
          CHANGED_MEANWHILE: "Les suggestions ont été réimportées entre-temps. La liste est rechargée.",
          INVALID_REASON: "Indique un motif.",
          FAILED: "L’écartement a échoué.",
        },
      },
    },
    clients: {
      title: "Clients",
      counts: {
        all: "Clients",
      },
      search: "Nom, abréviation ou numéro de client",
      masterClient: "Master",
      helperFunctions: {
        recalculateAllDryings: {
          button: "Recalculer tous les séchages",
          description: "Recalcule les prévisions ASSIST de tous les séchages de ce mandant avec le modèle le plus récent.",
          confirmTitle: "Recalculer tous les séchages ?",
          confirmMessage: "Les prévisions ASSIST de tous les séchages de ce mandant seront recalculées avec le modèle le plus récent. Cela peut prendre un moment.",
          confirmAccept: "Recalculer",
          started: "Le recalcul a été lancé.",
          alreadyRunning: "Un recalcul est déjà en cours.",
          noOp: "Aucun recalcul n’a été lancé (la fonction n’est peut-être pas activée pour ce mandant).",
          error: "Erreur lors du lancement du recalcul : {0}",
          failed: "Le recalcul n’a pas pu être lancé.",
          statusStarted: "Lancé",
          statusAlreadyRunning: "Déjà en cours",
          statusNoOp: "Rien à faire",
          refusals: {
            INVALID: "Le recalcul n’a pas pu être lancé.",
            NO_CLIENT: "Ce mandant n’existe plus.",
            DELETED_CLIENT: "Rien ne peut être recalculé pour un mandant supprimé.",
            SHARED_LOGIN: "Avec l’identifiant admin IRES partagé, rien ne peut être modifié. Connecte-toi avec ton propre utilisateur.",
            PERMISSION_DENIED: "Tu n’as pas l’autorisation de le faire.",
          },
        },
      },
      changes: {
        title: "Historique",
        loadFailed: "Impossible de charger l’historique.",
        none: "Rien n’a encore été modifié sur ce client dans l’IRES Admin Client.",
        showMore: "Afficher plus",
        followsGlobalTarget: "Version globale",
        everyProjectType: "Tous les types de projet des produits",
        filters: {
          CLIENT_LOGIN: "Connexions en tant que mandant",
        },
        groups: {
          INFO_CONFIG_TARGET: "Description",
          CLIENT_LOGIN: "Connecté en tant que mandant",
          CREATED: "Créé",
          SHARED_EMAIL_ADDRESS: "Adresse e-mail partagée nettoyée",
        },
        fields: {
          membersAdded: "Membres ajoutés",
          membersRemoved: "Membres retirés",
          serviceContractSince: "Contrat de service FW / config depuis",
          warrantyExtensionSince: "Extension de garantie panneaux depuis",
          allowedProjectTypeIds: "Types de projet (IRES)",
          activeProjectTypeIds: "Actifs chez le mandant",
          enabledFunctions: "Fonctions activées",
          sharedEmailAddress: "Adresse e-mail",
          sharedEmailAddressUsersRemoved: "Utilisateurs retirés",
          sharedEmailAddressDeleted: "Entrée supprimée",
        },
      },
      contracts: {
        editTitle: "Modifier les contrats",
        since: "Depuis",
        saved: "Contrats enregistrés.",
        saveFailed: "Impossible d’enregistrer les contrats.",
      },
      testSettings: {
        editTitle: "Modifier le test",
        saved: "Test enregistré.",
        saveFailed: "Impossible d’enregistrer le test.",
        usersLoadFailed: "Impossible de charger les utilisateurs.",
        errors: {
          UNKNOWN_TEST_USER: "Un utilisateur de test choisi n’est pas un utilisateur actif de ce mandant.",
        },
      },
      masterData: {
        clientName: "Nom",
        houseNumber: "Numéro",
        editTitle: "Modifier les données de base",
        projectNumberPrefixKept: "L’abréviation n’est qu’un libellé : les numéros de projet IRES de ce client commencent toujours par {0}.",
        iresTypeWarning: "Un client de type IRES a accès aux données de tous les clients. Ne change le type de client que si c’est voulu.",
        saved: "Données de base enregistrées.",
        fieldErrors: {
          required: "Obligatoire",
          tooLong: "100 caractères au maximum",
          prefixLength: "Exactement 4 caractères",
        },
        errors: {
          CHANGED_MEANWHILE: "Le client a été modifié entre-temps. Les données actuelles ont été rechargées, refais ta modification.",
          PREFIX_TAKEN: "Un autre client utilise déjà cette abréviation.",
          INVALID_VALUE: "Un champ n’est pas valide.",
          NO_CLIENT: "Ce client n’existe plus.",
          FAILED: "Impossible d’enregistrer les données de base.",
        },
      },
      group: {
        editTitle: "Modifier le groupe",
        hasMembersHint: "Un mandant MASTER avec des membres le reste jusqu’à ce que tu aies retiré tous les membres.",
        clientsLoadFailed: "Les mandants n’ont pas pu être chargés.",
        inactive: "(inactif)",
        deleted: "(supprimé)",
        thisClient: "ce mandant",
        overwriteTitle: "Écraser les paramètres ?",
        overwriteMessage: "Les paramètres de {0} remplacent tous les paramètres de ce mandant MASTER.",
        overwriteAccept: "Écraser",
        saved: "Groupe enregistré.",
        saveFailed: "Le groupe n’a pas pu être enregistré.",
        migrateSharedUsers: "Migrer les utilisateurs partagés",
        migrateSharedUsersMessage: "Les adresses e-mail partagées du groupe deviennent des utilisateurs partagés du groupe. Cette action est irréversible.",
        migrateSharedUsersAccept: "Migrer",
        migratedSharedUsers: "{0} utilisateurs partagés migrés.",
        noSharedUsersToMigrate: "Tous les utilisateurs partagés sont déjà migrés, ou il n’y en a aucun.",
        migrateSharedUsersFailed: "Les utilisateurs partagés n’ont pas pu être migrés.",
        refusals: {
          INVALID: "Le groupe n’a pas pu être enregistré.",
          NO_CLIENT: "Ce mandant n’existe plus.",
          DELETED_CLIENT: "Le groupe d’un mandant supprimé ne peut pas être modifié.",
          CHANGED_MEANWHILE: "Le groupe a été modifié entre-temps. La vue a été rechargée.",
          IS_MEMBER: "Un membre d’un groupe ne peut pas devenir mandant MASTER.",
          HAS_MEMBERS: "Retire d’abord tous les membres.",
          NOT_A_CANDIDATE: "Ces mandants ne peuvent pas devenir membres : {0}",
          NOT_A_MEMBER: "Les paramètres ne peuvent être repris que d’un membre.",
          DUPLICATE_BRANCH_NUMBERS: "Le numéro de succursale {0} est utilisé par {1} et par {2}.",
          SHARED_LOGIN: "Rien ne peut être modifié avec la connexion IRES Admin partagée. Connecte-toi avec ton propre utilisateur.",
        },
      },
      products: {
        editTitle: "Modifier les produits",
        saved: "Produits enregistrés.",
        saveFailed: "Les produits n’ont pas pu être enregistrés.",
        saveWarning: "En enregistrant, le choix de produit (ancien) que lisent IRES Project, IRES Work et IRES Office est mis à jour, et les licences sont recalculées.",
        derivedCaption: "Encore déduit du choix de produit et pas encore enregistré.",
        choices: {
          DEVICES_ONLY_WEBSITE: "Portail appareils",
          WEBSITE: "Portail projets",
          DEFAULT: "Manager de projet",
          PROJECT_OPTION: "Option de projet",
        },
        explanations: {
          officeDeviceAssignment: "Projets GZ et GL dans IRES Office. IRES Office lui-même est toujours disponible.",
          project: "Gestion de projet avec IRES Project.",
          work: "Gestion des appareils dans l’application IRES Work. Sans IRES Work, personne chez le client ne peut se connecter à IRES Work.",
          interface: "Interface REST vers un système externe.",
        },
        errors: {
          CHANGED_MEANWHILE: "Les produits ont été modifiés entre-temps. La vue a été rechargée.",
          INVALID_CLIENT: "Ce mandant ne peut pas avoir de produits.",
          INVALID: "Sélection de produit invalide.",
          NO_CLIENT: "Ce mandant n’existe plus.",
          DELETED_CLIENT: "Les produits d’un mandant supprimé ne peuvent pas être modifiés.",
          SHARED_LOGIN: "Avec le login admin IRES partagé, rien ne peut être modifié. Connecte-toi avec ton propre utilisateur.",
          FAILED: "Les produits n’ont pas pu être enregistrés.",
        },
      },
      projectTypes: {
        editTitle: "Modifier les types de projet",
        explanation: "Les types de projet de ses produits que le mandant reçoit. Les types décochés ne sont plus proposés par IRES Office, IRES Project, IRES Work ni par les interfaces.",
        notRestricted: "Sans restriction : le mandant reçoit tous les types de projet de ses produits.",
        followsMaster: "Défini chez le mandant MASTER",
        activeInClientTable: "actif chez le mandant",
        inactiveInClientTable: "inactif chez le mandant",
        atLeastOne: "Choisis au moins un type de projet.",
        withdrawWarning: "À l’enregistrement, chaque type de projet décoché est désactivé dans les types de projet possibles du mandant, afin qu’aucune application ne le propose plus. Les projets existants restent tels quels.",
        withdrawWarningMaster: "Cela vaut aussi pour les membres qui utilisent les réglages de projet de ce mandant MASTER.",
        allowNote: "Le mandant peut ensuite activer un nouveau type de projet dans Réglages déroulement du projet.",
        saved: "Types de projet enregistrés.",
        errors: {
          CHANGED_MEANWHILE: "Les types de projet ont été modifiés entre-temps. La vue a été rechargée.",
          INVALID_CLIENT: "Ce mandant ne peut pas avoir de types de projet.",
          INVALID: "Choix de types de projet non valide.",
          EMPTY: "Choisis au moins un type de projet.",
          NO_CLIENT: "Ce mandant n’existe plus.",
          DELETED_CLIENT: "Les types de projet d’un mandant supprimé ne peuvent pas être modifiés.",
          FOLLOWS_MASTER: "Ce mandant utilise les réglages de projet de son mandant MASTER. Modifie les types de projet là-bas.",
          SHARED_LOGIN: "Avec le login admin IRES partagé, rien ne peut être modifié. Connecte-toi avec ton propre utilisateur.",
          FAILED: "Les types de projet n’ont pas pu être enregistrés.",
        },
      },
      projectOrganisation: {
        editTitle: "Modifier l’organisation des projets",
        followsMaster: "Défini chez le mandant MASTER",
        notStored: "Non enregistrée : les applications utilisent leur réglage par défaut, tel qu’affiché ici.",
        reachNote: "S’applique après l’enregistrement dans IRES Office, IRES Project, IRES Work et l’interface.",
        reachNoteMaster: "Cela vaut aussi pour les membres qui utilisent les réglages de projet de ce mandant MASTER.",
        saved: "Organisation des projets enregistrée.",
        errors: {
          CHANGED_MEANWHILE: "L’organisation des projets a été modifiée entre-temps. La vue a été rechargée.",
          INVALID_CLIENT: "Ce mandant ne peut pas avoir d’organisation des projets.",
          INVALID: "Choix non valide. Les rendez-vous et la clôture du projet nécessitent au moins une application.",
          NO_CLIENT: "Ce mandant n’existe plus.",
          DELETED_CLIENT: "L’organisation des projets d’un mandant supprimé ne peut pas être modifiée.",
          FOLLOWS_MASTER: "Ce mandant utilise les réglages de projet de son mandant MASTER. Modifie l’organisation des projets là-bas.",
          NO_PROJECTS: "Les produits de ce mandant ne comprennent aucun projet.",
          SHARED_LOGIN: "Avec le login admin IRES partagé, rien ne peut être modifié. Connecte-toi avec ton propre utilisateur.",
          FAILED: "L’organisation des projets n’a pas pu être enregistrée.",
        },
      },
      systemConfiguration: {
        editTitle: "Modifier la configuration système",
        followsMaster: "Défini chez le mandant MASTER",
        notStored: "Non enregistrée : IRES Office utilise les anciens réglages du mandant, tels qu’affichés ici.",
        reachNote: "S’applique à tous les utilisateurs de ce mandant après l’enregistrement.",
        reachNoteMaster: "Cela vaut aussi pour les membres qui utilisent la configuration système de ce mandant MASTER.",
        saved: "Configuration système enregistrée.",
        assistScope: "Portée ASSIST",
        effectsFailed: "Enregistré, mais ce que la modification déclenche (véhicules, géocodage des adresses, ASSIST) a échoué. Signale-le, s’il te plaît.",
        errors: {
          CHANGED_MEANWHILE: "La configuration système a été modifiée entre-temps. La vue a été rechargée.",
          INVALID_CLIENT: "Ce mandant ne peut pas avoir de configuration système.",
          INVALID: "Choix non valide. « Suivi » nécessite « Carte », « Afficher gestion des appareils dans cockpit » nécessite « Gérer tous les appareils ».",
          NO_CLIENT: "Ce mandant n’existe plus.",
          DELETED_CLIENT: "La configuration système d’un mandant supprimé ne peut pas être modifiée.",
          FOLLOWS_MASTER: "Ce mandant utilise la configuration système de son mandant MASTER. Modifie-la là-bas.",
          SHARED_LOGIN: "Avec le login admin IRES partagé, rien ne peut être modifié. Connecte-toi avec ton propre utilisateur.",
          FAILED: "La configuration système n’a pas pu être enregistrée.",
        },
      },
      setup: {
        title: "Nouveau mandant",
        loadFailed: "La configuration n’a pas pu être chargée.",
        externalSystems: {
          explanation: "Avec l’API, le mandant peut recevoir tout de suite un système externe, par exemple son ERP. Il ne reçoit rien tant qu’IRES ne l’active pas et démarre en mise en place. Son mot de passe s’affiche une fois après la création. Les contacts et d’autres systèmes s’ajoutent ensuite sur la page du système.",
          create: "Créer un système externe",
          memberExplanation: "Un membre utilise les systèmes externes de son mandant MASTER. Un système coché atteint ensuite les projets de ce mandant.",
          masterHasNone: "Le mandant MASTER n’a aucun système externe.",
          system: "Système externe",
          linked: "Systèmes liés",
          none: "Aucun",
          sameAsClient: "Le système a besoin de sa propre adresse, pas de celle du mandant.",
        },
        steps: {
          masterData: "Mandant",
          products: "Produits",
          projectTypes: "Types de projet",
          projectOrganisation: "Organisation des projets",
          functions: "Fonctions",
          licences: "Licences",
          contracts: "Contrats et appareils",
          users: "Utilisateurs",
          externalSystems: "Systèmes externes",
          summary: "Récapitulatif",
        },
        next: "Suivant",
        create: "Créer",
        change: "Modifier",
        created: "Mandant créé.",
        createWarning: "CRÉER configure le mandant avec tout ce qui est affiché ici. Il peut se connecter aussitôt.",
        signInEmail: "Adresse e-mail (connexion)",
        signInPassword: "Mot de passe (connexion)",
        passwordTooShort: "Au moins {0} caractères",
        address: "Adresse",
        followsMaster: "comme le mandant MASTER",
        followsMasterExplanation: "En tant que membre, le mandant utilise les paramètres de son mandant MASTER {0}.",
        noProjects: "Sans IRES Project, IRES Work ni IRES Office (GZ / GL), il n’y a rien à définir ici.",
        organisationRequired: "Choisis au moins une application.",
        group: {
          kinds: {
            STANDALONE: "Autonome",
            MEMBER: "Membre d’un mandant MASTER",
            MASTER: "Nouveau mandant MASTER",
          },
          master: "Mandant MASTER",
          masterRequired: "Choisis le mandant MASTER.",
          memberHint: "Un membre reprend les types de projet, l’organisation des projets, les fonctions, les contrats et les appareils de son mandant MASTER. Ses licences sont les siennes.",
          memberOf: "Membre de {0}",
        },
        products: {
          officeAlways: "IRES Office avec la gestion des appareils HyDry est toujours inclus.",
          officeOnly: "IRES Office seul (appareils HyDry)",
        },
        functions: {
          enabled: "Activées",
          personalChat: "Chat personnel",
          projectChat: "Chat de projet",
        },
        licences: {
          explanation: "Les licences achetées pour les produits choisis. Tu les modifies plus tard dans IRES Admin.",
          noneNeeded: "Les produits choisis n’ont besoin d’aucune licence.",
          invalid: "Un nombre entier de 0 à {0}",
        },
        contracts: {
          devices: "Appareils",
          updateFirmwareViaIot: "Mise à jour du firmware IPU E-G via IOT",
          updateConfigViaIot: "Mise à jour de la config via IOT",
          conditions: {
            ALWAYS: "Toujours",
            NEVER: "Jamais",
            WHEN_IDLE_OR_AFTER_POWER_ON: "Panel inactif / démarré",
          },
          yesSince: "Oui, depuis le {0}",
          followsFleet: "comme la flotte",
          followsFleetExplanation: "Le mandant suit les versions cibles de la flotte. Tu définis ses propres versions cibles plus tard dans IRES Admin.",
        },
        users: {
          iresAdminExplanation: "L’utilisateur admin IRES est toujours créé : « Se connecter en tant que mandant » ouvre le mandant avec lui.",
          createFirstUser: "Créer le premier utilisateur du mandant",
          role: "Rôle : {0}",
          iresAdmin: "Utilisateur admin IRES",
          iresAdminAlways: "Créé",
          firstUser: "Premier utilisateur",
          noFirstUser: "Aucun, plus tard sous Utilisateurs",
        },
        errors: {
          INVALID: "Une saisie n’est pas valide. Vérifie les étapes.",
          NOT_A_MASTER: "Le mandant choisi n’est pas (ou plus) un mandant MASTER.",
          PROJECT_TYPES_EMPTY: "Choisis au moins un type de projet.",
          TRACKING_WITHOUT_MAP: "Le suivi nécessite la carte.",
          TILE_WITHOUT_ALL_DEVICES: "Afficher la gestion des appareils dans le cockpit nécessite Gérer tous les appareils.",
          NICKNAME_TAKEN: "Ce nom court existe déjà.",
          STAFF_NUMBER_TAKEN: "Ce matricule existe déjà.",
          PREFIX_TAKEN: "Un autre mandant a déjà cette abréviation.",
          EMAIL_TAKEN: "Un autre mandant se connecte déjà avec cette adresse e-mail.",
          USER_EMAIL_TAKEN: "Un autre utilisateur a déjà cette adresse e-mail.",
          IRES_ADMIN_EMAIL_TAKEN: "Aucune adresse n’est libre pour l’utilisateur admin IRES avec cette abréviation. Choisis-en une autre.",
          EXTERNAL_SYSTEM_EMAIL_TAKEN: "Un compte utilise déjà cette adresse. Choisis-en une autre pour le système externe.",
          NOT_THE_MASTERS_SYSTEM: "Un système choisi n’appartient plus au mandant MASTER. Choisis à nouveau les systèmes.",
          SHARED_LOGIN: "L’identifiant admin IRES partagé ne peut rien modifier. Connecte-toi avec ton propre utilisateur.",
          FAILED: "Le mandant n’a pas pu être créé.",
        },
      },
      partners: {
        title: "Systèmes externes",
        loadFailed: "Les systèmes externes n’ont pas pu être chargés.",
        none: "Aucun système externe connecté.",
        viaMaster: "via le mandant MASTER",
        editOnOwner: "Ce système externe appartient au mandant MASTER et se modifie là-bas.",
        partner: "Système externe",
        saved: "Enregistré.",
        noAddress: "Aucune (IRES n’envoie rien)",
        defaultEndpoint: "Par défaut : {0}",
        endpointLabel: "{0} (vide : {1})",
        byRoute: "Seulement pour les appels via EasyTec",
        statuses: {
          SETUP: "Mise en place",
          TEST: "Test",
          LIVE: "Live",
          PAUSED: "En pause",
        },
        statusDescriptions: {
          SETUP: "La connexion est en cours de mise en place.",
          TEST: "La connexion est testée avec le système.",
          LIVE: "Les projets sont échangés avec le système.",
          PAUSED: "IRES n’envoie rien au système ; ce qui arrive part à la reprise. Le système peut toujours appeler IRES.",
        },
        systems: {
          EASY_TEC: "Liste complète des étapes (EasyTec)",
          EXTERNAL: "Une étape à la fois (API IRES)",
          NONE: "Aucun (entrant uniquement)",
        },
        signIn: {
          API_KEY: "Clé API",
          SIGN_IN: "Adresse e-mail et mot de passe",
          EASY_TEC: "Connexion EasyTec (mandant et mot de passe)",
          NONE: "Aucune (IRES n’envoie rien)",
        },
        fields: {
          integrationStatus: "Statut",
          baseUrl: "URL de base",
          signIn: "IRES se connecte avec",
          system: "Transfert des étapes",
        },
        endpoints: {
          createProject: "Nouveau projet",
          projectData: "Données du projet",
          projectStatus: "Statut",
          noteUpdate: "Notes",
        },
        accepts: {
          acceptsNewProjects: "Nouveaux projets",
          acceptsProjectDataUpdates: "Données du projet",
          acceptsProjectStatusUpdates: "Statut",
          acceptsNotes: "Notes",
          includeProjectOwnersInfo: "Responsables du projet",
          sendsExtraPhaseData: "Données supplémentaires des phases",
        },
        behaviour: {
          appointmentFieldSwap: "Appliquer la correspondance rendez-vous / commencé",
          incomingContactPerson0: "Imposer le contact 0",
          sendsLatestProjectStatus: "Envoyer le dernier statut du projet",
          isTestSystem: "Système de test (numéros de projet échangés)",
        },
        cards: {
          status: "Statut",
          connection: "Connexion",
          accepts: "Ce que {0} reçoit",
          behaviour: "Comportement",
        },
        changeGroups: {
          created: "Système externe créé",
          password: "Nouveau mot de passe",
          accepts: "Ce que le système reçoit",
          credentials: "Données de connexion",
        },
        contacts: {
          title: "Contacts",
          none: "Aucun contact pour l’instant.",
          name: "Nom",
          role: "Rôle",
          email: "Adresse e-mail",
          phone: "Téléphone",
          add: "Ajouter un contact",
          remove: "Retirer le contact",
          roles: {
            TECHNICAL: "Technique",
            BUSINESS: "Métier",
          },
          invalid: {
            email: "Adresse e-mail non valide.",
            phone: "Uniquement des chiffres, des espaces et + ( ) / - .",
          },
        },
        goLive: {
          title: "Mise en service",
          description: "Vérifié automatiquement à l’ouverture. Rien de cela ne bloque le passage en Live.",
          checks: {
            CONTACT: "Contact enregistré",
            SIGNED_IN: "Connecté à IRES",
            CONNECTION: "Connexion complète (URL de base et identifiants)",
            PROJECT: "Premier projet échangé",
          },
          lastSignIn: "{0}, dernière fois le {1}",
          openWarning: "Encore ouvert pour la mise en service : {0}. Live peut quand même être choisi.",
        },
        packages: {
          title: "Paquets",
          description: "Ce que tu remets au partenaire pour la connexion : la description de l’API REST IRES réduite à ses points d’accès, en YAML et en page pour le navigateur, et un aperçu des échanges en PDF. Chaque paquet est enregistré avec la date, l’auteur, la version et le destinataire.",
          none: "Aucun paquet créé pour l’instant.",
          notAvailable: "Les systèmes EasyTec n’ont pas encore de paquets : ils utilisent leur propre interface.",
          loadFailed: "Les paquets n’ont pas pu être chargés.",
          create: "Nouveau paquet",
          createTitle: "Nouveau paquet pour {0}",
          createButton: "Créer",
          created: "Paquet créé.",
          changeGroup: "Paquet créé",
          version: "API {0}",
          by: "par {0}",
          for: "pour {0}",
          apiVersion: "Version de l’API",
          groups: "Points d’accès",
          recipient: "Destinataire",
          otherRecipient: "Autre personne",
          recipientName: "Nom",
          recipientEmail: "Adresse e-mail (facultative)",
          noCredentials: "Il ne contient jamais d’identifiants : tu remets le mot de passe du système séparément.",
          describes: "Le paquet décrit l’API REST IRES {0}.",
          groupNames: {
            SIGN_IN: "Connexion",
            PROJECTS: "Projets",
            STATUS: "Statut et étapes",
            NOTES: "Notes",
            REPORTS: "Rapports",
            DEVICES: "Appareils et attributions",
            DEVICE_CATEGORIES: "Catégories et types d’appareils",
            USERS: "Utilisateurs et rôles",
          },
          states: {
            CURRENT: "À jour",
            OUTDATED: "Obsolète",
            SUPERSEDED: "Remplacé",
            UNCHECKED: "Non vérifiable",
          },
          unchecked: "La description du paquet n’a pas pu être lue, donc on ne sait pas si l’API a changé.",
          operations: {
            added: "Nouveaux points d’accès : {0}",
            removed: "Points d’accès supprimés : {0}",
            changed: "Points d’accès modifiés : {0}",
          },
          general: "Modifié : {0}",
          generalParts: {
            SERVERS: "URL de base de l’API",
            SECURITY: "Connexion à l’API",
          },
          settingsNotChecked: "Les paramètres ne sont pas vérifiés : le paquet est plus ancien que cette vérification.",
          changelogLine: "API {0} : {1}",
          notSent: "non envoyé",
          settingNames: {
            name: "Nom",
            accessEmail: "Adresse de connexion du système",
            ownerIsGroup: "Groupe de clients (regionId)",
            sends: "IRES envoie au système",
          },
          files: {
            yaml: "Télécharger la description (YAML)",
            html: "Télécharger la description (HTML)",
            overview: "Télécharger l’aperçu (PDF)",
          },
        },
        editTitles: {
          PARTNER_STATUS: "Modifier le statut",
          PARTNER_CONNECTION: "Modifier la connexion",
          PARTNER_ACCEPTS: "Modifier ce que {0} reçoit",
          PARTNER_BEHAVIOUR: "Modifier le comportement",
          PARTNER_CREDENTIALS: "Modifier les données de connexion",
          PARTNER_CONTACTS: "Modifier les contacts",
        },
        warnings: {
          pause: "IRES n’envoie plus rien à ce système jusqu’à ce que tu le reprennes. Il peut toujours appeler IRES.",
          resume: "À la reprise, IRES envoie tout ce qui a attendu pendant la pause.",
          swapOff: "Sans la correspondance, le rendez-vous et le début partent séparément au système. Chaque étape de rendez-vous d’un projet ouvert est renvoyée à sa prochaine modification. Mets-toi d’accord avec son exploitant avant.",
          noStatus: "Le système ne reçoit alors plus de changements de statut.",
        },
        fieldErrors: {
          baseUrl: "Une URL commençant par https:// ou http://",
          endpoint: "Seulement des lettres, des chiffres et _ - . ~ /",
        },
        credentials: {
          button: "Modifier les données de connexion",
          apiKey: "Clé API",
          password: "Mot de passe",
          email: "Adresse e-mail",
          clientId: "Mandant (EasyTec)",
          authUrl: "Adresse de connexion",
          tokenUrl: "Adresse du jeton",
          set: "défini",
          missing: "manquant",
          secretSetLabel: "{0} (défini ; laisse vide pour garder)",
          secretMissingLabel: "{0} (manquant)",
          saved: "Données de connexion enregistrées.",
          replaced: "remplacé",
        },
        errors: {
          NOT_AVAILABLE: "Les systèmes EasyTec n’ont pas encore de paquets.",
          NO_PACKAGE: "Ce paquet n’existe pas.",
          NOT_A_MEMBER: "Seuls les membres du groupe du propriétaire peuvent être liés.",
          NO_CHANGES: "Rien n’a changé.",
          EMAIL_TAKEN: "Quelqu’un se connecte déjà avec cette adresse.",
          MEMBER_CLIENT: "Un membre utilise les systèmes externes de son mandant MASTER.",
          CHANGED_MEANWHILE: "Quelqu’un a modifié cela entre-temps. La page a été rechargée.",
          NOT_EDITABLE_HERE: "Ce système externe se modifie sur le mandant MASTER.",
          NEEDS_ERP_SIMULATOR: "Système de test seulement pour un mandant avec le simulateur ERP.",
          NO_PARTNER: "Ce système externe n’existe pas pour ce mandant.",
          INVALID: "Une saisie n’est pas valide.",
          SHARED_LOGIN: "Rien ne peut être modifié avec la connexion IRES-Admin partagée. Connecte-toi avec ton propre utilisateur.",
          FAILED: "Le système externe n’a pas pu être enregistré.",
        },
        access: {
          title: "Accès",
          description: "Le système se connecte à IRES avec cette adresse et son mot de passe. Le mot de passe n’est affiché qu’une fois, à la création et avec Nouveau mot de passe.",
          email: "Connexion du système à IRES",
          password: "Mot de passe",
          newPassword: "Nouveau mot de passe",
          newPasswordTitle: "Générer un nouveau mot de passe",
          newPasswordMessage: "Le mot de passe actuel de {0} cesse de fonctionner tout de suite. Le système ne peut se reconnecter qu’une fois qu’il a le nouveau.",
          passwordTitle: "Mot de passe pour {0}",
          onceWarning: "Le mot de passe n’est affiché que maintenant et n’est enregistré nulle part. Copie-le et transmets-le à l’exploitant du système.",
          copy: "Copier",
          copied: "Mot de passe copié.",
          copyFailed: "La copie n’a pas fonctionné. Sélectionne le mot de passe et copie-le à la main.",
          done: "Terminé",
        },
        create: {
          open: "Nouveau",
          title: "Nouveau système externe",
          name: "Nom",
          baseUrlOptional: "URL de base (facultative, aussi plus tard)",
          button: "Créer",
          created: "Système externe créé.",
          emailInvalid: "Une adresse e-mail, p. ex. prefixe-systeme@ires.de",
        },
        links: {
          title: "Mandants liés",
          description: "Le système atteint ces mandants : il peut créer et modifier leurs projets, et leurs nouveaux projets sont échangés avec lui. Tu lies ici les membres du groupe.",
          none: "Aucun mandant lié.",
          owner: "Propriétaire",
          link: "Lier",
          linkTitle: "Lier un mandant à {0}",
          member: "Mandant",
          linkWarning: "{0} peut alors créer et modifier les projets de ce mandant, et les nouveaux projets du mandant sont échangés avec {0}.",
          linked: "Lié.",
          unlink: "Supprimer le lien",
          unlinkTitle: "Supprimer le lien",
          unlinkMessage: "{1} ne peut plus atteindre {0} : ses appels pour ce mandant sont refusés.",
          unlinked: "Lien supprimé.",
          linkedClient: "Mandant lié",
        },
      },
      clientLogin: {
        button: "Se connecter en tant que mandant",
        noTab: "Le nouvel onglet n’a pas répondu. Autorise les fenêtres pop-up pour IRES Office et réessaie.",
        failed: "Le mandant n’a pas pu être ouvert.",
        refusals: {
          SHARED_LOGIN: "Un mandant ne peut pas être ouvert avec la connexion IRES Admin partagée. Connecte-toi avec ton propre utilisateur.",
          NO_CLIENT: "Ce mandant n’existe plus.",
          PORTAL_CLIENT: "Le mandant propre à IRES Admin Client ne peut pas être ouvert ainsi.",
          ADMIN_APP_CLIENT: "Les comptes de l’application IRES Admin ne peuvent pas être ouverts ainsi.",
          NO_IRES_ADMIN_USER: "Ce mandant n’a pas d’utilisateur administrateur IRES.",
        },
      },
      status: {
        blocked: {
          title: "Modifier le verrouillage",
          no: "Non verrouillé",
          yes: "Verrouillé",
          consequence: "Plus personne ne peut se connecter à ce client, sauf le compte administrateur IRES. Les appareils et les connexions ERP continuent de fonctionner.",
          saved: "Verrouillage enregistré.",
        },
        active: {
          title: "Modifier actif / inactif",
          yes: "Actif",
          no: "Inactif",
          consequence: "Les utilisateurs ne peuvent plus se connecter avec leur adresse e-mail, et le client disparaît des listes de son groupe.",
          unmet: "Le client ne peut pas encore être mis inactif :",
          saved: "Enregistré.",
        },
        delete: {
          title: "Supprimer le client",
          consequence: "Le client disparaît de toutes les listes, et plus personne ne peut se connecter. Toutes les données sont conservées ; la restauration annule la suppression.",
          unmet: "Le client ne peut pas encore être supprimé :",
          saved: "Client supprimé.",
        },
        restore: {
          title: "Restaurer le client",
          message: "Le client réapparaît dans les listes, et la connexion fonctionne à nouveau, sauf s’il est verrouillé.",
          button: "Restaurer",
          saved: "Client restauré.",
        },
        deleteReason: "Motif",
        deleteReasons: {
          CUSTOMER_LEFT: "Client parti",
          DUPLICATE: "Doublon",
          TEST_ACCOUNT: "Compte de test",
          OTHER: "Autre",
        },
        note: "Remarque (facultative)",
        noteRequired: "Remarque",
        noteTooLong: "200 caractères au maximum",
        conditions: {
          DEVICES_ASSIGNED: "Des appareils sont encore attribués.",
          RUNNING_PROJECTS: "Des projets sont encore en cours.",
          SHARED_USERS_AT_HOME: "Des utilisateurs partagés du groupe ont ce mandant comme mandant d’origine.",
          MASTER_WITH_MEMBERS: "Le client est le master d’un groupe avec des membres.",
          ERP_CONNECTED: "Une connexion ERP est active.",
        },
        changedMeanwhile: "Le statut a été modifié entre-temps. La vue a été rechargée.",
        saveFailed: "Le statut n’a pas pu être enregistré.",
      },
      liveOperation: {
        live: "En exploitation",
        notLive: "Hors exploitation",
        notLiveWithReason: "Hors exploitation ({0})",
        reasons: {
          TEST: "Test",
          DEMO: "Démo",
          WAREHOUSE: "Entrepôt",
        },
        reason: "Motif",
        change: "modifier",
        changedAt: "modifié le {0}",
        changedAtBy: "modifié le {0} par {1}",
        editTitle: "Modifier l’exploitation",
        consequence: "À partir de la nuit prochaine, Mira exclut les clients hors exploitation de tous les chiffres et comparaisons. Remis en exploitation, ils comptent de nouveau dès lors.",
        saved: "Exploitation enregistrée.",
        saveFailed: "Impossible d’enregistrer l’exploitation.",
      },
      miraAllClients: {
        on: "Oui : Mira affiche tous les clients additionnés",
        off: "Non",
        editTitle: "Modifier Mira : tous les clients",
        consequence: "Dès la nuit prochaine, Mira affiche alors les chiffres de tous les clients additionnés. Chaque utilisateur de ce client les voit.",
        savedOn: "Mira affiche tous les clients dès la nuit prochaine.",
        savedOff: "Mira n’affiche plus les chiffres de tous les clients.",
        saveFailed: "Le réglage n’a pas pu être enregistré.",
        notIresAccount: "Seul un client IRES peut afficher tous les clients.",
      },
      columns: {
        name: "Nom",
        currentProjects: "En cours",
        oldProjects: "Anciens",
        deletedProjects: "Supprimés",
        reports: "Rapports",
        panels: "Panels",
        comBoxes: "Box",
        minis: "Minis",
        number: "Numéro",
        shorthand: "Abrév.",
        users: "Utilisateurs",
      },
      // The Mandanten list's sort (2026-11-02): the name, or a figure, either way round.
      sorts: {
        NAME: "Nom",
        numProjects: "Projets en cours",
        numOldProjects: "Anciens projets",
        numDeletedProjects: "Projets supprimés",
        numReports: "Rapports",
        numCurrentPanels: "Panels",
        numCurrentComBoxes: "Box",
        numCurrentMinis: "Minis",
        numUsers: "Utilisateurs",
      },
      sortedBy: {
        mostFirst: "Tri : {0}, le plus grand nombre en premier",
        fewestFirst: "Tri : {0}, le plus petit nombre en premier",
        nameDescending: "Tri : nom, de Z à A",
      },
      columnGroups: {
        projects: "Projets",
        devices: "Appareils",
      },
      filters: {
        ALL: "Tous",
        IRES: "IRES",
        CLIENT: "Clients utilisateurs",
        SERVICE_CONTRACT: "Contrat de service",
        CONTRACT_PURCHASE: "Achat",
        CONTRACT_PERMANENT_RENT: "Location permanente",
        CONTRACT_TESTING: "Phase de test",
        HAS_APP: "A une app",
        MASTER: "Master",
        LIVE: "En exploitation",
        NOT_LIVE: "Hors exploitation",
        BLOCKED: "Verrouillé",
        DELETED: "Supprimés",
        ACTIVE: "Actifs",
        INACTIVE: "Inactifs",
      },
      filterGroups: {
        TYPE: "Type",
        CONTRACT: "Contrat",
        APP: "App",
        GROUP: "Groupe",
        OPERATION: "Exploitation",
        ACCESS: "Accès",
        STATUS: "Statut",
      },
      serviceContractSince: "depuis le {0}",
      noneMatching: "Aucun client ne correspond à la recherche et au filtre.",
      loadFailed: "Impossible de charger les clients.",
      figuresUpdatedAt: "État au {0}",
      detail: {
        loadFailed: "Impossible de charger le client.",
        notFound: "Ce client n’existe pas (ou plus).",
        licences: {
          title: "Licences",
          modelV2: "Modèle de licence 2 · limites",
          modelV3: "Modèle de licence 3 · utilisées sur achetées",
          exceeded: "Plus de licences sont utilisées qu’achetées.",
        },
        devices: {
          title: "Appareils",
          loadFailed: "Impossible de charger le nombre d’appareils.",
          hint: "Les panels sans affectation ouverte comptent comme anciens. Les totaux des panels ne comprennent que HyDry Panel, HyDry Slim et HyDry Edge.",
          columns: {
            type: "Affectation",
            panels: "Panels",
            comBoxes: "Box",
            minis: "Minis",
          },
          assignmentTypes: {
            SOLD: "Achat",
            PERMANENT_RENT: "Location permanente",
            DAILY_RENT: "Location journalière",
            CONSIGNMENT_STOCK: "Stock en consignation",
            TESTING: "Test",
            OTHER: "Autre",
            AVAILABLE: "Disponible",
          },
          former: "Anciens panels",
          total: "Total",
        },
        sections: {
          masterData: "Données de base",
          products: "Produits",
          projectTypes: "Types de projet",
          projectOrganisation: "Organisation des projets",
          systemConfiguration: "Configuration système",
          group: "Groupe",
          contracts: "Contrats",
          targetVersions: "Versions cibles",
          testSettings: "Test",
          status: "Statut",
          helperFunctions: "Fonctions auxiliaires",
        },
        fields: {
          isMaster: "Mandant MASTER",
          groupMembers: "Membres",
          settingsSource: "Paramètres repris de",
          masterClient: "Membre de",
          clientNumber: "Numéro de client",
          companyName: "Entreprise",
          zip: "Code postal",
          city: "Ville",
          street: "Rue",
          clientType: "Type de client",
          email: "Adresse e-mail",
          clientShorthand: "Abréviation du client",
          officeDeviceAssignment: "IRES Office (GZ / GL)",
          project: "IRES Project",
          work: "IRES Work",
          interface: "API",
          productChoice: "Choix de produit (ancien)",
          contracts: "Contrats",
          warrantyExtensionForPanels: "Extension de garantie panneaux",
          serviceContract: "Contrat de service FW / config",
          hasApp: "A une app",
          blocked: "Bloqué",
          isActive: "Actif",
          deleted: "Supprimé",
          liveOperation: "Exploitation",
          miraAllClients: "Mira : tous les clients",
          isTestSystem: "Simulateur ERP",
          testAppVersion: "Version d’app cible de test",
          testRoomInfoConfigVersion: "Version de description cible de test",
          testUsers: "Utilisateurs de test",
          numUsers: "Utilisateurs",
          numProjects: "Projets",
          numArchivedProjects: "Anciens projets",
          numDeletedProjects: "Projets supprimés",
          figuresUpdatedAt: "État des chiffres",
          numReports: "Rapports",
        },
        clientTypes: {
          IRES: "IRES",
          CLIENT: "Client",
          OTHER: "Autre",
        },
        contractTypes: {
          PURCHASE: "Achat",
          PERMANENT_RENT: "Location permanente",
          TESTING: "Phase de test",
        },
        testSettings: {
          unknownUser: "Utilisateur inconnu",
          inactiveUser: "(supprimé)",
          reachesNobody: "Le test n’atteint personne tant qu’aucun utilisateur de test n’est choisi.",
        },
        targetVersions: {
          targetFirmwareName: "Firmware cible A, B, C",
          targetIotFirmwareName: "Firmware cible D+",
          targetConfigName: "Configuration cible",
          targetAppApk: "Version de l’app",
          targetLeakDetectionInfoConfigVersion: "Détection de fuites",
          targetRoomInfoConfigVersion: "Séchage",
          targetHtmlTipsAndTricksFile: "Conseils et astuces",
          targetHtmlHistoryFile: "Historique des versions",
        },
      },
    },
    cockpit: {
      contractsAndApp: "Contrats et app",
      tasks: "Tâches",
      totalsTitle: "Totaux",
      totalsScope: "Clients en exploitation réelle",
      totals: {
        projects: "Projets",
        oldProjects: "Anciens projets",
      },
      exceptionSuggestions: "Suggestions d’exceptions Mira",
      externalSystemsInStatus: "Systèmes externes : {0}",
      waitingDeviceReports: "Rapports de test non attribués",
      ownTargets: "Clients avec leur propre cible",
      testTargets: "Clients avec une cible de test",
      loadFailed: "Tous les chiffres n’ont pas pu être chargés.",
    },
    clientSensorDataExport: {
      title: "Export des données de capteurs",
      description: "Les données de capteurs enregistrées des Box et panels HyDry sélectionnés dans un fichier Excel, une feuille par appareil. Un appareil ne fournit que les cycles pendant lesquels il était attribué à ce client.",
      startDate: "Date de début",
      endDate: "Date de fin",
      selected: "{0} sélectionné(s)",
      selectAll: "Tout sélectionner",
      selectNone: "Effacer la sélection",
      none: "Ce client n’a ni Box ni panels HyDry.",
      progress: "{0} sur {1} appareils traités",
      exportSuccess: "Export créé avec succès.",
      exportError: "Une erreur s’est produite lors de l’export.",
      noData: "Aucune mesure disponible pour les appareils sélectionnés sur la période choisie.",
    },
    clientDevices: {
      title: "Appareils",
      allDevices: "Tous les appareils",
      search: "Numéro de série",
      count: "Appareils",
      kinds: {
        PANELS: "Panels HyDry",
        BOXES: "Box HyDry",
        MINIS: "Minis HyDry",
      },
      scopes: {
        CURRENT: "Affectés actuellement",
        FORMER: "Anciens",
      },
      filterGroups: {
        KIND: "Type d’appareil",
        PANEL_TYPE: "Type de panel",
        PERIOD: "Période",
        ASSIGNMENT: "Affectation",
      },
      sorts: {
        SERIAL_NUMBER: "Numéro de série",
        ASSIGNMENT_TYPE: "Affectation",
        ASSIGNMENT_DATE: "Date d’affectation",
      },
      columns: {
        serialNumber: "Numéro de série",
        type: "Type d’appareil",
        assignment: "Affectation",
        firmware: "Firmware",
        lastContact: "Dernier contact",
      },
      since: "depuis le {0}",
      open: "ouverte",
      history: "Toutes les affectations",
      noHistory: "Aucune affectation",
      build: "Build {0}",
      config: "Config {0}",
      ipu: "IPU {0}",
      display: "Écran {0}",
      noneMatching: "Aucun appareil ne correspond à ces filtres.",
      loadFailed: "Impossible de charger les appareils.",
    },
    clientProjects: {
      title: "Projets",
      search: "Nom / numéro",
      count: "Projets",
      filterGroups: {
        STATUS: "Statut",
        KIND: "Type de projet",
      },
      columns: {
        period: "Période",
        devices: "Appareils",
        steps: "Étapes",
      },
      since: "depuis le {0}",
      officeNumber: "Office : {0}",
      erpNumber: "Numéro collectif : {0}",
      showMore: "Afficher plus ({0} sur {1})",
      noneMatching: "Aucun projet ne correspond à ces filtres.",
      loadFailed: "Impossible de charger les projets.",
      archiveLoading: "{0} % chargé",
      archiveLoadFailed: "Impossible de charger les anciens projets.",
    },
    clientReports: {
      title: "Rapports",
      count: "Rapports",
      columns: {
        report: "Rapport",
        project: "Projet",
        date: "Date",
        size: "Taille",
      },
      outdated: "obsolète",
      sizeMb: "{0} Mo",
      showMore: "Afficher plus ({0} sur {1})",
      none: "Aucun rapport pour l’instant.",
      loadFailed: "Impossible de charger les rapports.",
      loadMoreFailed: "Impossible de charger plus de rapports.",
      openFailed: "Impossible d’ouvrir le rapport.",
      fileMissing: "Le fichier de ce rapport est introuvable.",
      noFile: "Ce rapport n’a pas de fichier.",
      popupBlocked: "Ton navigateur a bloqué la nouvelle fenêtre. Autorise les fenêtres pop-up pour IRES Office.",
    },
    clientUsers: {
      title: "Utilisateurs",
      search: "Pseudo / nom",
      count: "Utilisateurs",
      status: "Statut",
      filterGroups: {
        STATUS: "Statut",
        ROLE: "Rôle",
      },
      statuses: {
        ACTIVE: "Actif",
        BLOCKED: "Bloqué",
        DELETED: "Supprimé",
      },
      noneMatching: "Aucun utilisateur ne correspond à ces filtres.",
      loadFailed: "Impossible de charger les utilisateurs.",
    },
    userSearch: {
      title: "Rechercher des utilisateurs",
      search: "E-mail / Nom / Nom court / Matricule",
      count: "Utilisateurs",
      capped: "les {0} premiers sur {1}",
      client: "Client",
      hint: "Saisis au moins trois caractères : adresse e-mail, nom, nom court ou matricule.",
      none: "Aucun utilisateur ne correspond à cette recherche.",
      loadFailed: "La recherche a échoué.",
      nickname: "Nom court {0}",
      staffNumber: "Matricule {0}",
      sharedEmailAddress: "E-mail partagé",
      groupUser: "Groupe",
    },
    sharedUsers: {
      title: "Utilisateurs partagés",
      search: "E-mail / Nom / Client",
      tabs: {
        emailAddresses: "Partager l’adresse e-mail",
        emailAddressesShort: "E-mail",
        group: "Groupe",
      },
      emailAddressCount: "Adresses e-mail partagées",
      groupUserCount: "Utilisateurs partagés",
      homeClient: "Client d’origine",
      group: "Groupe",
      userCount: "1 utilisateur | {count} utilisateurs",
      clientCount: "1 client | {count} clients",
      migrated: "Migré",
      cleanUp: "Nettoyer",
      cleanUpAll: "Tout nettoyer ({0})",
      cleaningUp: "Nettoyage {0} sur {1} …",
      filters: {
        ALL: "Tous",
        CLEAN_UP: "À nettoyer",
        OK: "En ordre",
        MIGRATED: "Migrées",
      },
      states: {
        OK: "En ordre",
        STALE: "{0} n’existent plus",
        EMPTY: "Plus personne",
      },
      userStates: {
        LIVE: "Actif",
        DELETED: "Supprimé",
        MISSING: "N’existe plus",
        ADDRESS_CHANGED: "Autre adresse e-mail",
      },
      confirm: {
        title: "Nettoyer ?",
        message: "Ces utilisateurs n’ont plus {0} et seront retirés de l’adresse e-mail partagée :",
        entryDeleted: "Il ne reste ensuite plus personne : l’entrée est supprimée et l’adresse est de nouveau libre.",
        othersStay: "Les autres utilisateurs gardent la connexion partagée.",
        allMessage: "{0} adresses e-mail partagées ont des utilisateurs qui n’existent plus. Veux-tu toutes les nettoyer ?",
      },
      cleanedUp: "{0} nettoyée.",
      cleanedUpAll: "{0} adresses e-mail partagées nettoyées.",
      cleanUpFailed: "Le nettoyage a échoué.",
      refusals: {
        SHARED_LOGIN: "Rien ne peut être modifié avec la connexion admin IRES commune. Connecte-toi avec ton propre utilisateur.",
        NO_ENTRY: "Cette entrée n’existe plus.",
      },
      loadFailed: "Les utilisateurs partagés n’ont pas pu être chargés.",
      none: "Aucune entrée ne correspond à ces filtres.",
    },
    pdfTemplates: {
      loading: "Chargement du modèle …",
      title: "Modèles PDF",
      sharedTitle: "Modèles PDF partagés",
      search: "Nom ou fichier",
      count: "Modèles PDF",
      sharedCount: "Modèles PDF partagés",
      openShared: "Modèles partagés",
      sharedHint: "Les modèles partagés peuvent être repris par chaque mandant. Le certificat HyDry n’utilise que les modèles propres d’un mandant.",
      columns: {
        name: "Modèle",
        fields: "Champs",
        problems: "Problèmes",
        lastSaved: "Dernier enregistrement",
      },
      hyDryCertificate: "Certificat HyDry",
      ignoredCertificate: "-HyDry, non utilisé",
      problemValues: "1 valeur reste vide | {count} valeurs restent vides",
      noProblems: "Toutes les valeurs sont remplies",
      none: "Aucun modèle PDF pour l’instant.",
      noFields: "Ce modèle n’a aucun champ.",
      loadFailed: "Impossible de charger les modèles PDF.",
      notFound: "Ce modèle PDF n’existe pas.",
      download: "Télécharger",
      downloadFailed: "Impossible de télécharger le modèle.",
      fileMissing: "Le fichier de ce modèle est introuvable.",
      detail: {
        field: "Champ",
        category: "Catégorie",
        values: "Valeurs",
        texts: "Texte avant / après",
        prefix: "avant : « {0} » ({1})",
        suffix: "après : « {0} » ({1})",
      },
      statuses: {
        UNKNOWN_TO_CLOUD: "reste vide : IRES Cloud ne connaît pas cette valeur",
        NOT_IMPLEMENTED: "reste vide : non implémenté dans IRES Cloud",
        CHECKBOX_ALWAYS_OFF: "la case reste toujours vide",
      },
      fieldTypes: {
        TEXT: "Champ de texte",
        CHECK_BOX: "Case à cocher",
        SIGNATURE: "Champ de signature",
        DROPDOWN: "Liste déroulante",
      },
      edit: {
        dialogTitle: "Modifier {0}",
        filters: {
          ALL: "Tous les champs",
          LINKED: "Liés",
          UNLINKED: "Non liés",
        },
        linkedCount: "{0} champs liés sur {1}",
        notLinked: "non lié",
        notInPdf: "N’est plus dans le PDF",
        childFields: "Groupe de {count} champ | Groupe de {count} champs",
        noneMatching: "Aucun champ ne correspond à ce filtre.",
        unavailable: {
          NO_FILE: "Ce modèle n’a pas de fichier.",
          FILE_MISSING: "Le fichier de ce modèle est introuvable.",
          ENCRYPTED: "Le PDF est chiffré, ses champs ne peuvent pas être lus.",
          UNREADABLE: "Le PDF ne peut pas être lu.",
        },
        onlyLinkedShown: "Seuls les champs liés sont affichés.",
        selection: "Sélection",
        noValue: "Aucune valeur liée pour l’instant.",
        addValue: "Ajouter une valeur",
        replaceValue: "Remplacer la valeur",
        prefix: "Texte avant",
        suffix: "Texte après",
        preview: "Aperçu",
        unlink: "Supprimer le lien",
        changedMeanwhile: "Le modèle a été enregistré entre-temps, par exemple dans IRES Admin. Recharge la page et refais tes modifications.",
        saveRefused: "Non enregistré : le lien de « {0} » ne correspond pas au PDF ou aux valeurs de sa catégorie.",
        saveFailed: "Les liens n’ont pas pu être enregistrés.",
        scopeClient: "Modèle de {0} : les modifications enregistrées s’appliquent à tous les nouveaux PDF qu’IRES Project crée pour ce mandant.",
        scopeCertificate: "Ce modèle remplit aussi le certificat HyDry de ce mandant.",
        scopeShared: "Modèle partagé : les modifications enregistrées ne s’appliquent qu’aux reprises futures. Les mandants qui l’ont déjà repris gardent leur copie inchangée.",
        confirmTitle: "Enregistrer les liens ?",
        confirmClient: "Tu enregistres le modèle « {0} » de {1}. Les nouveaux PDF qu’IRES Project crée pour ce mandant utiliseront alors les liens modifiés.",
        confirmShared: "Tu enregistres le modèle partagé « {0} ». Cela ne concerne que les reprises futures ; les copies existantes chez les mandants restent inchangées.",
        changesAdded: "Nouveaux liens : {0}",
        changesChanged: "Modifiés : {0}",
        changesRemoved: "Liens supprimés : {0}",
      },
      files: {
        upload: "Nouveau modèle",
        uploadTitle: "Nouveau modèle PDF",
        replace: "Remplacer le PDF",
        rename: "Renommer",
        copyToShared: "Copier dans les modèles partagés",
        copyFromShared: "Reprendre des modèles partagés",
        delete: "Supprimer",
        deleteTitle: "Supprimer le modèle ?",
        preview: "Aperçu",
        previewFailed: "L’aperçu n’a pas pu être créé.",
        popupBlocked: "Le navigateur a bloqué la nouvelle fenêtre. Autorise les pop-ups pour cette page.",
        importMappings: "Reprendre les liens",
        fileLabel: "Fichier PDF",
        nameLabel: "Nom du fichier",
        sourceLabel: "Modèle partagé",
        actions: {
          upload: "Téléverser",
          replace: "Remplacer",
          rename: "Renommer",
          copy: "Copier",
        },
        problems: {
          EMPTY: "Saisis un nom.",
          TOO_LONG: "Le nom est trop long.",
          INVALID_CHARACTERS: "Le nom ne doit contenir ni / ni \\ ni ..",
          TAKEN: "Un modèle porte déjà ce nom ici. Les tablettes gardent un modèle sous son nom ; chaque PDF a donc besoin d’un nouveau nom.",
        },
        switches: {
          title: "Comment IRES Project lit le nom :",
          hidden: "masqué dans la sélection ; IRES Cloud peut l’utiliser pour le certificat HyDry",
          always: "proposé dans chaque phase et pour chaque assureur",
          phase: "phase {0}",
          noPhase: "sans phase",
          insurer: "seulement pour l’assureur « {0} »",
          images: "avec images (+Bild)",
          phases: {
            LEAK_DETECTION: "recherche de fuite",
            DAMAGE_ASSESSMENT: "constat du dommage",
            DRYING_CONCLUSION: "fin du séchage",
            REPAIR: "remise en état",
          },
        },
        consequences: {
          uploadClient: "Le modèle devient sélectionnable dans IRES Project pour {0}.",
          uploadShared: "Le modèle est disponible pour tous les mandants. Il n’apparaît dans IRES Project qu’après une reprise.",
          replaceClient: "Les nouveaux PDF qu’IRES Project crée pour {0} utilisent le nouveau fichier.",
          replaceShared: "Cela ne concerne que les reprises futures ; les mandants qui ont repris le modèle gardent leur copie.",
          replaceFile: "Le nouveau fichier a besoin d’un nouveau nom, car les tablettes gardent un modèle sous son nom. L’ancien fichier est conservé et les liens restent ; les champs absents du nouveau PDF sont ensuite signalés.",
          renameClient: "Les nouveaux PDF qu’IRES Project crée pour {0} portent le nouveau nom, et ses options (phase, assureur, +Bild) s’appliquent dès lors. Les documents existants restent inchangés.",
          renameShared: "Cela ne concerne que les reprises futures ; les copies existantes gardent leur nom.",
          copyToShared: "La copie est disponible pour tous les mandants. Elle est indépendante du modèle de {0} : les modifications de l’un n’atteignent pas l’autre.",
          copyFromShared: "La copie appartient à {0} et y devient sélectionnable dans IRES Project. Elle est indépendante du modèle partagé : les modifications de l’un n’atteignent pas l’autre.",
          deleteClient: "« {0} » de {1} sera supprimé. IRES Project ne le propose plus ; les documents existants restent inchangés.",
          deleteShared: "Le modèle partagé « {0} » sera supprimé. Les mandants qui l’ont repris gardent leur copie.",
          deleteKeepsFile: "Le fichier reste enregistré chez IRES et peut être restauré.",
          certificateReplace: "Ce modèle remplit le certificat HyDry de ce mandant. Garde -HyDry au début du nom, sinon IRES Cloud ne l’utilise plus pour cela.",
          certificateRename: "Ce modèle remplit le certificat HyDry de ce mandant. Sans -HyDry au début du nom, IRES Cloud ne l’utilise plus pour cela.",
          certificateLOST: "Ce mandant n’a alors plus de modèle pour le certificat HyDry ; IRES Cloud ne crée alors plus de certificats.",
          certificateCHANGED: "Le certificat HyDry de ce mandant utilise alors un autre modèle.",
        },
        success: {
          created: "Modèle créé. Lie maintenant ses champs.",
          replaced: "PDF remplacé.",
          renamed: "Modèle renommé.",
          copied: "Modèle copié dans les modèles partagés.",
          deleted: "Modèle supprimé.",
        },
        errors: {
          FILE_NAME_TAKEN: "Ce nom de fichier existe déjà ici, y compris pour un modèle supprimé ou remplacé. Choisis-en un autre.",
          FILE_TOO_LARGE: "Le PDF dépasse 6 Mo.",
          NOT_A_PDF: "Le fichier n’est pas un PDF lisible.",
          ENCRYPTED: "Le PDF est chiffré ; ses champs ne peuvent pas être lus.",
          NO_FILE: "Le fichier de ce modèle est introuvable.",
          FILE_NAME_EMPTY: "Saisis un nom.",
          FILE_NAME_TOO_LONG: "Le nom est trop long.",
          FILE_NAME_INVALID_CHARACTERS: "Le nom ne doit contenir ni / ni \\ ni ..",
          FAILED: "Cela n’a pas fonctionné. Réessaie.",
        },
        import: {
          title: "Reprendre les liens",
          sourceLabel: "Depuis le modèle",
          groups: {
            own: "Modèles de ce périmètre",
            shared: "Modèles partagés",
          },
          fresh: "{count} champ sans lien reçoit le lien du modèle : | {count} champs sans lien reçoivent le lien du modèle :",
          conflicting: "Ces champs sont liés autrement ici. Coche ce qui doit être écrasé :",
          nothing: "Ce modèle n’a aucun lien reprenable pour les champs de ce PDF.",
          missing: "{count} champ du modèle n’existe pas dans ce PDF ; il est ignoré. | {count} champs du modèle n’existent pas dans ce PDF ; ils sont ignorés.",
          savedLater: "Repris dans tes modifications ; enregistré seulement avec ENREGISTRER.",
        },
      },
    },
    infoConfig: {
      title: "Descriptions",
      globalTarget: "Cible globale : {0}",
      newVersion: "Nouvelle version",
      columns: {
        version: "Version",
        state: "Statut",
        uploaded: "Téléversée",
      },
      filters: {
        CURRENT: "Versions actuelles",
        TARGETS: "Cibles",
        RETIRED: "Retirées",
        LEGACY: "Recherche de fuite (anciennes)",
      },
      legacyHint: "Ces fichiers appartiennent aux projets autonomes de recherche de fuite, qui ne sont plus créés depuis 2021. Ils sont en lecture seule.",
      retiredHint: "Les versions retirées ne sont plus proposées comme cible. Les projets qui les utilisent restent inchangés.",
      loadFailed: "Les descriptions n’ont pas pu être chargées.",
      none: "Aucune version.",
      badges: {
        globalTarget: "Cible globale",
        clientTargets: "Cible de {count} mandant | Cible de {count} mandants",
        testTargets: "Cible de test chez {count} mandant | Cible de test chez {count} mandants",
        retired: "Retirée",
        unlisted: "Absente de la liste",
        noFile: "Fichier manquant",
      },
      publish: {
        title: "Nouvelle version de description",
        file: "Fichier CSV",
        version: "Numéro de version",
        permanent: "Une version publiée ne peut plus être modifiée ni supprimée ; vérifie-la donc avant.",
        facts: "Encodage {0} · séparateur {1} · en-tête {2} · {3} lignes",
        noProblems: "Aucun problème trouvé.",
        acknowledge: "J’ai lu les remarques et je veux quand même publier.",
        differences: "Différences avec la version {0}",
        noBase: "Aucune cible globale pour comparer.",
        check: "Vérifier",
        publish: "Publier",
        published: "Version {0} publiée.",
        versionProblems: {
          FORMAT: "Chiffres, un point et deux décimales, p. ex. 5.58.",
          TAKEN: "Cette version existe déjà.",
          NOT_NEWER: "La version doit être supérieure à la plus récente.",
        },
      },
      problems: {
        line: "Ligne {0} :",
        NOT_UTF8: "Le fichier n’est pas en UTF-8. Enregistre-le en « CSV UTF-8 », sinon les caractères accentués se perdent sur les tablettes.",
        EMPTY_FILE: "Le fichier est vide.",
        FIRST_LINE_WITHOUT_SEPARATOR: "La première ligne ne se termine pas par le séparateur ; IRES Project détecte le séparateur grâce à elle.",
        VERSION_HEADER_MISSING: "La première ligne doit commencer par #Version.",
        VERSION_HEADER_MISMATCH: "L’en-tête indique la version {0}, mais le fichier doit être publié sous un autre numéro.",
        VERSION_FORMAT: "« {0} » n’est pas un numéro de version valide (chiffres, point, deux décimales).",
        ROW_TOO_SHORT: "La ligne {0} a trop peu de colonnes ; IRES Project ne pourrait pas lire le fichier.",
        ROW_BEFORE_SECTION: "La ligne {0} se trouve avant la première section et est ignorée.",
        COMMA_SEPARATOR: "Le fichier est séparé par des virgules au lieu de points-virgules.",
        VERSION_TAKEN: "La version {0} existe déjà.",
        VERSION_NOT_NEWER: "La version n’est pas supérieure à la plus récente ({0}).",
      },
      differences: {
        none: "Aucune différence.",
        optionChangesHint: "{count} valeur se trouve maintenant à une position qui signifiait autre chose avant. | {count} valeurs se trouvent maintenant à des positions qui signifiaient autre chose avant.",
        SECTION_ADDED: "Section ajoutée",
        SECTION_REMOVED: "Section supprimée",
        ROW_ADDED: "{0} : nouvelle",
        ROW_REMOVED: "{0} : supprimée",
        ROW_CHANGED: "{0} : libellé « {2} » → « {3} »",
        TYPE_CHANGED: "{0} : type {2} → {3}",
        OPTION_ADDED: "{0}, valeur {1} : nouvelle « {3} »",
        OPTION_REMOVED: "{0}, valeur {1} : « {2} » supprimée",
        OPTION_CHANGED: "{0}, valeur {1} : « {2} » → « {3} »",
      },
      detail: {
        loading: "Chargement de la version {0} …",
        newFromThis: "Nouvelle version à partir de celle-ci",
        legacy: "Recherche de fuite (ancienne)",
        rowCount: "{count} ligne | {count} lignes",
        notFound: "Cette version n’existe pas.",
        setGlobalTarget: "Définir comme cible globale",
        setGlobalTargetTitle: "Changer la cible globale ?",
        setGlobalTargetMessage: "Les nouveaux projets de tous les mandants sans cible propre utilisent alors la version {0}. Les projets existants gardent leur version.",
        globalTargetSet: "La version {0} est maintenant la cible globale.",
        retire: "Retirer",
        retireTitle: "Retirer cette version ?",
        retireMessage: "La version {0} n’est plus proposée dans les listes ni comme cible. Les projets qui l’utilisent restent inchangés et le fichier est conservé.",
        retired: "La version {0} est retirée.",
      },
      target: {
        editTitle: "Modifier la description du mandant",
        version: "Version",
        consequence: "Les nouveaux projets de ce mandant utilisent alors cette version. Les projets existants gardent la leur.",
        followGlobal: "Utiliser la cible globale ({0})",
        saved: "Cible enregistrée.",
        change: "modifier",
      },
      errors: {
        CHECK_FAILED: "Le fichier contient des erreurs ; vérifie-le à nouveau.",
        WARNINGS_NOT_ACKNOWLEDGED: "Confirme d’abord les remarques.",
        VERSION_TAKEN: "Cette version existe déjà entre-temps.",
        VERSION_RETIRED: "Cette version est retirée.",
        VERSION_IS_TARGET: "Cette version est encore une cible et ne peut pas être retirée.",
        NEEDS_SYSADMIN: "Seul un SysAdmin du portail peut faire cela.",
        NO_FILE: "Le fichier de cette version est manquant.",
        FILE_TOO_LARGE: "Le fichier dépasse 2 Mo.",
        FAILED: "Cela n’a pas fonctionné. Réessaie.",
      },
      sections: {
        search: "Clé ou texte",
        noneMatching: "Aucune ligne ne correspond à la recherche.",
        columns: {
          key: "Clé",
          category: "Catégorie",
          group: "Groupe",
          entry: "Entrée",
          trade: "Corps de métier",
          type: "Type",
          values: "Valeurs",
        },
      },
      draft: {
        rowDialogTitle: "Modifier {0}",
        title: "Brouillon {0} (de {1})",
        savedHere: "Enregistré dans ce navigateur",
        none: "Aucun brouillon. Ouvre une version et choisis « Nouvelle version à partir de celle-ci ».",
        notSaved: "Le navigateur ne garde pas le brouillon (fenêtre privée ou stockage plein). Un rechargement le supprime.",
        discard: "Supprimer",
        discardTitle: "Supprimer le brouillon ?",
        discardMessage: "Toutes les modifications de ce brouillon seront perdues. Les versions publiées restent inchangées.",
        checkAndPublish: "Vérifier et publier",
        changeVersion: "Modifier le numéro de version",
        insertRow: "Insérer une ligne après",
        insertRowMessage: "Nouvelle ligne après {0}, même section.",
        removeRow: "Supprimer la ligne",
        removeRowMessage: "Supprimer la ligne {0} du brouillon ?",
        keyRequired: "Saisis une clé.",
        keyTaken: "Cette clé existe déjà.",
        rowHint: "Les modifications ne concernent que ce brouillon.",
        valuesHint: "Le chiffre à gauche est le numéro par lequel la description renvoie à la valeur (Boden0010-3 est la troisième valeur de Boden0010). Dans une ligne avec un type, un / et les valeurs vides ne comptent pas ; dans une ligne sans type (Def…), chaque cellule compte.",
        addValue: "Ajouter une valeur",
        referencesShifted: "Ces renvois pointeront ensuite vers une autre valeur et ne sont pas adaptés :",
        referenceShift: "{0} : « {1} » → « {2} », utilisé dans {3}",
        referenceGone: "{0} : « {1} » → aucune valeur, utilisé dans {2}",
        referencedByMore: "{0} et {1} autres",
        replaceTitle: "Remplacer le brouillon ouvert ?",
        replaceMessage: "Ce navigateur contient déjà le brouillon {0} (de {1}). Un nouveau brouillon le remplace.",
        replace: "Remplacer",
        openExisting: "L’ouvrir",
        open: "Brouillon ouvert {0} (de {1})",
        continue: "Continuer",
      },
    },
    deviceReports: {
      resultsTitle: "Résultats",
      matchingReports: "Rapports de test correspondants",
      filters: "Filtres",
      device: "Appareil",
      anyDevice: "Tous les appareils",
      deviceCategory: "Type d’appareil",
      allCategories: "Tous",
      categoryComBox: "ComBox",
      categorySensor: "Capteur",
      categoryPanel: "Panneau",
      allReportTypes: "Tous",
      period: "Période",
      noPeriodLimit: "Sans limite",
      maxAgeMonths: "Derniers",
      fromDate: "À partir du",
      monthsSuffix: "mois",
      outcomeAll: "Tous",
      outcomePassed: "Réussi",
      outcomeFailed: "Échoué",
      assignment: "Attribution",
      assignmentAll: "Tous",
      assignmentAssigned: "Attribués",
      assignmentUnassigned: "Non attribués",
      categoryExcludesUnassigned: "Les rapports non attribués n’ont pas encore d’appareil, donc pas de type d’appareil. Ils sont masqués tant que tu filtres par type.",
      showReports: "Afficher les rapports",
      noneMatching: "Aucun rapport de test ne correspond à ces filtres.",
      countNone: "aucun",
      countApprox: "env. {0}",
      pageLimited: "Les {0} rapports attribués les plus récents sont affichés. Réduis la période pour en voir de plus anciens.",
      waitingBySerialNumber: "Appareil pas encore créé",
      waitingByMacAddress: "Encore sans numéro de série",
      title: "Rapports de test",
      serialNumber: "Numéro de série",
      searchHint: "Saisis un numéro de série pour voir les rapports de test de l’appareil.",
      noneForDevice: "Il n’y a aucun rapport de test pour cet appareil.",
      loadFailed: "Les rapports de test n’ont pas pu être chargés.",
      capturedAt: "Testé le",
      reportType: "Type",
      result: "Résultat",
      uploadedBy: "Téléversé par",
      initial: "Test initial",
      viewer: {
        title: "Rapport de test",
        loadFailed: "Le rapport de test n’a pas pu être chargé.",
        unknownDevice: "Appareil inconnu",
        steps: "Étapes de test",
        step: "Étape",
        comment: "Description",
        status: "Statut",
        detail: "Détail",
        duration: "Durée",
        rawData: "Rapport complet",
        formatPdf: "PDF",
        formatJson: "JSON",
        downloadFailed: "Le rapport de test n’a pas pu être téléchargé.",
      },
    },
  },
  allDevices: {
    acquisitionDate: "Date d’acquisition",
    addNewCategory: "Créer nouvelle catégorie",
    addNewCategoryDesc: "Veuillez spécifier le nom de la nouvelle catégorie",
    allDevicesOverview: "Aperçu appareils",
    availability: "Disponibilité",
    available: "Disponible",
    categoryNotSaved: "Catégorie non sauvegardée",
    categorySaved: "Catégorie sauvegardée avec succès",
    createDeviceDialogTitle: "Créer appareil de type {0}",
    currentProject: "Projet actuel",
    currentProjectStartedAt: "Projet {0}, depuis {1}",
    deleteCategoryConfirmMessage:
      "Êtes-vous sûr de vouloir supprimer la catégorie {0} ?",
    deleteCategoryConfirmTitle: "Supprimer catégorie d’appareils",
    deleteTemplateConfirmMessage:
      "Êtes-vous sûr de vouloir supprimer le type d’appareil {0} ?",
    deleteTemplateConfirmTitle: "Supprimer type d’appareil",
    deleted: "Supprimé",
    deletionConfirmationDialog: {
      errorMessage: "Erreur lors de la suppression d’appareils",
      message:
        "Êtes-vous sûr de vouloir supprimer tous les appareils sélectionnés ?",
      successMessage: "Appareils supprimés avec succès",
      title: "Supprimer appareils",
    },
    deviceCategoryDeleted: "Catégorie supprimée avec succès",
    deviceCode: "Code",
    deviceCreated: "Création réussie ! L’appareil a été ajouté avec succès.",
    deviceNotCreated: "Échec de la création ! Impossible d’ajouter l’appareil.",
    deviceTemplateDeleted: "Type d’appareil supprimé avec succès",
    deviceTemplateNotSaved: "Type d’appareil non sauvegardé",
    deviceTemplateSaved: "Type d’appareil sauvegardé avec succès",
    editCategory: "Renommer catégorie d’appareils",
    editCategoryDesc: "Veuillez spécifier un nouveau nom pour la catégorie {0}",
    editDeviceType: "Éditer type d’appareil",
    electricityMeter: "Alimentation électrique",
    electricityMeterForOtherDevices: "Compteur alimentation externe",
    electricityMeterManufacturer: "Fabricant du compteur",
    electricityMeterManufacturerFull: "FABRICANT DE COMPTEUR",
    electricityMeterNumber: "Numéro de compteur",
    electricityMeterNumberAndManufacturer: "Numéro de compteur/fabricant",
    electricityMeterNumberFull: "Numéro de compteur",
    emptyDeviceCategoriesTemplatesHint:
      "Aucune catégorie d’appareils n’a encore été créée. Créer une catégorie d’appareils avec +.",
    emptyDeviceCategory:
      "Cette catégorie est encore vide. Vous pouvez créer de nouveaux types d’appareils au niveau de l’administration.",
    emptyDeviceTemplatesHint:
      "Aucun type d’appareil n’a encore été créé. Créer un type d’appareil avec +.",
    emptyDevicesHint: "Aucun appareil trouvé. Créer un appareil avec +.",
    emptyPanelTypes: "Aucun {0} trouvé.",
    errorCategoryNotFound: "Catégorie introuvable",
    errorDeviceNameEmpty: "Le type d’appareil est vide",
    errorDevicePowerUsageTypeEmpty:
      "Le type d’utilisation de l’appareil est vide.",
    errorDeviceTemplateHasDevices:
      "Impossible de supprimer un type d’appareil contenant des appareils.",
    errorExistingCategoryName: "Il existe déjà une catégorie de ce nom",
    errorExistingDeviceName: "Un type d’appareil portant ce nom existe déjà.",
    errorInvalidElectricityMeterManufacturer:
      "Le fabricant de compteurs n’est pas valide",
    errorInvalidElectricityMeterNumber:
      "Le numéro de compteur n’est pas valide",
    errorInvalidManufacturer: "Le fabricant n’est pas valide",
    errorInvalidNote: "La remarque n’est pas valable",
    errorInvalidQrCode: "Code QR non valide",
    errorInvalidSerialNumber: "Numéro de série non valide",
    errorInventoryNumber: "Veuillez spécifier le numéro d’inventaire",
    errorInventoryNumberAlreadyExists:
      "Ce numéro d’inventaire est déjà attribué",
    errorInventoryNumberInvalid: "Le numéro d’inventaire n’est pas valide.",
    errorPowerConsumptionPerHourError:
      "Veuillez spécifier la puissance caractéristique",
    errorQrCodeAlreadyExists: "Ce code QR est déjà utilisé",
    errorQrCodeTooLong:
      "Le code QR dépasse la limite maximale de 30 caractères. Veuillez spécifier un code plus court.",
    filterAllDevices: "Tous",
    filterAvailableDevices: "Utilisable",
    filterDevicesInUsage: "en action",
    filterUnavailableDevices: "Non disponible",
    formatLastProjectTimeInfo: "{0} - {1}",
    inventoryNumber: "Numéro d’inventaire",
    lastProject: "Dernier projet",
    manageAllDevices: "Gérer appareils",
    manufacturer: "Fabricant",
    meterInfoStart: "Relevé du compteur début: {0}",
    meterInfoStartEnd: "Relevé du compteur {0} - {1}",
    multiDevicesEditDialog: {
      title: "Éditer appareils",
    },
    noDevicePowerUsage: "Aucun",
    noDevicesFound: "Aucun appareil trouvé",
    noMatchingDevicesFound: "Aucun appareil correspondant trouvé",
    noQrCode: "Aucun code",
    notAvailable: "Non disponible",
    note: "Remarque",
    operatingHours: "Heures de fonctionnement",
    operatingHoursFromAssignment: "Attribution",
    powerConsumptionPerHour: "Puissance caractéristique (W)",
    powerUsageType: "Compteur",
    qrCodeNotStored: "Aucun",
    qrCodeStored: "Renseigné",
    recentlyClosedProject: "Projet {0}, de {1} à {2}",
    serialNumber: "Numéro de série",
    title: "Gérer tous les appareils",
  },
  appointmentType: {
    damageAssessment: "Relevé des dommages",
    dryingConclusion: "Démontage du séchage",
    dryingSetup: "Montage du séchage",
    followUpInspection: "Ressoumission",
    leakDetection: "Détection de fuites",
    measurement: "Mesure",
    repair: "Restauration",
  },
  assignDevice: {
    addAssignmentHint: "Nouvelle association avec +",
    addHyDryAssignmentHint: "Associer nouveaux appareils Hydry avec +.",
    assignHyDryDevice: "Associer appareil HyDry",
    assignPanel: "Associer Panel",
    assignToday: "Associer aujourd’hui",
    assignmentFrom: "Association de",
    assignmentHintTitle: "Association des appareils HyDry",
    assignmentUntil: "Association jusqu’à",
    billingViaDevice: "Facturation via : {0}",
    externalCountingStartDateError:
      "Association impossible. La date de début doit être à partir du {0}.",
    externalCountingOpenAssignmentError:
      "Association impossible. Une association ouverte n’est pas autorisée car l’appareil de facturation est associé jusqu’au {0}.",
    externalCountingEndDateError:
      "Association impossible. La date de fin doit être au plus tard le {0}.",
    countingDeviceHasActiveDependentsError:
      "Libération impossible. Il y a des associations actives facturées via cet appareil. Veuillez d'abord libérer ces appareils.",
    countingDeviceWindowBeforeMinDate:
      "Association impossible. L'association de l'appareil {0} se termine avant la date de début la plus tôt possible de cet appareil.",
    countingDeviceEndDateTooEarlyError:
      "Libération impossible. La date de fin doit être le {0} ou après, car il y a des appareils dépendants avec une date de fin ultérieure.",
    externalCountingStartDateAdjustedTitle: "Remarque",
    externalCountingStartDateAdjustedMessage:
      "La date de début d’association a été adaptée à l’association de l’appareil {0}.",
    collidingAssignment:
      "Il existe une autre association (à partir du {1}) au {0}. Impossible de créer l’association.",
    correct: "Corriger",
    correctedBy: "corrigé {0} {1}",
    countedViaExternalDevice: "Facturation électrique via un autre appareil ?",
    deleteAssignmentMessage:
      "Êtes-vous sûr de vouloir supprimer l’association ?",
    deleteAssignmentTitle: "Supprimer association des appareils",
    deviceAlreadyAssigned: "Appareil HyDry {0} est déjà associé au projet {1}.",
    genericDeviceAlreadyAssignedMessage:
      "L’appareil {0} est déjà associé au projet {1}.",
    deviceAlreadyAssignedMessage:
      "Il existe une autre association au {0} (jusqu’au {1}). Impossible de créer l’association.",
    deviceAlreadyAssignedTitle: "Appareil HyDry déjà associé",
    genericDeviceAlreadyAssignedTitle: "Appareil déjà associé",
    deviceBranchError:
      "Association impossible. L’appareil HyDry est sur le site {0}.",
    dryingNoStartedWarning: "Séchage non encore commencé",
    errorEndDateTitle: "Vérifier date de fin d’association",
    errorMeterReadingEnd: "La valeur doit être >= relevé du compteur au début",
    errorMeterReadingStart: "La valeur doit être >= 0",
    errorStartDateTitle: "Vérifier date de début de l’association",
    formatAssignComBox: "Associer Box HyDry {0}",
    formatAssignPanel: "Associer Panel HyDry {0}",
    formatCalculatedPowerConsumption: "Consommation électrique calculée :",
    assignmentHoursPrompt: "Veuillez saisir la durée d'affectation en heures.",
    operationTimeHint: "{0} heures (calculé de {1} 12:00 à {2} 12:00)",
    formatHyDryInApartment: "Appareils HyDry appartement {0}",
    formatHyDryInElectricitySupply: "Appareils HyDry alimentation électrique {0}",
    roomLevelAssignToRoomHint: "Dans ce projet, les appareils sont attribués à une pièce. Utilise le plus à côté de la pièce.",
    roomLevelNoRoomsHint: "Cet appartement n’a pas encore de pièces. Ajoute d’abord une pièce pour attribuer des appareils.",
    formatPowerConsumption: "Consommation: {0}",
    formatSignOffComBox: "Déconnecter Box HyDry {0}",
    formatSignOffPanel: "Déconnecter Panel HyDry {0}",
    genericAssignmentHintTitle: "Association des appareils",
    meterReadingEnd: "Relevé du compteur fin :",
    meterReadingEndChanged: "Relevé du compteur modifié",
    meterReadingEndChangedMessage:
      "Relevé du compteur modifié. Sauvegarder quand même ?",
    meterReadingFromAssignment: "Projet {0} : {1}",
    meterReadingFromIot: "lu : {0}",
    meterReadingStart: "Relevé du compteur début:",
    meterReadingsForPowerConsumption: "Relevés de compteur pour la consommation électrique",
    selectNoCountingDevice: "Ne rien sélectionner",
    selectCountingDeviceTitle:
      "Sélectionner un appareil pour la facturation électrique",
    useForElectricityBilling: "Utiliser pour la facturation électrique ?",
    noAvailableHyDryDevices: "Aucun appareil HyDry disponible trouvé",
    noAvailableDevices: "Aucun appareil disponible trouvé",
    deviceAssignedToOtherProject: "Cet appareil est déjà associé au projet \"{0}\".",
    deviceInOtherBranch:
      "Cet appareil appartient au site \"{0}\". Modifie son site pour l’associer à ce projet.",
    noMatchingDeviceFound: "Aucun appareil HyDry correspondant trouvé",
    noProgramChainsInAssignmentWarning:
      "Aucun séchage trouvé. Veuillez vérifier la période.",
    noUnassignedProgramChainFoundMessage:
      "Aucun séchage trouvé au sein de la période de l’association. Créer quand même l’association ?",
    powerConsumption: "Consommation électrique",
    powerConsumptionKWh: "Consommation électrique (kWh)",
    powerConsumptionRemote:
      "Consommation électrique (veuillez vérifier les relevés à distance)",
    signOff: "Déconnecter",
    signOffToday: "Déconnecter aujourd’hui",
    releaseDependantDevicesFirst: "Les appareils dépendants doivent d’abord être déconnectés.",
    assignmentSavedSuccess: "Association enregistrée avec succès.",
    assignmentSavedError: "Une erreur est survenue lors de l’enregistrement de l’association.",
    assignmentReleasedSuccess: "Association libérée avec succès.",
    assignmentReleasedError: "Une erreur est survenue lors de la libération de l’association.",
    assignmentCorrectedSuccess: "Association corrigée avec succès.",
    assignmentCorrectedError: "Une erreur est survenue lors de la correction de l’association.",
    assignmentDeletedSuccess: "Association supprimée avec succès.",
    assignmentDeletedError: "Une erreur est survenue lors de la suppression de l’association.",
    releaseDevices: "Libérer les appareils",
    devicesAssignedCount: "1 appareil attribué | {n} appareils attribués",
  },
  assignDeviceToProjectBranchDialog: {
    changeBranch: "Récupérer appareil",
    message:
      "L’appareil {0} est disponible sur le site {1}. Aller récupérer l’appareil sur le site actuel {2} ?",
    title: "Site appareil",
  },
  assignIresDevice: {
    assignAnyway: "Associer quand même ce jour-là",
    assignAnywayMessage:
      "L’association est réalisée à partir de {0}. Impossible d’associer le séchage {1}.",
    chainWillBeAssignedMessage:
      "Déconnexion au {0}. Le séchage {1} sera associé.",
    dialogIncludeOverlappingProgramChainFinishedMessage:
      "Un séchage est en cours au {0} (séchage {1}, commencé le {2}, clos le {3}). Ce séchage sera associé. Veuillez sélectionner un autre jour si possible.",
    dialogOverlappingProgramChainFinishedMessage:
      "Un séchage est en cours au {0} (séchage {1}, commencé le {2}, clos le {3}). Ce séchage ne sera pas associé. Veuillez sélectionner un autre jour si possible.",
    dialogOverlappingProgramChainMessage:
      "Un séchage est en cours au {0} (séchage {1}, commencé le {2}). Ce séchage ne sera pas associé. Veuillez sélectionner un autre jour si possible.",
    releaseAnyway: "Déconnecter quand même ce jour-là",
  },
  assignLicences: {
    basic: "Base",
    damageAssessmentAndLeakDetection: "Relevé",
    drying: "Séchage",
    dryingAndRepair: "Séchage",
    errorLicencesV3LimitExceeded:
      "Licences autorisées dépassées. Sauvegarde impossible.",
    errorMissingLicences:
      "Toutes les licences de type {0} sont déjà utilisées.",
    formatUsage: "{0} de {1}",
    leakDetection: "Détection de fuites",
    overviewLicences: "Aperçu des licences",
    overviewUsedLicences: "Aperçu des licences utilisées",
    selectLicences: "Sélectionner licences",
  },
  assignmentDetails: {
    titleComBox: "Box HyDry {0}",
    titlePanel: "Panel HyDry {0}",
  },
  changeEmailAndPassword: {
    changeEmailAndPasswordTitle:
      "Base de données : modifier l’adresse e-mail et le mot de passe ",
    emailAddress: "Adresse e-mail",
    emailAddressAlreadyUsed: "Cette adresse e-mail est déjà utilisée",
    firstSignInMessage: "Veuillez remplir les champs suivants",
    firstSignInTitle: "Première connexion",
    newEmailAddress: "Nouvelle adresse e-mail de la base de données",
    oldPassword: "Ancien mot de passe",
    password: "Mot de passe",
    passwordError: "Mot de passe incorrect",
  },
  chartData: {
    ground: "Sol",
    groundTemp: "Température sol",
    humidity: "Humidité",
    intensity: "Intensité",
    temp: "Température",
    wall: "Mur",
    wallTemp: "Température mur",
  },
  clientData: {
    addContactPerson: "Interlocuteur  +",
    addDevices: "Ajouter appareils",
    apartment: "Appartement",
    apartmentNumber: "W{0}",
    appointmentAgreement: "Prise de rendez-vous",
    approveProject: "Confirmer projet",
    approvedBy: "Projet confirmé : {0} par {1}",
    changeProjectOwner: "Modifier responsable de projet",
    changingProjectTypeToPortalMessage:
      "Êtes-vous sûr de vouloir modifier le projet Project Manager en projet Portal ?",
    changingProjectTypeToPortalTitle: "Changement de type de projet",
    changingProjectTypeToProjectmanagerMessage:
      "Êtes-vous sûr de vouloir modifier le projet Portal en projet Project Manager ?",
    changingProjectTypeToProjectmanagerTitle: "Changement de type de projet",
    client: "Donneur d’ordre",
    confirmProject: "Confirmer projet",
    contact: "Contact général",
    contactBy: "Contact par",
    contactPerson: "Contact appartement",
    contract: "Ordre",
    contractCreatedBy: "Exécuté par",
    contractType: "Type d’ordre",
    copyClient: "Comme donneur d’ordre",
    copyPolicyHolder: "Comme preneur d’assurance",
    createProject: "Créer projet",
    createdAt: "Ordre saisi : {0} par {1}",
    damageAssessment: "Relevé des dommages",
    damageDay: "Date du sinistre",
    damageId: "Référence du sinistre",
    damageLocation: "Lieu du sinistre",
    damageNumber: "Numéro de sinistre",
    damageNumberShort: "N° de sinistre.",
    damageType: "Type de dommage",
    datePlanned: "Date prévue",
    deleteContactPartnerConfirmationMessage:
      "Êtes-vous sûr de vouloir supprimer l’interlocuteur {0} ?",
    deleteContactPartnerConfirmationTitle: "Supprimer interlocuteur ",
    deleteContactPerson: "Interlocuteur -",
    deleteContactPersonBlockedByDevices:
      "L’appartement {0} ne peut pas être supprimé car des appareils sont attribués.",
    contactPersonAddedSuccess: "Appartement {0} ajouté",
    contactPersonDeletedSuccess: "Appartement {0} supprimé",
    deleteProject: "Supprimer projet",
    deleteProjectMessage: "Veux-tu vraiment supprimer ce projet ?",
    deleteProjectTitle: "Supprimer projet",
    directOrder: "Ordre direct",
    doNotApproveProject: "Ne pas confirmer le projet",
    firstContact: "Prise de contact",
    saveProjectErrorMessage: "Erreur lors de l'enregistrement du projet",
    formatApartment: "Appartement {0}",
    formatElectricitySupply: "Alimentation électrique {0}",
    formatBranch: "Site : {0}",
    formatContactPerson: "Interlocuteur {0}",
    formatNote: "Note : {0}",
    formatProjectNumberIres: "Numéro de projet IRES : {0}",
    formatProjectNumberOffice: "Numéro de projet Office : {0}",
    formatProjectNumberOfficeForSantec: "Numéro de projet Office : {0} / {1}",
    formatProjectOwner: "Responsable de projet : {0}",
    formatProjectStart: "Début du projet : {0}",
    formatProjectSupervisor: "Chef de projet : {0}",
    insurance: "Assurance",
    insuranceCase: "Risque assuré",
    insuranceContactName: "Nom",
    insuranceName: "Nom de l’assurance",
    lossAdjuster: "Gestionnaire de dommages",
    mainContractNumber: "Numéro d’ordre principal : {0}",
    missingProjectNumberOfficeMessage:
      "« Numéro de projet office » non spécifié. Confirmer quand même le projet ?",
    missingProjectNumberOfficeTitle: "Numéro de projet Office",
    mobilePhone: "Mobile {0}",
    newOrder: "Nouvel ordre",
    note: "Note",
    pdfDocument: "Ajouter PDF 1",
    pdfDocument2: "Ajouter PDF 2",
    pdfDocumentInfo: "Plus d’informations dans le PDF",
    phone: "Tél. {0}",
    policyHolder: "Preneur d’assurance",
    policyNumber: "Numéro de police",
    process: "Opération",
    processNumber: "Numéro d’opération",
    projectControl: "Pilotage du projet",
    projectControlHint: "Saisir et modifier en cliquant sur les champs colorés",
    projectData: "Données du projet",
    projectHint: "Saisir et modifier en cliquant sur les champs colorés",
    projectName: "Nom du projet",
    projectNumber: "Numéro de projet",
    projectNumberIres: "Numéro de projet IRES",
    projectNumberOffice: "Numéro de projet Office",
    projectOwner: "Responsable de projet",
    projectStartDate: "Début du projet",
    projectSupervisor: "Chef de projet",
    regulation: "Régulation",
    regulationBy: "Régulation par",
    rejectProject: "Refuser projet",
    rejectedBy: "Projet refusé : {0} par {1}",
    runningTasksSuspensionDeleteQuestion: "Vraiment supprimer ?",
    runningTasksSuspensionMoveToFinishedQuestion:
      "Vraiment déplacer vers PROJETS TERMINÉS ?",
    runningTasksSuspensionWarning:
      "Un travail est encore en cours sur ce projet ({0}). La tâche sera interrompue. | Un travail est encore en cours sur ce projet ({0}). Les tâches seront interrompues.",
    setProjectOwner: "Définir responsable de projet",
    setProjectSupervisor: "Désigner chef de projet",
    timePlanned: "Temps prévu",
    title: "Civilité",
    uploadDocument: "Télécharger un document",
  },
  clientSelector: {
    client: "Filiale",
  },
  cockpit: {
    allDevices: "Gestion des appareils",
    allHyDryDevices: "Tous les appareils HyDry",
    allProjects: "Tous les projets",
    appointmentManagement: "Prise de rendez-vous",
    appointments: {
      later: "Plus tard",
      overdue: "En retard",
      today: "Aujourd’hui",
      tomorrow: "Demain",
    },
    createNewProject: "Créer projet",
    dummyCardTitle: "Tout est capturé",
    extras: "Outils",
    formatCompany: "Filiale : {0}",
    iresExtra: {
      backToUser: "Retour à {0}",
      selectSharedUser: "Sélectionner utilisateur partagé",
      selectUser: "Sélectionner utilisateur",
    },
    iresExtras: " Outils IRES",
    myAppointments: "Mes rendez-vous",
    myHyDryDevices: "Mes appareils HyDry",
    myMessages: "Mes messages",
    myProjects: "Mes projets",
    projectOrganisation: "Organisation des projets",
    projects: "Projets",
    relevantProjects: "Projets pertinents",
  },
  comBox: {
    deviceList: {
      formatSensorValuesFloor: "Sol : {0}, humidité : {1}",
      formatSensorValuesRoom: "Pièce : {0}, humidité : {1}",
    },
    deviceState: {
      active: "Séchage en cours",
      dryRunEnded: "Séchage terminé",
      idle: "Commencer séchage",
      lidClosed: "Capot fermé",
      lidOpen: "Capot ouvert",
      malfunction: "Erreur",
      paused: "En pause",
      powerFail: "Prise retirée",
      standBy: "Arrêt",
      suspended: "suspendu",
      transition: "Transition",
      waiting: "interrompu",
      warning: "Avertissement",
    },
    dryingPauseType: {
      humidityThresholdReached: "Pause de déshumidification active",
      manual: "Pause manuelle active",
      powerOverload: "Surcharge pause active",
      program: "Pause de programme active",
      temperatureTooHigh: "Pause de surchauffe active",
    },
    errors: {
      error0: "Horloge en temps réel défectueuse",
      error1: "Heure non valide",
      error11: "Le capteur 1 ne réagit pas",
      error11New: "Au moins un capteur ne réagit pas",
      error12: "Le capteur 2 ne réagit pas",
      error13: "Le capteur 3 ne réagit pas",
      error14: "Le capteur 4 ne réagit pas",
      error15: "Le capteur d’environnement ne réagit pas",
      error15New: "Dysfonctionnement du capteur de pièce",
      error16: "Relais défectueux",
      error17: "Modem BLE ne répond pas",
      error18: "NB1 Modem ne démarre pas",
      error19: "Carte SIM non détectée",
      error2: "Mémoire défectueuse (EEPROM)",
      error20: "Box réinitialisée à la configuration usine",
      error21: "Config appareil réinitialisée",
      error22: "Config mandant réinitialisée",
      error23: "Config de séchage réinitialisée",
      error24: "Réinitialisation watchdog",
      error25: "Dépassement UART 1",
      error26: "Dépassement UART 2",
      error27: "Dépassement UART 3",
      error28: "Dépassement UART 4",
      error29: "Dépassement UART 5",
      error3: "Mémoire défectueuse (SPI Flash)",
      error4: "Expiration de l’écran",
      error5: "Le compteur d’énergie ne répond pas",
      error6: "Aucun capteur de référence",
      error7: "Température du capteur trop élevée",
      error8: "Erreur compteur d’électricité",
    },
    events: {
      event: "Événement {0}",
      event1: "Box connectée à l’alimentation électrique",
      event10: "Séchage repris",
      event11: "Séchage repris",
      event12: "Séchage terminé",
      event125: "Prise allumée avec retard",
      event13: "Commencer séchage",
      event14: "Box éteinte",
      event15: "Étape terminée",
      event16: "Fin du programme",
      event17: "Nouveau course démarré (durée max.)",
      event18: "Nouvelle course démarrée (nombre d’échantillons max.)",
      event2: "Box allumée, séchage interrompu",
      event20: "Début de la pause nocturne",
      event21: "Pause nocturne terminée",
      event22: "Échantillon de surveillance",
      event23: "Intervalle de surveillance terminé",
      event24: "Pause de séchage démarrée",
      event25: "Pause de séchage terminée",
      event26: "Prolongation de la phase",
      event28: "Avertissement",
      event29: "Défaut",
      event3: "Box allumée, séchage repris",
      event30: "Redémarrage (Boot)",
      event31: "Box coupée de l’alimentation électrique",
      event32: "Connexion BLE établie",
      event33: "Connexion BLE interrompue",
      event34: "Démarrage du programme",
      event36: "Capot ouvert",
      event37: "Capot fermé",
      event40: "NB1 Connexion au réseau établie",
      event41: "NB1 Échec de connexion au réseau",
      event42: "NB1 Connexion au serveur établie",
      event43: "NB1 Échec de connexion au serveur",
      event44: "NB1 Expiration de la connexion",
      event45: "NB1 Connexion fermée",
      event46: "NB1 Réseau déconnecté",
      event47: "NB1 désactivé",
      event48: "NB1 Connexion terminée (0) (fermer session)",
      event49: "NB1 Connexion terminée (1) (rétablir)",
      event50: "NB1 Connexion terminée (2)",
      event53: "NB1 Mise à jour de la qualité du signal",
      event54: "NB1 Modem allumé",
      event55: "NB1 Modem éteint",
      event56: "NB1 Tentative de session",
      event59: "Heure d’été / heure d’hiver",
      event6: "Box allumée",
      event60: "Heure actualisée",
      event61: "Redémarrage (Commande)",
      event62: "Redémarrage (nouvelle configuration)",
      event64: "Réinitialisation (configuration de l’appareil)",
      event65: "Redémarrage (nouveau firmware)",
      event66: "Redémarrage (nouvel écran firmware)",
      event67: "Mise à jour (configuration)",
      event68: "Mise à jour (IPU firmware)",
      event69: "Mise à jour (écran firmware)",
      event7: "Nouveau séchage démarré",
      event70: "Mesure de la tension de la batterie",
      event71: "Dépassivation batterie commencée",
      event72: "Dépassivation batterie terminée",
      event75: "128 erreurs sur I2C2",
      event76: "NB1 État en cas de panne de courant",
      event77: "Configuration du capteur modifiée",
      event8: "Nouvelle course démarrée",
      event80: "Température de la pièce trop élevée",
      event81: "Température de la pièce OK",
      event82: "Air de la pièce suffisamment déshumidifié",
      event83: "L’air de la pièce est à nouveau déshumidifié",
      event84: "Température de la pièce très basse",
      event86: "Humidité de la pièce très élevée",
      event88: "Pause de surcharge",
      event9: "Séchage suspendu",
      warningFixed: "Avertissement levé",
    },
    formatComBox: "Box {0}",
    formatComBoxError: "Erreur : {0}",
    formatComBoxInfo: "Info : {0}",
    formatComBoxWarning: "Avertissement : {0}",
    humidityUnit: {
      absoluteHumidity: "humidité absolue",
      absoluteHumidityAndPressure: "Hum. abs./pression",
      formatAbsoluteHumidity: "{0} g/m³",
      formatAbsoluteHumidityAndPressure: "{0} g/m³ / {1}hPa",
      formatMixingRatio: "{0} g/kg",
      formatMixingRatioAndPressure: "{0} g/kg / {1}hPa",
      formatPercent: "{0}%",
      formatPercentAndPressure: "{0}% / {1}hPa",
      formatPercentAndPowerConsumption: "{0}% / {1}W",
      formatPercentAndPowerConsumptionAndPressure: "{0}% / {1}W / {2}hPa",
      formatRelativeHumidity: "{0} %Hr",
      mixingRatio: "Rapport de mélange",
      mixingRatioAndPressure: "Rap mél/pression",
      powerConsumption: "Puissance",
      relativeHumidity: "Hum. rel.",
      relativeHumidityAll: "Hum. rel./pluie/pression/puissance",
      relativeHumidityAndPressure: "Hum. rel./pluie/pression",
      relativeHumidityAndPowerConsumption: "Hum. rel./puissance",
      relativeHumidityAndPowerConsumptionAndPressure:
        "Hum. rel./pluie/pression/puissance",
    },
    nightModeActive: "Mode nuit actif",
    relativeHumidity: "Hum. rel.",
    sensorType: {
      bluetoothType3: "BLE type 3",
      bluetoothType1: "BLE type 1",
      bluetoothType5: "BLE type 5",
      empty: "Aucun capteur",
      radon: "Radon",
      sht3x: "SHT3X",
      telaire: "Telaire",
      unknow: "Inconnu",
    },
    temperature: "Température",
  },
  comBoxClientConfig: {
    clientConfig: "Configuration du mandant HyDry Control",
    createClientConfig: "Créer une configuration de mandant HyDry Control",
    displayMessage: "Texte sur l’écran",
    expertMode: "Mode expert",
    formatSensorProgram: "S{0}",
    name: "Nom",
    programmSensors: "Capteurs du programme",
    selectableDryingPrograms: "Programmes de séchage sélectionnables",
    selectableDryingProgramsBox: "Programmes de séchage sélectionnables (Box)",
    selectableDryingProgramsMini: "Programmes de séchage sélectionnables (Mini)",
    defaultProgramMini: "Programme standard (Mini)",
    selectableSensorPrograms: "Programmes de capteurs sélectionnables",
    sensor: "Capteur {0}",
    version: "Version",
  },
  sensorInfo: {
    title: "SENSOR INFO ({0})",
    titleRoom: "SENSOR INFO (PIÈCE)",
    serialNumber: "Numéro de série",
    type: "Type",
    status: "Statut",
    statusOk: "OK",
    statusBatteryLow: "Batterie faible",
    statusPoorLink: "Mauvaise qualité de connexion",
    statusSensorLost: "Capteur perdu",
    statusTurnedOff: "Capteur éteint manuellement",
    typeTempHumidity: "Capteur temp / humidité",
    typePressure: "Capteur de pression",
    typeHammerElectrode: "Électrode à enfoncer",
    typeRadon: "Capteur de radon",
    typeInternalSensor: "Capteur interne de la box",
    connection: "Connexion",
    wired: "Filaire",
    wireless: "Sans fil",
    integrated: "Intégré",
    signalStrength: "Intensité du signal",
    batteryStatus: "État de la batterie",
    firmware: "Firmware",
    noData: "Aucune donnée de capteur disponible",
  },
  dryingGraph: {
    temperatureAxisLabel: "Temp",
    absoluteHumidityAxisLabel: "Hum. abs.",
    relativeHumidityAxisLabel: "Hum. rel.",
    mixingRatioAxisLabel: "Rap mél",
    resistanceDigitsAxisLabel: "Digits",
    formatResistanceDigits: "{0}",
    tooltipSensorHumidity: "Humidité",
    tooltipSensorResistance: "Digits",
    tooltipSensorTemperature: "Température",
    tooltipWeather: "Météo",
    tooltipPower: "Puissance",
    tooltipIntensity: "Intensité",
    weatherDataUnavailable: "Les données météo n’ont pas pu être chargées. Veuillez réessayer plus tard.",
  },
  comBoxDetail: {
    confirmMeterReadingPowerUpTitle: "Box HyDry en cours d’allumage",
    confirmMeterReadingUpMessage:
      "Veuillez confirmer l’état actuel du compteur d’électricité",
    control: {
      change: "MODIFIER",
      confirmPowerOn: {
        messageBox:
          "Êtes-vous sûr de vouloir allumer la Box ? Les prises sont activées quand le capot est ouvert.",
        messageMini:
          "Êtes-vous sûr de vouloir allumer le MINI ? Les prises sont activées lorsque le MINI est allumé.",
        title: "Allumer Box HyDry depuis le mode veille",
      },
      formatPowerOnTitle: "Allumer Box {0}",
      iotMeterReadingHint:
        "L’instruction sera exécutée lors de la prochaine connexion IdO. Le relevé du compteur sera lu et appliqué via IdO. Continuer ?",
      pause: "Pause",
      powerOff: "Éteindre",
      powerOn: "Allumer",
      relays: "Relais",
      resume: "Reprendre",
      start: "Démarrer",
      terminate: "Terminer",
    },
    controlConfig: {
      changeDryRun: "Box {0} : modifier séchage",
      currentConfigUnknown:
        "Les réglages actuels de cette box ne sont pas connus. Les réglages par défaut sont préremplis : vérifie-les avant d’enregistrer.",
      defaultDryingMode: "Procédure standard",
      defaultNightMode: "Configuration standard Mode nuit",
      defaultProgram: "Programme standard",
      defaultProgramBox: "Programme standard (Box)",
      defaultSocketAB: "Configuration standard prises A+B",
      defaultSocketCD: "Configuration standard prises C+D",
      dryRunParameters: "PARAMÈTRES DE FONCTIONNEMENT",
      dryingMode: "Procédure",
      dryingModeChangeDisabledDialogMessage:
        "Impossible de modifier le mode de fonctionnement lorsque le séchage est en cours. Terminer d’abord le séchage.",
      dryingModeChangeDisabledDialogTitle: "Modifier mode de fonctionnement",
      dryingModeOptions: {
        monitor: "Moniteur",
        negativePressure: "Aspiration",
        positivePressure: "Insufflation",
        pushPull: "Insufflation/aspiration",
        roomDrying: "Séchage de la pièce",
      },
      formatNightModeParameters: "de {0} à {1} {2} {3}",
      formatNightModeParametersAlternate: "{0}-{1}, {2}, {3}",
      formatNightModeParametersNoDaysAlternate: "{0}-{1}, {2}",
      missingFloorSensorWarningMessageForBoxDefault:
        "Programme de séchage sans capteurs de sol sélectionné : le pilotage est strictement temporel jusqu’à la durée maximale du programme.",
      missingFloorSensorWarningMessageForBoxSupportingRoomDrying:
        "Programme de séchage sans capteurs de sol sélectionné : le pilotage est strictement temporel jusqu’à la durée maximale du programme. Nous recommandons le séchage avec le programme SÉCHAGE DE PIÈCE.",
      missingFloorSensorWarningStartAnyway: "Démarrer quand même",
      missingFloorSensorWarningTitle: "Vérifier programme de séchage",
      nightMode: "Mode nuit",
      nightModeDays: "Jours mode nuit",
      nightModeEnd: "Fin mode nuit",
      nightModeOff: "Mode nuit désactivé",
      nightModeOn: "Mode nuit activé",
      nightModeSockets: "Mode nuit prises",
      nightModeSocketsOptions: {
        allSockets: "Toutes les prises de courant",
        allSocketsAlternate: "Tous",
        allSocketsShort: "Tous",
        allSocketsShortAlternate: "Tous",
        programSockets: "Prises du programme",
        programSocketsAlternate: "PROG",
        programSocketsShort: "PROG",
        programSocketsShortAlternate: "PROG",
      },
      nightModeStart: "Début mode nuit",
      program: "Programme",
      roomDryingHintMessageBox:
        "Les réglages suivants sont recommandés :\n\nPrises A+B PROG : déshumidificateur d’air\nPrises C+D MARCHE : ventilateur et/ou appareils pour l’assèchement des murs",
      roomDryingHintMessageMini:
        "Les réglages suivants sont recommandés :\n\nPrise A PROG : déshumidificateur d’air\nPrise B MARCHE : ventilateur et/ou appareils pour l’assèchement des murs",
      roomDryingHintTitle: "Séchage de la pièce",
      sensors: "CAPTEURS",
      socketA: "Prise A",
      socketAB: "Prises A+B",
      socketB: "Prise B",
      socketCD: "Prises C+D",
      socketModeOptions: {
        off: "Arrêt",
        on: "Marche",
        program: "PROG",
      },
      start: "Démarrer",
      startDryRun: "Box {0} : démarrer séchage",
    },
    floorTempHumidity: "Sol temp / humidité",
    tempHumidity: "Temp / humidité",
    formatEndOfPhase: "P{0} Fin",
    formatPhase: "Phase {0}",
    formatProgram: "P{0}",
    formatSensor: "Capteur {0}",
    monitor: "Moniteur",
    nightModeParameters: {
      title: "Réglages mode nuit",
    },
    pause: {
      confirm: "Confirmer pause",
      hint: "Pause (min)",
      message: "Veuillez spécifier la durée de la pause (min)",
      title: "Mettre Box {0} en pause",
    },
    phases: "Phases",
    postDryingRun: "Phase de clôture",
    program: "Programme",
    programDryingSensor: "Séchage capteur",
    programDryingTime: "Séchage temps",
    roomTempHumidity: "Temp / humidité de la pièce",
    sensorData: {
      roomSensor: "Pièce",
      sensor: "Capteur",
    },
    sensorUsage: {
      measurement: "Mesure",
      measurementShort: "MESS",
      program: "Programme",
      programShort: "PRG",
      reference: "Référence",
      referenceShort: "RÉF",
      usage: "Utilisation",
    },
    sensorUsageRecommendation: {
      dryingMode: "Mode de fonctionnement",
      hint1: "Les réglages de capteur suivants sont recommandés :",
      hint2: "Voir aussi le guide d’utilisation.",
      referenceSensor: "Capteur de référence",
      roomSensor: "Capteur de la pièce",
      roomSensorOrSensor1: "Capteur de la pièce ou capteur 1",
      sensor1: "Capteur 1",
      title: "Programme de séchage avec commande par capteur sélectionné",
    },
    terminateDryRun: {
      dryRunKeyValues: "DONNÉES DE SÉCHAGE",
      keyValueCurrent: "Actuel",
      keyValueDuration: "Durée",
      keyValueHumidity: "Humidité",
      keyValueMeter: "Compteur",
      keyValueStart: "Début",
      terminateDryRun: "Clore séchage",
    },
    testRelays: {
      numCycles: "Cycles de commutation",
      onOffDuration: "Durée d’allumage et d’extinction (1/10 sec)",
      relay1Active: "Relais 1 actif",
      relay2Active: "Relais 2 actif",
      title: "Test de relais {0}",
    },
    title: "Détails Box {0}",
  },
  comBoxSampleIotInfo: {
    batteryVoltageToLow: "Tension de la batterie trop faible",
    disconnectFailure: "Erreur lors de l’envoi du disconnect NB1",
    formatIotInfo:
      "Message de panne de courant : {0} ({1}), BC66 : {2}, NB1 : {3}, compteur : {4}",
    iotConnectonDisabled: "NB1 Connexion désactivée",
    iotServerConnectionFailure: "Serveur IdO inaccessible",
    noIpAddress: "Aucune adresse IP",
    noNetwork: "Échec de l’enregistrement",
    reserved: "Réservé",
    socketFailure: "Erreur lors de l’ouverture du socket",
    success: "Envoyé avec succès",
    timeoutIotServerConnect:
      "Expiration du délai d’attente lors de la connexion au serveur IdO",
    unexpectedModemReset: "Réinitialisation inattendue du modem",
  },
  comBoxSettings: {
    battery: "Batterie",
    electricityMeter: "Compteur d’électricité",
    factoryReset: {
      action: "Réglages d’usine",
      confirm: "Réinitialiser",
      consequences: {
        datalog: "Tous les cycles enregistrés sur la box sont supprimés. Ceux que la box a déjà transmis restent dans le portail.",
        queued: "Les commandes sont notées via IdO et exécutées au prochain contact de la box.",
        reboot: "La box redémarre ensuite.",
        terminate: "Si un séchage est en cours sur la box, il est d’abord terminé.",
      },
      flags: {
        bConfig: "Configuration de base",
        cConfig: "Configuration client",
        counters: "Compteurs d’heures de fonctionnement et de mises sous tension",
        datalog: "Journal : supprimer tous les cycles de la box",
        dConfig: "Programmes de séchage et de capteurs",
        fileInfo: "Fichiers : logo et images firmware",
      },
      queueFailed: "La réinitialisation n’a pas pu être notée.",
      reboots: "Redémarre la box",
      title: "Réinitialiser la box {0}",
    },
    firmwareDisplay: "Firmware écran",
    firmwareIPU: "Firmware IPU",
    mcuResetSource: "MCU Reset Source",
    mcuResetSourceValues: {
      independentWatchdog: "Watchdog indépendant",
      lowPower: "Puissance faible",
      powerOn: "Sous tension",
      resetPin: "Reset-Pin",
      software: "Logiciel",
      windowWatchdog: "Fenêtre watchdog",
    },
    restartConfirmMessage: "Le redémarrage est noté via IdO.",
    restartConfirmTitle: "Redémarrer la box {0} ?",
    title: "Réglages Box {0}",
  },
  common: {
    abort: "ANNULER",
    apply: "APPLIQUER",
    refresh: "Actualiser",
    download: "Télécharger",
    address: "Adresse",
    all: "Tous",
    allDevices: "Tous les appareils",
    activeDevices: "Appareils actifs",
    activeHydryDevices: "Appareils HyDry actifs",
    and: "et",
    api: "API",
    appointment: "Rendez-vous",
    appUpdate: {
      message: "Une nouvelle version est disponible.",
      refresh: "Recharger",
      later: "Plus tard",
    },
    archived: "Archivé",
    areYouSure: "En êtes-vous sûr ?",
    assign: "Associer",
    back: "RETOUR",
    barcode: "CODE-BARRES",
    both: "Les deux",
    box: "Box",
    branch: "Site",
    branches: "Sites",
    build: "Build {0} ({1})",
    change: "MODIFIER",
    changesNotSaved: "Modifications non sauvegardées",
    changesSaved: "Modifications sauvegardées",
    close: "Fermer",
    concluded: "Clos",
    movedToFinished: "Déplacé",
    restored: "Restauré",
    confirm: "Confirmer",
    confirmationDialog: {
      cancelMessage:
        "Vous avez déjà effectué des modifications. Souhaitez-vous annuler ces modifications ?",
      cancelTitle: "Annuler les modifications ?",
      unsavedChangesMessage: "Veux-tu vraiment annuler ?",
      unsavedChangesTitle: "Attention : perte de données",
    },
    confirmSignOutMessage: "Êtes-vous sûr de vouloir fermer la session ?",
    confirmSignOutTitle: "Fermer session",
    country: "Pays",
    currentProject: "Projet actuel : {0}",
    dataComplete: "Données complètes",
    dataSaved: "Données sauvegardées",
    date: "Date",
    dayOfTheWeek: {
      friday: "Ven",
      monday: "Lun",
      saturday: "Sam",
      sunday: "Dim",
      thursday: "Jeu",
      tuesday: "Mar",
      wednesday: "Mer",
    },
    delete: "Supprimer",
    deleted: "Supprimé",
    details: "Détails",
    development: "Développement V{0}",
    device: "Appareil",
    deviceManager: "IRES Work",
    devices: "Appareils",
    drying: "Séchage",
    duration: {
      formatDays: "1 jour | {count} jours",
      formatDaysOpenEnded: "1 jour | {count} jours",
      formatHours: "1 heure | {count} heures",
      formatMinutes: "1 minute | {count} minutes",
      now: "Maintenant",
    },
    edit: "Éditer",
    electricityMeter: "Compteur d’électricité",
    electricityMeterKwh: "Compteur (kWh) :",
    email: "Adresse e-mail",
    emailShort: "E-mail",
    invalidEmailAddress: "Adresse e-mail invalide",
    end: "Fin",
    endViewAs: "Quitter la perspective",
    execute: "exécuter",
    executionBy: "Exécution par",
    additionalUser: "Employé supplémentaire",
    additionalUsers: "Employés supplémentaires",
    addAdditionalUser: "Ajouter un employé supplémentaire",
    export: "Exporter",
    filter: "Filtrer",
    firstName: "Prénom",
    floor: "Complément d’adresse",
    formatKWh: "{0} kWh",
    formatPercent: "{0} %",
    formatRelativeHumidity: "{0} %Hr",
    formatRun: "Course {0}",
    formatRuns: "1 course | {count} courses",
    formatTemperature: "{0} °C",
    formatTemperatureCompact: "{0} °C",
    from: "de {0}",
    fromUntil: "de {0} à {1}",
    fromUntilAlt: "du {0} au {1}",
    houseNumber: "Numéro de maison",
    hydryDevices: "Appareils HyDry",
    usedDevices: "Appareils utilisés",
    ires: "IRES",
    isAdmin: "OUI",
    kwh: "kWh",
    lastName: "Nom de famille",
    lastProject: "Dernier projet : {0}",
    leakDetection: "Détection de fuites",
    location: "Lieu",
    mobilePhone: "Mobile",
    name: "Nom",
    new: "Nouveau",
    never: "Jamais",
    nfc: "NFC",
    no: "Non",
    noUsersToShow: "Aucun utilisateur approprié trouvé pour cette tâche.",
    notAvailable: "non disponible",
    numPanels: "{0} HyDry",
    off: "Arrêt",
    ok: "OK",
    on: "Marche",
    open: "Ouvrir",
    otherDevices: "Tous les appareils",
    pageNotAvailable: "Cette page n’est pas disponible pour toi.",
    panel: "Panel",
    phone: "Téléphone",
    portal: "IRES Office",
    production: "Production V{0}",
    project: "Projet",
    projectManager: "IRES Project",
    projects: "Projets",
    qrCode: "QR",
    save: "SAUVEGARDER",
    saveData: "Sauvegarder données",
    search: "Rechercher",
    select: "Sélectionner",
    serialNumber: "Numéro de série",
    signOut: "Fermer session",
    more: "Plus",
    moreActions: "Plus d’actions",
    toggleTheme: "Basculer le thème",
    signedInAs: "Connecté en tant que {0}",
    since: "depuis {0}",
    sinceUntil: "depuis {0} jusqu’à {1}",
    sort: "Trier",
    start: "Début",
    startingAt: "à partir de {0}",
    street: "Rue",
    submit: "Appliquer",
    time: "Heure",
    timeOfDay: "Heure",
    todo: "TODO",
    unknown: "Inconnu",
    unsavedChangesDialog: {
      doNotSave: "NE PAS SAUVEGARDER",
      message:
        "Des modifications n’ont pas encore été sauvegardées. Voulez-vous les sauvegarder ?",
      title: "Modifications non sauvegardées",
    },
    until: "jusqu’à {0}",
    user: "Utilisateur",
    userProjects: "Vue {0}",
    version: "Version : {0}",
    viewAsEndedNoRight: "La perspective a été fermée, car tu n’as plus le droit de l’utiliser.",
    viewAsEndedUserUnavailable: "La perspective a été fermée, car l’utilisateur n’est plus disponible.",
    viewAsReadOnly: "Rien ne peut être modifié pendant la perspective d’un autre utilisateur.",
    viewOf: "Perspective de : {0}",
    viewOfProjects: "Vue {0}",
    web: "Web",
    yes: "Oui",
    zipCode: "CODE POSTAL",
  },
  dataViewer: {
    rows: "Lignes",
    columns: "Colonnes",
    search: "Rechercher...",
    noResults: "Aucun résultat",
    noData: "Aucune donnée disponible",
    noSections: "Aucune section disponible",
    expandAll: "Tout déplier",
    collapseAll: "Tout replier",
    editModeOn: "Modifier",
    editModeOff: "Arrêter la modification",
  },
  pdeViewer: {
    title: "Échange de données de projet (PDE)",
    loading: "Chargement du PDE...",
    loadError: "Échec du chargement des données PDE",
    noStorageLocation: "Aucun chemin de fichier PDE disponible",
    download: "Télécharger",
    noSelection: "Aucune sélection",
    saveSuccess: "Données PDE enregistrées",
    saveError: "Échec de l’enregistrement des données PDE",
    sections: {
      projectInfo: "Données du projet",
      apartments: "Appartements",
      rooms: "Pièces",
      consolidatedWorkItems: "Prestations (CWI)",
      materials: "Matériaux",
      timeEstimate: "Estimation du temps",
      timeTracking: "Suivi du temps",
      deviceAssignments: "Affectations d’appareils",
      workItems: "Positions de travail",
      affectedComponents: "Composants concernés",
    },
    fields: {
      projectIdIres: "ID projet IRES",
      projectIdErp: "ID projet ERP",
      projectTypeId: "Type de projet",
      creationTimestamp: "Créé",
      pdeSchemaVersion: "Version du schéma",
      infoConfigVersion: "Version description",
      erpBoQVersion: "Version LV",
      senderId: "Expéditeur",
      projectStatus: "Statut",
      apartmentNumber: "Appartement",
      lastName: "Nom",
      firstName: "Prénom",
      floor: "Étage",
      roomNumber: "N° pièce",
      roomName: "Nom de la pièce",
      note: "Note",
      numberOfAffectedWalls: "Murs affectés",
      numberOfWalls: "Nombre de murs",
      roomWidth: "Largeur",
      roomLength: "Longueur",
      roomHeight: "Hauteur",
      roomArea: "Surface",
      component: "Composant",
      workItemId: "Position de travail",
      billingItemId: "Position de facturation",
      billingItemId2: "Position de facturation 2",
      workItemText: "Description",
      billingItemTextErp: "Texte ERP",
      quantityIres: "Qté IRES",
      quantityErp: "Qté ERP",
      quantityCompleted: "Qté terminée",
      unit: "Unité",
      phase: "Phase",
      trade: "Corps de métier",
      serviceProviderIres: "Prestataire IRES",
      serviceProviderErp: "Prestataire ERP",
      chapter: "Chapitre",
      section: "Section",
      paragraph: "Paragraphe",
      asset: "Matériel",
      quantity: "Quantité",
      technicianId: "Technicien",
      protectionHours: "Protection (h)",
      dismantlingHours: "Démontage (h)",
      setupDryingHours: "Montage séchage (h)",
      measurementHours: "Mesure (h)",
      packupDryingHours: "Démontage séchage (h)",
      restorationHours: "Restauration (h)",
      entryNumber: "N°",
      date: "Date",
      startOfWork: "Début",
      endOfWork: "Fin",
      travelTimeHours: "Temps de trajet (h)",
      leakDetectionHours: "Détection de fuite (h)",
      damageAssessmentHours: "Constat de dommages (h)",
      userNumber: "N° ouvrier",
      workDone: "Travail effectué",
      materialUsed: "Matériel utilisé",
      deviceAssignmentNumber: "N° affectation",
      deviceType: "Type d’appareil",
      deviceId: "ID appareil",
      countingDeviceId: "ID compteur",
      electricityMeterType: "Type de compteur",
      meterStart: "Compteur début",
      meterEnd: "Compteur fin",
      consumption: "Consommation",
      fromDate: "Du",
      toDate: "Au",
      wallNumber: "N° mur",
      componentWidth: "Largeur composant",
      componentLength: "Longueur composant",
      componentHeight: "Hauteur composant",
      componentArea: "Surface composant",
      damageWidth: "Largeur dommage",
      damageLength: "Longueur dommage",
      damageHeight: "Hauteur dommage",
      damageArea: "Surface dommage",
    },
    biInfo: {
      notFound: "Aucune position de facturation trouvée dans le catalogue.",
      noCatalogReference: "Le PDE n’indique aucun catalogue, aucun texte LV n’est donc disponible.",
      catalogNotFound: "Aucun catalogue actif ne correspond à « {0} », aucun texte LV n’est donc disponible.",
      catalogAmbiguous: "Attention : {0} catalogues correspondent à « {1} ». Les textes affichés proviennent de « {2} ». Vérifie que c’est correct.",
      catalogLoadFailed: "Les textes LV n’ont pas pu être chargés.",
    },
  },
  beschreibungViewer: {
    title: "Description (Tâches)",
    loading: "Chargement de la description...",
    loadError: "Erreur lors du chargement des données",
    noStorageLocation: "Aucun chemin de fichier disponible",
    download: "Télécharger",
    sections: {
      projectInfo: "Infos projet",
      apartments: "Appartements",
      rooms: "Pièces",
      workItems: "Travaux",
      materials: "Matériaux",
      timeEstimate: "Estimation du temps",
      timeTracking: "Suivi du temps",
      buildingStructure: "Structure du bâtiment",
      workItemChanges: "Modifications des travaux",
      tasks: "Tâches",
    },
    fields: {
      projectId: "N° de projet",
      address: "Adresse",
      dateTime: "Date/Heure",
      lastName: "Nom",
      firstName: "Prénom",
    },
  },
  deviceDetailsDialog: {
    openProject: "Ouvrir projet",
  },
  deviceFilter: {
    active: "actif",
    available: "utilisable",
    finished: "terminé",
    inUsage: "en action",
    noAssignedToProject: "sans projet",
    notAvailable: "non disponible",
    overall: "total",
    overdue: "en retard",
  },
  deviceHistory: {
    externalMeterUsed: "Comptage externe",
    headerLabel: "Intervention {0}",
  },
  dryingHistory: {
    dryingHistoryDevice: "Historique de l’appareil {0}",
    formatDryingHistoryBox: "Historique de la Box {0}",
    formatDryingHistoryPanel: "Historique du Panel {0}",
    formatDryingHistoryWithChainNumber: "{0} Séchage {1}",
    notAvailable: "--- Historique non disponible ---",
  },
  dryingInfo: {
    assigned: "Associé",
    createDryingReport: "Rapport de séchage",
    day: "Jour",
    devicesAssinged: "Appareil associé",
    drying: "Séchage",
    endValue: "Fin",
    formatDurationClosedAssignment: "de {0} à {1} ({2})",
    formatDurationCompletedChain: "de {0} à {1} ({2})",
    formatDurationOpenAssignment: "depuis {0} ({1})",
    formatDurationOpenChain: "depuis {0} ({1})",
    formatMeterReading: "Début {0}, fin {1}, consommation {2}",
    formatMeterReadingActiveProject: "Début {0}",
    formatMeterReadingActiveRun: "Début {0}, actuel {1}, consommation {2}",
    formatMeterReadingConsumed: "Consommation {0}",
    formatMeterReadingEnd: "Fin {0}",
    formatMeterReadingStart: "Début {0}",
    formatPercentageDryingPause: "{0}, dont {1} % de pauses de séchage",
    formatRelativeAndAbsoluteChainNumber: "Séchage {0} ({1})",
    formatRelativeChainNumber: "Séchage {0}",
    groundTemp: "Température sol °C",
    heatRatioWall: "Intensité mur %",
    humidity: "Humidité",
    latestValue: "actuel",
    maxValue: "max",
    measurements: "Valeurs mesurées",
    minValue: "min",
    noProject: "Aucun projet",
    program: "Programme",
    project: "Projet {0}",
    resistanceDigits: "Digits",
    startValue: "Début",
    temp: "Temp",
    wallTemp: "Température mur °C",
  },
  dryingProjectOverview: {
    apartments: "1 appartement | {count} appartements",
    damagePatternCompletedItem: "{0} {1} ({2})",
    damagePatternConclusionStates: {
      carryOutDrying: "Exécuter séchage",
      noContract: "Aucun ordre",
      noDryingNecessary: "Aucun séchage nécessaire",
      yesOffer: "Oui, devis",
    },
    damagePatternItem: "{0} tableau des dommages ({1})",
    devices: "1 appareil | {count} appareils",
    dryingStartItem: "Début du séchage",
    plannedDamageAssessmentItem: "{0} relevé des dommages planifié ({1})",
    projectItemFinished: "Projet terminé",
    projectNoContract: "Projet terminé, aucun ordre",
    projectNoDryingNecessary: "Projet terminé, aucun séchage nécessaire",
    projectNumberItem: "{0} projet {1} ({2})",
    projectOnHold: "Projet suspendu",
    projectTitle: "Séchage : {0}",
    rooms: "1 pièce | {count} pièces",
  },
  hyDryEventLog: {
    date: "Date",
    deleteNote: "Supprimer note",
    event: "Événement",
    formatCycle: "Z{0}",
    formatPhase: "P{0}",
    formatStep: "S{0}",
    lid: "Capot",
    log: "Journal",
    logbook: "Journal",
    noLogs: "Le journal n’est pas encore disponible pour ce séchage.",
    note: "Note",
    pause: "Pause",
    program: "Programme",
    sortAscending: "Tri croissant",
    sortDescending: "Tri décroissant",
    step: "Étape",
  },
  hyDryEvents: {
    categories: {
      longDescription: {
        alert: "Alerte",
        drying: "Séchage",
        ires: "IRES",
        lid: "Capot",
        note: "Note",
        organisation: "Organisation",
        other: "Autres",
        pause: "Pause",
        sensor: "Capteur",
      },
      shortDescription: {
        alert: "Alerte",
        drying: "Séchage",
        ires: "IRES",
        lid: "Capot",
        note: "Note",
        organisation: "Orga",
        other: "Sinon",
        pause: "Pause",
        sensor: "Capteur",
      },
    },
    longDescription: {
      battery: "Batterie {0}%",
      checkDryingProgress: "Vérifier avancement du séchage",
      comBoxDryingCompleted: "Séchage terminé",
      deviceOverdue: "IdO en retard",
      dryingEnded: "Séchage terminé",
      dryingParametersChanged: "Paramètres de séchage modifiés",
      dryingPausedAfterPowerOn:
        "Alimentation électrique rétablie, séchage interrompu",
      dryingProgramDone: "Programme de séchage terminé",
      dryingProgramStarted: "Programme de séchage démarré",
      dryingProgramTerminated: "Programme de séchage clos",
      dryingProgressNotPlausible: "Déroulement du séchage non plausible",
      dryingQualityAssessment: "Évaluation de la qualité du séchage",
      dryingResumed: "Séchage repris",
      dryingResumedAfterPowerOn:
        "Alimentation électrique rétablie, reprise du séchage",
      dryingStartNotPlausible: "Début du séchage non plausible",
      dryingStarted: "Nouveau séchage commencé",
      dryingSucceed: "Séchage terminé",
      dryingSuspended: "Séchage suspendu",
      errorWhileDrying: "Erreurs de l’appareil pendant le séchage",
      firmware: "FW {0}",
      formatPowerFailWhileDrying:
        "Perte de courant pendant le séchage (plus de {0} h)",
      interruptedDryingEnded: "Séchage suspendu terminé",
      interruptedDryingResumed: "Séchage suspendu repris",
      lidClosed: "Capot fermé",
      lidOpened: "Capot ouvert",
      malfunction: "Erreur : {0}, aucun séchage",
      malfunctionWhileDrying: "Erreur : {0}, séchage en cours",
      manualPauseEnded: "Pause manuelle terminée",
      manualPauseStarted: "Pause manuelle démarrée",
      newDrying: "Commencer séchage",
      note: "Note",
      pauseEnded: "Pause terminée",
      pauseStarted: "Pause dans le séchage",
      powerFailWhileDrying: "Perte de courant pendant le séchage",
      poweredOff: "Débranché, aucun séchage",
      poweredOffWhileDrying: "Débranché en cours de séchage",
      poweredOn: "Branché",
      programCompleted: "Programme de séchage terminé",
      programPauseEnded: "Pause de programme terminée",
      programPauseStarted: "Pause de programme démarrée",
      programPhaseEnded: "Étape {0} du programme achevée",
      programStepCompleted: "Le séchage a achevé l’étape {0} du programme",
      prolongedPowerFail: "perte de courant prolongée",
      roomDryingHumidityVeryHigh: "Humidité de la pièce très élevée",
      roomDryingPauseEndendHumidityTargetReached:
        "L’air de la pièce est déshumidifié, pause terminée",
      roomDryingPauseEndendTemperatureTooHigh: "Température OK, pause terminée",
      roomDryingPauseStartedHumidityTargetReached:
        "Suffisamment déshumidifié, début de la pause",
      roomDryingPauseStartedTemperatureTooHigh:
        "Température trop élevée, pause commencée",
      roomDryingTemperatureVeryLow: "Température de la pièce très basse",
      rssi: "RSSI {0}",
      sensorBackInRange: "Capteur (Slot {0}) de nouveau à portée",
      sensorBatteryWeak: "Capteur (Slot {0}) : batterie faible",
      sensorButtonPressed: "Capteur (Slot {0}) : bouton actionné",
      sensorConfigurationChanged: "Configuration des capteurs modifiée : {0}",
      sensorConfigurationChangedWithEventNo:
        "Configuration des capteurs modifiée (événement {0}) :\n{1}",
      sensorConfigurationSnapshot:
        "Séchage démarré avec la configuration de capteurs : {0}",
      sensorOutOfRange: "Capteur (Slot {0}) hors de portée",
      sensorLinkGood: "Capteur (Slot {0}) : connexion ok",
      sensorLinkTimeout: "Capteur (Slot {0}) : délai de communication dépassé",
      sensorLinkTimeoutResolved:
        "Capteur (Slot {0}) : communication rétablie",
      sensorLinkWeak: "Capteur (Slot {0}) : connexion faible",
      sensorTurnedOff: "Capteur (Slot {0}) désactivé",
      successfulDryingEndend: "Séchage terminé clos",
      timerPauseEnded: "Pause nocturne terminée",
      timerPauseStarted: "Pause nocturne démarrée",
      turnedOff: "Éteint",
      turnedOn: "Allumé",
      unknownEvent: "Inconnu",
      warning: "Avertissement : {0}, aucun séchage",
      warningWhileDrying: "Avertissement: {0}, séchage en cours",
    },
    shortDescription: {
      battery: "Batterie {0}%",
      checkDryingProgress: "Vérifier avancement du séchage",
      comBoxDryingCompleted: "Séchage terminé",
      deviceOverdue: "IdO en retard",
      dryingEnded: "Séchage terminé",
      dryingParametersChanged: "Paramètres de séchage modifiés",
      dryingPausedAfterPowerOn: "Séchage suspendu",
      dryingProgramDone: "Programme de séchage",
      dryingProgramStarted: "Programme de séchage démarré",
      dryingProgramTerminated: "Programme de séchage clos",
      dryingProgressNotPlausible: "Vérifier déroulement du séchage",
      dryingQualityAssessment: "Évaluation de la qualité du séchage",
      dryingResumed: "Séchage repris",
      dryingResumedAfterPowerOn: "Séchage repris",
      dryingStartNotPlausible: "Vérifier déroulement du séchage",
      dryingStarted: "Séchage commencé",
      dryingSucceed: "Séchage terminé",
      dryingSuspended: "Séchage suspendu",
      errorWhileDrying: "Erreur de l’appareil",
      firmware: "FW {0}",
      formatPowerFailWhileDrying: "Perte de courant (> {0} h)",
      interruptedDryingEnded: "Séchage terminé",
      interruptedDryingResumed: "Séchage repris",
      lidClosed: "Capot fermé",
      lidOpened: "Capot ouvert",
      malfunction: "Erreur : {0}, aucun séchage",
      malfunctionWhileDrying: "Erreur : {0}, séchage en cours",
      manualPauseEnded: "Pause manuelle terminée",
      manualPauseStarted: "Pause manuelle démarrée",
      newDrying: "Commencer séchage",
      note: "Note",
      pauseEnded: "Pause terminée",
      pauseStarted: "Pause commencée",
      powerFailWhileDrying: "Perte de courant",
      poweredOff: "Débranché, aucun séchage",
      poweredOffWhileDrying: "Débranché en cours de séchage",
      poweredOn: "Branché",
      programCompleted: "Programme de séchage terminé",
      programPauseEnded: "Pause de programme terminée",
      programPauseStarted: "Pause de programme démarrée",
      programPhaseEnded: "Étape {0} du programme achevée",
      programStepCompleted: "Séchage : étape du programme achevée.",
      prolongedPowerFail: "perte de courant prolongée",
      roomDryingHumidityVeryHigh: "Humidité de la pièce très élevée",
      roomDryingPauseEndendHumidityTargetReached:
        "L’air de la pièce est déshumidifié, pause terminée",
      roomDryingPauseEndendTemperatureTooHigh: "Température OK, pause terminée",
      roomDryingPauseStartedHumidityTargetReached:
        "Suffisamment déshumidifié, début de la pause",
      roomDryingPauseStartedTemperatureTooHigh:
        "Température trop élevée, pause commencée",
      roomDryingTemperatureVeryLow: "Température de la pièce très basse",
      rssi: "RSSI {0}",
      sensorBackInRange: "Capteur (Slot {0}) de nouveau à portée",
      sensorBatteryWeak: "Capteur (Slot {0}) : batterie faible",
      sensorButtonPressed: "Capteur (Slot {0}) : bouton actionné",
      sensorConfigurationChanged: "Configuration des capteurs modifiée : {0}",
      sensorConfigurationChangedWithEventNo:
        "Configuration des capteurs modifiée (événement {0}) :\n{1}",
      sensorConfigurationSnapshot:
        "Séchage démarré avec la configuration de capteurs : {0}",
      sensorOutOfRange: "Capteur (Slot {0}) hors de portée",
      sensorLinkGood: "Capteur (Slot {0}) : bonne connexion",
      sensorLinkTimeout: "Capteur (Slot {0}) : délai de communication dépassé",
      sensorLinkTimeoutResolved:
        "Capteur (Slot {0}) : communication rétablie",
      sensorLinkWeak: "Capteur (Slot {0}) : connexion faible",
      sensorTurnedOff: "Capteur (Slot {0}) désactivé",
      successfulDryingEndend: "Séchage terminé",
      timerPauseEnded: "Pause nocturne terminée",
      timerPauseStarted: "Pause nocturne démarrée",
      turnedOff: "Éteint",
      turnedOn: "Allumé",
      unknownEvent: "Inconnu",
      warning: "Avertissement : {0}, aucun séchage",
      warningWhileDrying: "Avertissement: {0}, séchage en cours",
    },
  },
  iresDevice: {
    deviceAssignedToProject: "Appareil associé à un projet",
    deviceInUsage: "Appareil en cours d’utilisation",
    deviceNotAvailable: "L’appareil est associé à une autre filiale.",
    formatBatteryStatus: "{0} V, note {1}",
    moveDevicesButtonText: "Déplacer appareils",
    moveDevicesDialog: {
      assignmentStartDate: "à partir de la date",
      branch: "Site",
      client: "Filiale",
      errorMessage: "Impossible de déplacer les appareils",
      successMessage:
        "1 appareil déplacé avec succès | {count} appareils déplacés avec succès",
      title: "Déplacer appareils",
    },
  },
  iresDeviceDetail: {
    comBoxDoesNotExist: "Il n’existe aucune HyDry Box avec le numéro de série {0}.",
    panelDoesNotExist: "Il n’existe aucun HyDry Panel avec le numéro de série {0}.",
    neverReportedSince: "{0} a été créé le {1}, mais ne s’est encore jamais connecté.",
    neverReported: "{0} a été créé, mais ne s’est encore jamais connecté.",
    warningCheckProjectAssignment: "Vérifier période d’association du projet",
    warningNoProgramChainsInClosedAssignment:
      "Cette association ne contient aucun séchage",
  },
  iresDeviceSensor: {
    floorSensor1: "Capteur1",
    floorSensor2: "Capteur2",
    floorSensor3: "Capteur3",
    floorSensor4: "Capteur4",
    ground: "Sol",
    guideSensor: "Guide",
    humidity: "Humidité",
    resistanceDigits: "Digits",
    intensity: "Intensité",
    intensityAndRelativeHumidityAndPressure: "Intensité/humidité rel./pression",
    roomSensor: "Pièce",
    temperature: "Température",
    wall: "Mur",
  },
  iresDeviceType: {
    box: "Box HyDry",
    edge: "HyDry Edge",
    formatHyDryBox: "Box HyDry {0}",
    formatHyDryMini: "HyDry Mini {0}",
    formatHyDryPanel: "Panel HyDry {0}",
    mini: "HyDry Mini",
    panel: "Panel HyDry",
    slim: "HyDry Slim",
  },
  joinSharedEmailAddress: {
    errorWrongPassword: "Mot de passe non valide",
    formatMessage:
      "L’adresse e-mail {0} est partagée par un autre utilisateur. Veuillez saisir le mot de passe de l’adresse e-mail partagée.",
    title: "E-mail partagé",
  },
  language: {
    de: "Allemand",
    en: "Anglais",
    fr: "Français",
    it: "Italien",
  },
  leakDetectionProjectOverview: {
    conclusion: "Fin",
    leakDetection: "Détection de fuites",
    projectCreation: "Nouveau projet",
    projectItemFinished: "Projet terminé",
    projectTitle: "Détection de fuites : {0}",
  },
  location: {
    addressEdited: "Adresse modifiée. Clique pour rechercher la position à nouveau.",
    ambiguous:
      "Cette adresse correspond à {0} lieux possibles. Choisis le bon dans la liste de suggestions ou place le point toi-même.",
    backfilled: "Code postal et ville repris de l’adresse trouvée : {0}",
    confidence: {
      CONFIRMED: "Adresse confirmée",
      GOOD: "Localisé automatiquement, bonne qualité",
      POOR: "Localisé automatiquement, qualité médiocre",
      UNRELIABLE: "Aucune position exploitable",
    },
    crossCheckMismatch:
      "La position trouvée correspond à une autre adresse que celle que tu as saisie. Vérifie-la sur la carte.",
    geocodingFailed: "L’adresse est introuvable. Place le point toi-même sur la carte.",
    legend: {
      CONFIRMED: "confirmée",
      GOOD: "bonne",
      POOR: "imprécise",
      UNRELIABLE: "inutilisable",
      title: "Couleurs",
    },
    lookingUp: "Recherche de la position …",
    mapLoadFailed: "La carte n’a pas pu être chargée.",
    noAddress: "Saisis au moins une ville, une rue ou un code postal.",
    pickerHint:
      "Déplace le point ou clique sur la carte pour définir la position exacte. La position est enregistrée pour les fonctions de trajet, l’adresse que tu as saisie reste inchangée.",
    pickerHintReadonly: "Position de l’adresse.",
    pickerTitle: "Position",
    quality: {
      APPROXIMATE: "Afficher sur la carte (emplacement approximatif)",
      GEOMETRIC_CENTER: "Afficher sur la carte (centre de la rue ou de la localité)",
      MANUAL: "Afficher sur la carte (placé à la main)",
      RANGE_INTERPOLATED: "Afficher sur la carte (numéro estimé)",
      ROOFTOP: "Afficher sur la carte (bâtiment exact)",
      none: "Pas encore localisé. Afficher sur la carte",
      unknown: "Afficher sur la carte (précision inconnue)",
    },
    search: {
      hint: "Saisis l’adresse et choisis la suggestion correspondante.",
      label: "Rechercher une adresse",
      noResults: "Aucune suggestion trouvée.",
    },
  },
  login: {
    clientHandover: {
      opening: "Ouverture en tant que mandant …",
      failed: "La connexion en tant que mandant a échoué. Ferme cet onglet et réessaie dans IRES Admin Client.",
      refused: "La connexion en tant que mandant a été refusée. {0} Ferme cet onglet.",
    },
    backToLogin: "Retour à la connexion",
    clientPortal: "Portail client HyDry",
    clientPortalEmail: "Adresse e-mail portail",
    emailAddress: "Adresse e-mail",
    forgotPassword: "Mot de passe oublié",
    forgotUserPassword: "Mot de passe utilisateur oublié ?",
    forgotUserPasswordMessage:
      "Contacte ton administrateur ou écris-nous à support@hydry.de",
    login: "Connecter",
    loginContactEmail: "E-mail support@hydry.de",
    loginContactText:
      "Si, en tant que partenaire, tu n’es pas enregistré pour l’utilisation, fais-le-nous savoir par e-mail.",
    loginFailed:
      "Échec de connexion. Vérifie ton adresse e-mail et ton mot de passe.",
    loginFailedBlocked:
      "Échec de connexion. L’utilisateur avec l’adresse e-mail {0} est verrouillé.",
    signInRefused: {
      CLIENT_BLOCKED: "Connexion impossible. L’accès de ton entreprise est verrouillé. Contacte IRES.",
      USER_BLOCKED: "Connexion impossible. Ton utilisateur est verrouillé. Contacte un administrateur.",
    },
    loginWelcomeText: "Connecte-toi.",
    loginWelcomeTitle: "Gestion des appareils HyDry et télécommande",
    networkBlocked: "Connexion bloquée. Vérifie tes paramètres de proxy ou de VPN et réessaie.",
    noInternetAvailable: "Pas de connexion Internet. Vérifie ta connexion réseau et réessaie.",
    passowrdEmailSharing: "Mot de passe",
    password: "Mot de passe",
    passwordResetEmailAlreadySent:
      "Un e-mail de réinitialisation de ton mot de passe a déjà été envoyé. Vérifie ta boîte de réception et, si besoin, ton dossier de courrier indésirable.",
    passwordResetEmailError:
      "Une erreur s’est produite lors de l’envoi de l’e-mail de réinitialisation de ton mot de passe. Réessaie.",
    passwordResetEmailSent:
      "L’e-mail de réinitialisation de ton mot de passe a bien été envoyé.",
    passwordResetSharedEmailError:
      "Le mot de passe d’un utilisateur partagé ne peut pas être réinitialisé. Contacte l’administrateur système.",
    pleaseSignIn:
      "Indique ton identifiant utilisateur et ton mot de passe",
    pleaseSignInWithEmail: "Indique ton adresse e-mail",
    resetPassword: "Réinitialiser le mot de passe",
    sessionEnd: "Tu t’es connecté sur un autre appareil.",
    unknownEmailAddress:
      "Connexion au portail HyDry pour {0} : l’adresse e-mail {1} est introuvable. L’utilisateur est-il créé correctement ?",
    userIdentification: "Identifiant utilisateur",
  },
  messageSettings: {
    erp: "ERP",
    erpConnection: "Connexion ERP",
    filterAll: "Filtre total",
    filterMyProject: "Messages des projets",
    filterNoProject: "Filtre projet",
    logCategories: "Classes de Journal",
    logCategoriesTotal: "Classes de journal total",
    mailboxes: "Boîtes de réception",
    messages: "Messages",
    organisationCapability: "Tâche d’organisation",
    organisationRole: "Rôle d’organisation",
    projectRole: "Rôle de projet",
    selectLogCategories: "Sélection des classes de journal",
    showMessagesToProjectOwners: "à responsable",
    showMessagesToProjectSupervisors: "à chef de projet",
  },
  messages: {
    details: {
      currentProject: "Projet actuel",
      device: "Appareil",
    },
    formatDrying: "Séchage {0}",
    formatMessagesTitle: "Nouveaux messages ({0})",
    formatMoreMessages: "+{0}",
    formatNewMessages: "{0} total",
    formatNewMessagesForCapability: "{0} à {1}",
    formatNewMessagesForMailbox: "{0} nouveau(x) à la boîte {1}",
    formatNewMessagesForMe: "{0} à moi",
    formatNewMessagesForRole: "{0} à {1}",
    formatNumNewMesssages: "1 nouveau message | {count} nouveaux messages",
    markAsRead: "Lu",
    message: "Message",
    messages: "Messages",
    newMessages: "total",
    newMessagesForCapability: "à {0}",
    newMessagesForMailbox: "à boîte de réception {0}",
    newMessagesForMe: "à moi",
    newMessagesForRole: "à {0}",
    noMessagesFound: "--- aucun message trouvé ---",
    sortBy: {
      messageDate: "Dernier",
      projectNumber: "Numéro de projet",
      serialNumber: "Numéro de série",
    },
    yesterday: "hier",
  },
  openProgramChainDecision: {
    confirmReleaseMessage:
      "Déconnexion au {0}. Le séchage {1} sera associé. Corriger le relevé du compteur de fin si nécessaire.",
    decide: "Veuillez décider",
    deleteAssignment: "Supprimer association",
    message:
      "Un séchage est en cours au {0} (séchage {1}, commencé le {2}). Êtes-vous sûr de vouloir déconnecter l’association au {3} ? Le séchage en cours sera alors terminé et l’état du compteur électrique peut être ajusté si nécessaire.",
    noProgramChainsFoundInAssignmentRange:
      "Aucun séchage associable trouvé au sein de la période de l’association. Déconnecter quand même l’association ?",
    openProgramChain: "Séchage en cours",
    recentlyActiveDeviceWarning:
      "Sinon, vous devez ANNULER et sélectionner une autre date de déconnexion.",
    release: "Déconnecter",
    releaseDescription: "Déconnecter quand même",
    stop: "Stop",
    stopBoxMessage: "Terminer séchage avec Box {0} ?",
    stopCommandQueuedMessage:
      "Commande STOP via IdO notée. Souhaitez-vous patienter ou déconnecter maintenant ?",
    stopDescription: "Terminer séchage maintenant ?",
    stopDrying: "Terminer séchage",
    stopPanelMessage: "Terminer séchage avec Panel {0} ?",
    wait: "Patienter",
    waitDescription: "Patienter jusqu’à la fin du séchage",
  },
  notFound: {
    message: "Cette page n’existe pas (ou plus).",
    toCockpit: "Vers le Cockpit",
  },
  overview: {
    active: "actif",
    activeProjects: "Projets actifs",
    availableIresDevices: "Appareils HyDry disponibles",
    default: "HyDry MANAGER",
    deviceTypeHyDryComBoxes: "Box HyDry",
    deviceTypeHyDryPanels: "Panels HyDry",
    deviceTypes: "1 type d’appareil | {count} types d’appareils",
    devices: "1 appareil | {count} appareils",
    devicesOnlyWebsite: "Portail HyDry ",
    error: "Erreur",
    finished: "terminé",
    inUsage: "en action",
    iotClientPortal: "Portail client HyDry",
    manageDevices: "Gérer appareils",
    manageProjects: "Gérer projets",
    overall: "total",
    overdue: "en retard",
    projectManagement: "Gestion de projet",
    projectOption: "HyDry OPTION",
    recentlyFinished: "clos",
    warning: "Avertissement",
    website: "HyDry PORTAL",
    withDevice: "dont avec appareils HyDry",
  },
  pages: {
    allDevices: "Tous les appareils",
    cockpit: "Cockpit",
    createProject: "Créer projet",
    devices: "Appareils HyDry",
    help: "À propos",
    maps: "Cartes",
    mira: "Mira",
    messages: "Messages",
    notFound: "Page introuvable",
    overview: "Aperçu",
    panelDetails: "Détails Panel",
    projectDetails: "Détails du projet",
    projects: "Projets",
    scheduling: "Planning d’interventions",
    settings: "Réglages",
    aiPredictions: "RENO",
    users: "Utilisateur",
    timeTrackingHistory: "Suivi du temps",
  },
  panel: {
    events: {
      event: "Événement {0}",
      event0: "Échantillon de données chaque minute",
      event1: "Allumé",
      event10: "Fin du programme (dernière étape)",
      event11: "Fin du programme (durée maximale)",
      event12: "Fin du programme (part du chauffage)",
      event13: "Fin du programme (manuel)",
      event13Log: "Séchage manuel terminé",
      event14: "Phase de refroidissement interrompue",
      event15: "Reprise du séchage",
      event16: "Durée de séchage max. atteinte",
      event18: "Étape terminée",
      event19: "Redémarrage manuel",
      event1Log: "Panel allumé",
      event2: "Prise retirée",
      event20: "Temps de chauffage maximal dépassé",
      event20Warning: "Avertissement : temps de chauffage maximal dépassé",
      event21: "Avertissement : capteur de position déclenché",
      event22: "Température du sol max. atteinte",
      event24: "Dépassement de la température (85 °C)",
      event24Log: "Dépassement de la température sur mur et / ou sol",
      event25: "Température du boîtier trop élevée",
      event255: "Inconnu",
      event25Log: "Dépassement de la température dans boîtier du Panel",
      event26: "Température de la puce du capteur max. atteinte",
      event27: "Température max. de la puce du capteur Edge atteinte",
      event28: "Panneau de chauffage allumé",
      event28Log:
        "Panneau de chauffage (mural) à nouveau actif après une surchauffe.",
      event29: "Panneau de chauffage au sol allumé.",
      event29Log:
        "Panneau de chauffage (sol) à nouveau actif après une surchauffe",
      event2Log: "Débranché en cours de séchage",
      event3: "Redémarrage après interruption du réseau / réinitialisation",
      event30: "NB1 Échec de connexion au réseau",
      event31: "NB1 Connexion au réseau établie",
      event32: "NB1 Échec de connexion au serveur",
      event33: "NB1 Connexion au serveur établie",
      event34: "NB1 Expiration de la connexion",
      event35: "NB1 Connexion terminée (0) (fermer session)",
      event36: "NB1 Connexion terminée (1) (rétablir)",
      event37: "NB1 Connexion terminée (2) (expiration du délai d’attente)",
      event39: "NB1 non disponible",
      event39Log: "NB1 Modem désactivé",
      event4: "Démarrage automatique",
      event48: "DATALOG_EVT_MIN_MALFUNCTION",
      event49: "DATALOG_EVT_POSITION",
      event5: "Démarrage manuel",
      event50: "Erreur : impossible d’initialiser l’EEPROM.",
      event51: "Erreur : la configuration de l’appareil est erronée.",
      event52: "Erreur : impossible d’initialiser SPI-Flash.",
      event53:
        "'Erreur : Datalog incohérent (\"Système de fichiers défectueux\")'",
      event54: "Erreur : impossible d’initialiser RTCC.",
      event55:
        "Erreur : l’heure de l’appareil n’est pas correcte ou l’horloge n’est pas réglée.",
      event56:
        "Erreur : le convertisseur ADC du MCU est défectueux ou fournit des valeurs erronées.",
      event57: "Erreur : un des capteurs IR est défectueux.",
      event59:
        "Erreur : le compteur d’énergie est défectueux ou délivre des valeurs erronées.",
      event5Log: "Démarrage manuel du séchage",
      event6: "Démarrage après retard à l’allumage",
      event60:
        "Erreur : la consommation de courant ne correspond pas à l’état de fonctionnement.",
      event61: "Erreur : table de programme non valide.",
      event62:
        "L’arrêt de sécurité (alarme de température du matériel) s’est déclenché.",
      event63:
        "Erreur : le capteur d’accélération pour la détection de la position est défectueux.",
      event64: "Erreur : module BLE",
      event65: "Erreur : module NB1",
      event66: "DATALOG_OUT_OF_TIME",
      event68: "Mise à jour du firmware démarrée",
      event69: "Firmware mis à jour",
      event6Log: "Démarrage du programme après WAIT",
      event7: "Démarrage après avoir atteint la température de base",
      event70: "Mesure de la batterie",
      event71: "Chauffage éteint",
      event71Log:
        "Surveillance de la puissance active : veuillez vérifier l’alimentation électrique !",
      event72: "Chauffage allumé",
      event72Log:
        "Surveillance de la puissance terminée : alimentation électrique correcte.",
      event73:
        "Réduction de la puissance en raison de variations de la tension d’alimentation.",
      event74: "Variations de la tension d’alimentation",
      event75: "Tension d’alimentation stable",
      event76: "NB1 État en cas de panne de courant",
      event8: "Événement de l’étape",
      event80: "Redémarrage pour la mise à jour de la configuration",
      event81: "Redémarrage pour la mise à jour du firmware",
      event82: "Heure réinitialisée",
      event9: "Démarrer le programme de suivi",
      event90: "Dépassivation début",
      event91: "Dépassivation fin",
    },
  },
  panelControl: {
    confirmCancelQueuedRequestMessage:
      "Êtes-vous sûr de ne pas vouloir exécuter l’action notée ?",
    confirmCancelQueuedRequestTitle: "Arrêter action notée",
    executingCommandImmediatly:
      "La communication est établie via IdO. Cela peut durer un moment.",
    executingCommandNextIotConnection:
      "L’instruction sera exécutée lors de la prochaine connexion IdO.",
    programSelection: "Sélection programme",
    queuedRequestFactoryReset: "Réinitialisation via IdO notée",
    queuedRequestPause: "Pause via IdO notée",
    queuedRequestPowerChangeDryRun: "Modifier via IdO noté",
    queuedRequestPowerOffComBox: "Éteindre via IdO noté",
    queuedRequestPowerOnComBox: "Allumer via IdO noté",
    queuedRequestPowerStartDryRun: "Démarrage via IdO noté",
    queuedRequestRelayTest: "Test de relais via IdO noté",
    queuedRequestRestartPanel: "Redémarrage via IdO noté ",
    queuedRequestResume: "Reprise via IdO notée",
    queuedRequestSelectProgram: "Démarrage de P {0} via IdO noté",
    queuedRequestStartPanel: "Démarrage via IdO noté",
    queuedRequestStopPanel: "Arrêt via IdO noté ",
    queuedRequestTerminate: "Terminer séchage via IdO noté",
    queuedRequestUpdateIotConfig: "Mise à jour IdO config via IdO notée",
    start: "Démarrer",
    startPanelTitle: "Démarrer Panel {0} avec P {1} {2}",
    startQueued: "Démarrage noté",
    stopPanelTitle: "Arrêter Panel {0}",
    stopQueued: "Arrêt noté",
  },
  panelDetail: {
    actions: {
      closeProgramChainText: "Séchage de {0} à",
      endDrying: "Terminer séchage",
      history: "Historique",
      notes: "Notes",
      programChooser: "Sélection programme",
      progress: "Progression",
      restart: "Redémarrage",
      graph: "Graphique",
      runs: "Courses",
      setComBoxOffline: "Déconnecter Box",
      setHyDryDeviceOffline: "Déconnecter appareil HyDry",
      setPanelOffline: "Déconnecter Panel",
      setPanelOfflineMessage:
        "Veuillez spécifier la date d’extinction du Panel",
      startPanel: "Début",
      stopPanel: "Stop",
    },
    connectReason: "Connect Reason",
    connectReasonDescriptions: {
      0: "INCONNU",
      1: "Alimentation allumée",
      2: "périodique",
      3: "Nouvelle course",
      4: "Étape terminée",
      5: "Alimentation éteinte",
      6: "Avertissement",
      7: "Erreur",
      8: "BLE déconnecté",
      9: "Tentative de session",
      10: "Reconnect",
    },
    coooling: "Refroidir",
    disconnected: "Coupé",
    drying: "Séchage",
    dryingPhaseInfo: {
      error: "Erreur",
      program0: "Phase de clôture",
      program1ToProgram7: "Séchage actif",
      warning: "Avertissement",
    },
    dryingProgram: "Programme de séchage",
    dryingProgressGraph: {
      formatTemperature: "{0} °C",
      temperature: "Température",
    },
    dryingProgressGraphControl: {
      formatDrying: "Séchage {0}",
      groundTemp: "Température sol",
      log: "Journal",
      new: "Nouveau",
      next: "Séchage >",
      nextShort: ">",
      overview: "Total",
      previous: "< Séchage",
      previousShort: "<",
      rateDrying: "Qualité",
      single: "Individuellement",
      wallTemp: "Température mur",
    },
    event: "Événement",
    formatChainAndProgram: "Séchage {0} / programme {1}",
    formatDryingProgram: "P{0}",
    formatDryingProgramWithName: "P{0} : {1}",
    formatHeatRatio: "{0}%",
    formatHeatRatioAndRelativeHumidityAndPressure: "{0}% / {1}% / {2}hPa",
    formatHeatRatioWithLabel: "Intensité : {0}%",
    formatTemperatureGround: "Sol : {0} °C",
    formatTemperatureWall: "Mur : {0} °C",
    formatTemperatureWallAndGround: "Mur : {0} °C / sol : {1} °C",
    formatTemperatureWallAndGroundMax: "Mur max {0} °C / sol max {1} °C",
    formatTemperatureWallMax: "Mur max {0} °C",
    heatRatio: "Intensité",
    heating: "Échauffement",
    heatingInfo: "FirstTime/FHR/HR/CR/HRatio",
    idle: "Contrôle de la température",
    lastEvent: "Dernier événement",
    lastInfo: {
      current: "actuel",
      days: "il y a 1 jour | il y a {count} jours",
      hours: "il y a {0} h",
      lastPing: "PING {0}",
      lastPingCurrent: "PING actuel",
      minutes: "il y a {0} min",
    },
    lastInformation: "Dernière Information",
    lastMeterReading: "dernier relevé {0}",
    malfunction: "Erreur",
    maxTemperature: "Température max",
    meterReading: "Relevé du compteur",
    meterReadingByUser: "Consommation d’électricité relevée (kWh)",
    metereReadingStartEnd: "Début {0}, fin {1}",
    noActiveProgramChainWarning: "Aucun séchage actif",
    noData: "aucune donnée",
    noInfoAvailable: "aucune information disponible",
    noProgramChainFound:
      "Aucun séchage trouvé dans le créneau de cette association.",
    numDryings: "1 séchage | {count} séchages",
    numRuns: "Courses",
    operatingStatus: "État de fonctionnement",
    powerConsumption: "Consommation électrique",
    powerFail: "Prise retirée",
    powerUp: "Démarré",
    progStepCycle: "Prog/étape/cycle",
    runInfo: {
      duration: "Durée : {0}",
      durationActiveRun: "Données: {0} de {1}",
      formatRunProgramInfo: "T {0} / Course {1} / {2}",
      heatingPercentageAndPowerConsumption: "{0}% chauffé, {1} kWh",
      programDescription: "T {0} / P {1}",
      programDescriptionIdle: "T {0} / P 0 Contrôle de la température",
      programMonitor: "Moniteur",
      programP0: "Contrôle de la température",
      programPX: "P{0}",
      runAssigned: "{0} du {1} - {2}",
      runAssignedOpenEnded: "{0} depuis {1}",
      runDescription: "Course {0} de {1} à {2}",
      runDescriptionActive: "Course {0} depuis {1} {2}",
      runDescriptionAdjusted: "Course {0} de {1} à {2}*.",
      runDescriptionSingleDay: "Course {0} au {1} à {2}",
      runDescriptionSingleDayAdjusted: "Course {0} au {1} à {2}*.",
      runNoProject: "Aucun projet",
      runNotAssigned: "Non associé",
      stepsAndCycles: "Étapes/cycles : {0}/{1}",
      t0: "T0 : {0}m",
      temperatureGroundAndWall: "Mur : {0}-{1} °C / sol : {2}-{3} °C",
      temperatureWall: "Mur : {0}-{1} °C",
    },
    runTime: "Durée",
    runningSince: "Séchage en cours",
    source: {
      ble: "BLE",
      iot: "IdO",
    },
    step: "Étapes",
    temperature: "Température",
    title: "Détails Panel {0}",
    waiting: "Patienter",
    warning: "Avertissement",
  },
  panelList: {
    activeFilters: "--- Filtres actifs : {0} ---",
    description: "Gestion des appareils HyDry",
    devicesOfProject: "'État de l’appareil projet \"{0}\"'",
    filterActiveDevices: "appareils actifs",
    filterAllDevices: "tous les appareils",
    filterDevicesOverdueDevices: "appareils en retard",
    filterDevicesWithWarningOrError: "Appareils avec avertissement/erreur",
    filterFinishedDevices: "appareils terminés",
    filterInUsage: "Appareils en action",
    filterNotAssignedToProject: "Appareils sans projet",
    hint: "Sélectionner appareil par un clic",
    hyDryDevicesOverview: "Aperçu appareils",
    manageHyDryDevices: "Gérer appareils",
    noDevicesFound: "--- aucun appareil trouvé ---",
    ownComBoxes: "Afficher ses propres appareils",
    sortByDryingStart: "Début du séchage",
    sortByInventoryNumber: "Numéro d’inventaire",
    sortByProject: "Projet",
    sortBySerialnumber: "Numéro de série",
    sortByStatus: "État",
    testBoxes: "Afficher le test des Box",
  },
  panelSettings: {
    configName: "Configuration",
    firmwareIPU: "Firmware IPU",
    restartConfirmMessage: "Le redémarrage est noté via IdO.",
    restartConfirmTitle: "Redémarrer le panel {0} ?",
    title: "Réglages Panel {0}",
  },
  pdfReport: {
    device: "Appareil",
    deviceNumber: "N°",
    end: "Fin",
    finalReport: "Séchage technique : rapport final",
    formatPowerConsumption: "Consommation : {0}",
    formatProjectName: "Projet {0}",
    from: "de",
    hyDryDevicesUsgae: "Utilisation des appareils HyDry",
    hyDryDryingInfo: "Données de séchage HyDry",
    intermediateReport: "Séchage technique: rapport d’avancement",
    meterNumber: "N° de compteur",
    noHyDryDevicesUsed: "Aucun appareil HyDry n’a été associé à ce projet.",
    powerConsumption: "Consommation",
    start: "Début",
    sumPowerConsumption: "Consommation totale",
    until: "à",
  },
  pickerDialog: {
    noSelection: "Aucune sélection",
  },
  programChainNote: {
    createNoteTitle: "Créer commentaire",
    deleteNoteConfirmationDialogMessage:
      "Êtes-vous sûr de vouloir supprimer ce commentaire?",
    deleteNoteConfirmationDialogTitle: "Supprimer commentaire",
    note: "Commentaire +",
    notePlus: "Commentaire +",
    noteSaved: "Commentaire sauvegardé",
  },
  projectConclusion: {
    concludeProject: "Clore projet",
    concludeProjectMessage: "Clore le projet {0} et créer un rapport final ?",
    createFinalReport: "Créer rapport intermédiaire",
    createFinalReportButton: "Créer rapport final",
    createInterimReport: "Créer rapport intermédiaire",
    createReport: "Créer rapport",
    description: "Clore le projet et déconnecter les appareils HyDry",
    formatProjectFinished: "Clos le {0} par {1}",
    projectConcluded: "Projet clos",
    projectDuration: "Durée du projet",
    releaseFinalReport: "Valider rapport final",
    reopenProject: "Réouvrir projet",
    reopenProjectMessage: "Êtes-vous sûr de vouloir rouvrir le projet ?",
    sendFinalReport: "Valider rapport final",
    signOffAllDevices: "Déconnecter tous les appareils",
    signOffAllHyDryDevices: "Déconnecter tous les appareils HyDry",
    signOffAllDevicesMessage: "Déconnecter tous les appareils HyDry de ce projet ?",
    signOffAllDevicesSuccess: "Tous les appareils HyDry déconnectés",
  },
  projectDetails: {
    createNote: "Créer note",
    documents: "Documents",
    erp: "ERP",
    meterReadingStart: "Compteur d’électricité début : {0}",
    noDevicesAssigned: "--- aucun appareil associé ---",
    note: "Note",
    notes: "Notes",
    powerConsumption: "Consommation: {0}",
    project: "Projet",
    projectConclusion: "Clôture du projet",
    projectConclusionShort: "Clôture",
    projectNameAlreadyExistsMessage:
      "Il existe déjà un projet portant le nom que vous avez sélectionné. Sauvegarder quand même ?",
    projectNameAlreadyExistsTitle: "Le nom du projet existe déjà",
    projectNumberAlreadyExists: "Numéro de projet déjà existant",
    reports: "Rapports",
    timeLine: "Barre de temps",
    updateNote: "Éditer note",
  },
  projectList: {
    activeFilters: "--- Filtres actifs : {0} ---",
    description: "Gestion des projets de séchage",
    filterAllProjects: "tous les projets",
    filterOverdue: "en retard",
    filterRecentlyFinished: "clos",
    filterWithDevices: "avec appareils HyDry",
    finishedProjects: "Projets terminés",
    hint: "Sélectionner projet par un clic, créer projet en cliquant sur +.",
    hintWithoutOptionToCreate: "Sélectionner projet par un clic",
    newestProjets: "Derniers projets",
    noProjectsFound: "--- aucun projet trouvé ---",
    numAllDevices: "{0}/{1} appareils actifs",
    numAllDevicesAllActive: "1 appareil actif | {count} appareils actifs",
    numAllDevicesNoneActive: "1 appareil | {count} appareils",
    numApartments: "1 logement | {count} logements",
    numRooms: "1 pièce | {count} pièces",
    oldestProjects: "Projets les plus anciens",
    overdueProjects: "projets en retard",
    projectFinished: "Projet terminé",
    projectNumber: "Numéro de projet",
    projectProgress: "Progression du projet",
    recentProjects: "projets actuels",
    relevantProjectsTitle: "Projets pertinents",
    showFinishedProjects: "Afficher projets terminés",
    showFinishedProjectsShort: "terminés",
    showRecentProjects: "Afficher projets actuels",
    showRecentProjectsShort: "Actuels",
    title: "Tous les projets",
    types: {
      archived: "Anciens",
      deleted: "Supprimés",
      finished: "Terminés",
      running: "En cours",
    },
    urgency: "Degré d’urgence",
  },
  projectOverview: {
    recordedByItem: "{0} {1} ({2})",
  },
  projectStateFilter: {
    allProjects: "Projet | Projets",
    assignDevices: "associer appareils",
    concludeProjekt: "Clore projet",
    damageAssessment: "relevé(s) des dommages",
    drying: "séchage(s)",
    dryingConclusion: "démontage(s) du séchage",
    dryingSetup: "montage(s) du séchage",
    followUpInspection: "ressoumission(s)",
    insuranceOffer: "devis à l’assurance",
    intermediateMeasurement: "mesure(s) de l’avancement",
    leakDetection: "détection de fuites",
    missingDryingApproval: "autoriser séchage | autoriser séchages",
    missingFirstContact: "prise de contact | prises de contact",
    missingProjectApproval: "Confirmer le projet | Confirmer les projets",
    missingProjectConclusion: "Clôture du projet | Clôtures du projet",
    missingProjectOwner: "sans responsable",
    missingProjectSupervisor: "sans chef de projet",
    missingReport: "sans rapport",
    new: "nouveau(x)",
    overall: "total",
    overdue: "en retard",
    ownProjects: "propre projet | propres projets",
    projectSupervisor: "projet responsable | projets responsables",
    recentlyFinished: "clos récemment",
    repair: "restauration(s)",
    withHyDryDevices: "avec appareils HyDry",
  },
  projectStatus: {
    acceptOrder: "Confirmer projet ?",
    actionAcceptOrder: "Confirmer projet",
    actionRejectOrder: "Refuser projet",
    allApartments: "Tous les appartements",
    approvalStatus: "État autorisation : {0}",
    approvalStatuses: {
      noDryingNecessary: "aucun séchage nécessaire",
      yesExecute: "Oui, réaliser",
      yesOffer: "Oui, devis",
    },
    controlMeasurement: "Fin mesure de contrôle",
    csvTrades: "Métiers",
    damageDescription: "Description du dommage: {0}",
    dateTime: "Date/heure",
    downloadExternalReport: "Rapport externe",
    downloadInternalReport: "Rapport interne",
    downloadReport: "Rapport",
    dryingAreaFloor: "Surface sol (m²)",
    dryingAreaWallCeiling: "Surface mur / plafond (m²)",
    dryingDuration: "Durée de séchage (jours)",
    formatAppointment: "Rendez-vous : {0}",
    formatDryingDuration:
      "Durée de séchage : 1 jour | Durée de séchage : {count} jours",
    formatEstimatedDryingDuration:
      "Durée de séchage estimée 1 jour | Durée de séchage estimée {count} jours",
    formatDryingAreaFloor: "Sol {0} m²",
    formatDryingAreaWallCeiling: "Mur / plafond {0} m²",
    note: "Remarque : {0}",
    orderAccepted: "Projet confirmé",
    orderRejected: "Projet refusé",
    parameters: "Paramètres",
    projectEndDesc: "Fin du projet: {0}",
    projectStepDescription: "Description",
    releaseDrying: "Autoriser séchage ?",
    servicesCSV: "Tableau des prestations (CSV)",
    step: "Étape",
    step1: "Ordre saisi",
    step10: "Rendez-vous pour montage du séchage",
    step11: "Fin montage du séchage",
    step12: "Rendez-vous pour mesure",
    step13: "Fin mesure",
    step14: "Rendez-vous pour démontage du séchage",
    step15: "Fin séchage",
    step16: "Rendez-vous pour restauration",
    step17: "Début de la restauration",
    step18: "Projet clos",
    step2: "Projet confirmé",
    step3: "Prise de contact",
    step4: "Rendez-vous pour détection de fuites",
    step5: "Fin détection des fuites",
    step6: "Rendez-vous pour relevé des dommages",
    step7: "Fin relevé des dommages",
    step8: "Devis à l’assurance",
    step9: "Autorisation du séchage",
    stepDoneBy: "Réalisé par",
    appointmentAlreadyCompleted: "Le rendez-vous a déjà été terminé et ne peut pas être supprimé.",
    appointmentDeleteError: "Une erreur est survenue lors de la suppression du rendez-vous.",
    appointmentDeleteSuccess: "Rendez-vous supprimé avec succès.",
    appointmentSaveSuccess: "Rendez-vous enregistré avec succès.",
    user: "Utilisateur",
  },
  projectStep: {
    acceptOrder: "Accepter ordre ?",
    appointmentDamageAssessment: "Relevé des dommages",
    appointmentDryingConclusion: "Démontage du séchage",
    appointmentDryingSetup: "Montage du séchage",
    appointmentIntermediateMeasurement: "Mesure",
    appointmentLeakDetection: "Détection de fuites",
    appointmentMissingDate: "Quand???",
    appointmentMissingResponsibleUser: "Qui???",
    appointmentNow: "immédiatement",
    appointmentOpenResposibleUser: "Responsable : ouvert",
    appointmentRestoration: "Restauration",
    approveDrying: "Autoriser séchage ?",
    approveProject: "Confirmer projet",
    assignDevices: "Associer appareils",
    concludeProject: "Clore projet",
    damageAssessmentResumed: "Relevé des dommages repris",
    damageAssessmentSuspended: "Relevé des dommages interrompu",
    damageAssessmentFinished: "Relevé des dommages terminé",
    damageAssessmentRunning: "Relevé des dommages en cours",
    damageDescription: "Interlocuteur/description du dommage",
    dryingApproved: "Séchage autorisé",
    dryingCompleted: "Séchage démonté",
    dryingConcluded: "Séchage terminé",
    dryingFinished: "Séchage terminé",
    dryingPackupResumed: "Démontage du séchage repris",
    dryingPackupSuspended: "Démontage du séchage interrompu",
    dryingNecessary: "Séchage nécessaire?",
    dryingRunning: "Séchage actif",
    dryingSetupResumed: "Montage du séchage repris",
    dryingSetupSuspended: "Montage du séchage interrompu",
    dryingSuccessful: "Séchage réussi ?",
    establishFirstContact: "Prendre contact",
    firstContactEstablished: "Contact établi",
    followUpInspectionShorthand: "Ressoum",
    formatDryingFinished: "Séchage {0} démonté",
    formatDryingRunningSince: "Séchage actif depuis {0}",
    intermediateMeasurementResumed: "Mesure reprise",
    intermediateMeasurementSuspended: "Mesure interrompue",
    interimReportCreated: "Rapport d’avancement créé",
    leakDetectionFinished: "Détection de fuites terminée",
    leakDetectionResumed: "Détection de fuites reprise",
    leakDetectionSuspended: "Détection de fuites interrompue",
    leakDetectionRunning: "Détection de fuites en cours",
    makeAppointment: "Prendre rendez-vous",
    noContract: "Aucun ordre",
    noDrying: "Aucun séchage",
    noReport: "Aucun rapport",
    note: "Remarque",
    offerSend: "Devis envoyé à l’assurance",
    orderRecorded: "Ordre saisi",
    orderRejected: "Ordre refusé",
    projectApproved: "Projet confirmé",
    projectEnd: "Fin projet",
    projectFinished: "Projet terminé",
    projectOnHold: "Projet suspendu",
    projectStepRepairFinished: "Restauration close",
    projectStepRepairStarted: "Restauration en cours",
    projectStepSetupDrying: "Montage du séchage en cours",
    repairResumed: "Restauration reprise",
    repairSuspended: "Restauration interrompue",
    reportCreated: "Rapport créé",
    setProjectSupervisor: "Désigner chef de projet",
  },
  rateDrying: {
    dryingDuration: {
      formatShouldHaveStoppedAt: "J. aurait démonté le séchage au {0}.",
      shouldHaveRunLonger: "J. aurait laissé le séchage se prolonger.",
      shouldHaveStoppedAt: "Quand J. serait amené à démonter ?",
      title: "Durée de séchage",
    },
    formatPhase: "Phase {0}",
    formatPhaseNew: "Phase",
    formatPhaseShort: "P{0}",
    formatPhaseShortNew: "P",
    formatRateHistoryBox: "Qualité Box {0} séchage {1}",
    formatRateHistoryPanel: "Qualité Panel {0} séchage {1}",
    postDryingRun: "Phase de clôture",
    quality: "Qualité",
    qualityDrying: {
      bad: "satisfaisant",
      dryingSpeed: "Vitesse",
      flow: "Courant",
      good: "bien",
      long: "plutôt long",
      ok: "OK",
      roomHumidity: "Humidité de la pièce",
      roomTemperature: "Température de la pièce",
      short: "plutôt court",
      title: "Qualité séchage",
      tooLong: "trop long",
      tooShort: "trop court",
      veryBad: "mauvais",
      veryGood: "très bon",
    },
    qualityNotes: {
      EDTGeneral: "Couche isolante sous chape - général",
      EDTPauses: "Couche isolante sous chape - pauses",
      EDTPhase4: "Couche isolante sous chape - phase 4",
      anomalies: "Anomalies",
      dryingWithPreDriedAir: "air chaud pré-séché",
      general: "Général",
      gkgConstant: "g/kg constant",
      gkgConstantInPause: "g/kg constamment en pause",
      gkgDecreasedInPause: "g/kg augmente en pause",
      gkgIncreasedAfterPause: "g/kg augmente après pause",
      gkgIncreasedInPause: "g/kg tombe en pause",
      gkgOfProcessAirTooHigh: "g/kg d’air de process trop élevé",
      gkgRoomTooHigh: "g/kg pièce trop élevée",
      humidityOfProcessAirTooHigh: "Hr de l’air de process trop élevé",
      insufficientAirFlow: "Courant trop faible",
      interruptionByCustomers: "Interruption par client",
      moistureNearDrillHoles: "Humidité en périphérie autour des trous",
      newMoistureAppeared: "nouvel apport d’humidité",
      noPlasticSheetingOnRawFloor: "sans film sur sol brut",
      powerConsumptionTooLow: "Consommation électrique trop faible",
      relayMalfunction: "Relais défectueux",
      roomConditions: "Conditions de la pièce",
      roomHumidityTooHigh: "rF pièce trop élevée",
      roomTemperature: "Température de la pièce",
      stableAfterXDays: "stable après x jours",
      title: "Remarques",
      tooHigh: "trop élevé",
      tooLow: "trop bas",
      underfloorHeating: "Chauffage au sol",
    },
    qualityOverall: {
      dryingDuration: "Durée de séchage",
      dryingProcess: "Processus de séchage",
      exemplaryFor: "Exemple de",
      knowledgeGain: "Données d’entrée pour l’apprentissage",
      labels: {
        dryingWithPreDriedAir: "Séchage avec air chaud préséché",
        insufficientAirFlow: "Courant trop faible",
        moistureNearDrillHoles: "Humidité en périphérie autour des trous",
        newMoistureAppeared: "Nouvel apport d’humidité",
        nightlyInterruptionByClient: "interruptions nocturnes par les clients",
        noPlasticSheetingOnRawFloor: "sans film sur sol brut",
        relayMalfunction: "Relais défectueux",
        underfloorHeating: "Chauffage au sol",
      },
      title: "Évaluation globale",
    },
    qualityPhase: {
      days: "Jours",
      delta: "Delta",
      duration: "Durée",
      maximumPowerConsumption: "Puissance max",
      minimumPowerConsumption: "Puissance min",
      mixingRatio: "mélange.",
      overall: "Total",
      progress: "Progrès",
      progressMixingRatio: "RM/j",
      progressRelativeHumidity: "% Hr/j",
      relativeHumidity: "% Hr",
      title: "Qualité phases",
      watt: "Watt",
    },
    qualityProgram: {
      activity: "Activité",
      ok: "OK",
      pauses: "Pause",
      phaseChange: "Changement de phase",
      title: "Qualité programme",
      toFast: "trop rapide",
      toLong: "trop long",
      toShort: "trop court",
      toSlow: "trop lent",
    },
    ratingSaved: "Évaluation sauvegardée",
    title: "Évaluer qualité",
  },
  regulatorTypes: {
    agent: "Courtier",
    externalRegulator: "Régulateur externe",
    vuAgency: "Agence d’assurance",
    vuFieldSales: "Service extérieur d’assurance ",
    vuInternalSales: "Service intérieur d’assurance ",
  },
  report: {
    completedPhaseReport: "Rapport",
    damageReport: "Rapport relevé des dommages",
    deleteReportMessage: "Êtes-vous sûr de vouloir supprimer le rapport ?",
    deleteReportTitle: "Supprimer rapport",
    finalReportDrying: "Rapport final sur le séchage",
    footer: {
      dryingReport: "Rapport de séchage HyDry",
      finalReport: "Rapport final HyDry",
      interimReport: "Rapport intermédiaire HyDry",
      formatPageOfPages: "{0} sur {1}",
    },
    formatReportDate: "créé {0}",
    formatReportDateAndSendDate: "créé et envoyé {0}",
    formatReportDateWithSendDate: "du {0}, envoyé le {1}",
    interimPhaseReport: "Rapport intermédiaire",
    interimReportDrying: "Rapport d’avancement séchage",
    timeTracking: "Rapport Suivi du temps",
    interimReportRepair: "Rapport d’avancement réparation",
    leakDetectionReport: "Rapport détection de fuites",
    reportName: {
      dryingReportFileNamePrefix: "HYDRY_SÉCHAGE",
      finalReportFileNamePrefix: "HYDRY_CLÔTURE",
      interimReport: "Rapport intermédiaire HyDry",
      interimReportFileNamePrefix: "HYDRY_PROGRÈS",
    },
    reportType: {
      damageReport: "TABLEAU DES DOMMAGES",
      finalReport: "FIN",
      interim: "AVANCEMENT",
      leakDetection: "Détection de fuites",
    },
    reportUsage: {
      damageAssessment: "Relevé des dommages",
      documentDescription: "",
      drying: "Séchage",
      external: "EXT",
      externalDescription: "externe",
      externalImagesDescription: "Images",
      externalShortDescription: "Rapport",
      externalSingleTimeTrackingDescription: "rapport de temps",
      externalTimeTrackingDescription: "rapport de temps",
      hyDryCertificate: "Certificat HyDry",
      internal: "INT",
      internalDescription: "interne",
      leakDetection: "Détection de fuites",
      measurementProtocol: "Protocole de mesure",
      restoration: "Réparation",
      serviceDescription: "Corps de métier",
      serviceJsonDescription: "PDE",
      svImage: "SV Bild Erstbericht",
    },
    subject: {
      damageAssessment: "Relevé des dommages",
      drying: "Séchage",
      leakDetection: "Détection de fuites",
      repair: "Réparation",
    },
  },
  reportList: {
    hint: "Rapports sur l’association des appareils et la consommation d’énergie",
    noReportsFound: "--- aucun rapport trouvé ---",
  },
  resetPassword: {
    errorEmailSharingPasswordNoMatch: "Le mot de passe ne correspond pas",
    errorMinEmailSharingPasswordLength:
      "Le mot de passe doit comporter au moins 8 caractères.",
    errorMinPasswordLength:
      "Le mot de passe doit comporter au moins 8 caractères.",
    errorPasswordNoMatch: "Les mots de passe ne correspondent pas",
    errorWrongEmailSharingPassword: "Mot de passe incorrect",
    errorWrongPassword: "Mot de passe incorrect",
    newEmailSharingPassword: "Nouveau mot de passe",
    newEmailSharingPasswordRepeated: "Répéter nouveau mot de passe",
    newPassword: "Nouveau mot de passe",
    newPasswordRepeated: "Répéter nouveau mot de passe",
    oldPassword: "Ancien mot de passe",
    passwordResetFailed:
      "Une erreur s’est produite lors de la réinitialisation de ton mot de passe. Réessaie.",
    passwordResetSuccess: "Ton mot de passe a été réinitialisé avec succès.",
    setNewEmailSharingPassword: "Définir nouveau mot de passe",
    setNewPassword: "Définir nouveau mot de passe",
    tokenInvalid:
      "Le lien de réinitialisation de ton mot de passe n’est pas valide ou a expiré.",
  },
  sampleList: {
    filterAll: "Tous",
    filterBatteryEvent: "Événements de la batterie",
    filterDryingEvent: "Événements de séchage",
    filterEndOfStep: "Fin étape",
    filterEvent: "Événements",
    filterMonitor: "Moniteur",
    filterPowerReduction: "Réduction de la puissance",
    formatTitle:
      "Échantillons de {0} / T{1} / Course {2} / P{3} à partir de {4}",
    formatVoltage: "{0} V",
    heatRatio: "Ratio de chaleur",
    samplesPerPage: "Échantillons par page :",
    sortAscending: "Tri croissant",
    sortDescending: "Tri décroissant",
    titleChipTemp1: "Puce1",
    titleChipTemp2: "Puce2",
    titleCycle: "Cycle",
    titleEvent: "Événement",
    titleIndex: "Index",
    titlePower: "Puissance",
    titleStatus: "État",
    titleStep: "Étape",
    titleTime: "Heure",
    titleWallChip1Max: "Puce1Max",
    titleWallTemp1: "Mur1",
    titleWallTemp1Max: "Mur1Max",
    titleWallTemp2: "Mur2",
    titleWallTemp2Max: "Mur2Max",
  },
  scheduling: {
    durationInMinutes: "Durée (min)",
    taskDetails: {
      addAppointment: "Rendez-vous+",
      addNote: "Note+",
      appointmentConfirmed: "Rendez-vous confirmé",
      dateSuggestions: "Rendez-vous possibles",
      delete: {
        message: "Êtes-vous sûr de vouloir supprimer un rendez-vous confirmé ?",
        title: "Supprimer rendez-vous ?",
      },
      deleteNote: "Note-",
      fromDate: "à partir de la date",
      noSuggestionsFound:
        "Aucun rendez-vous autorisé trouvé, veuillez modifier les objectifs.",
      note: "Note",
      parameterFixed: "fixe",
      parametersForPlanning: "Objectifs pour la planification des rendez-vous",
      title: "Planifier rendez-vous",
      undoConfirmation: {
        message: "Le rendez-vous confirmé doit-il être validé ?",
        title: "Confirmation supprimée",
      },
      unsavedChagnes: {
        message:
          "Des données ont été modifiées pour la planification. Annuler quand même ?",
        title: "Données de planification modifiées",
      },
    },
    taskType: {
      damageAssessment: "Relevé des dommages",
      dryingConclusion: "Démontage du séchage",
      dryingSetup: "Montage du séchage",
      intermediateMeasurement: "Mesure de l’avancement",
      leakDetection: "Détection de fuites",
      repair: "Restauration",
    },
    tasks: {
      confirmedTasks: "Tâches confirmées",
      filter: {
        all: "Tous",
        filterOff: "Filtre éteint",
        lastFourWeek: "4 dernières semaines",
        lastWeek: "La semaine dernière",
        startingFromLastWeek: "À partir de la semaine dernière",
        startingFromToday: "À partir d’aujourd’hui",
      },
      formatStartingAt: "à partir de {0}",
      openTasks: "Rendez-vous",
      sortOrder: {
        appointmentDate: "Heure de début",
        earliestStartDate: "Degré d’urgence",
        projectNumber: "Numéro de projet",
        taskType: "Étape de travail",
        user: "Responsable",
      },
    },
    timeline: {
      formatMinutes: "{0} min",
    },
    timelineControl: {
      formatCalendarWeek: "SC {0}",
      moveBackward: "<",
      moveForward: ">",
    },
    timelineSettings: {
      date: "à partir de la date",
      hideWeekends: "Masquer sam+dim",
      onlyShowWorkingHours: "Temps de travail uniquement",
      today: "Aujourd’hui",
      visibleArea: {
        fourWeeks: "4 sem",
        label: "Affichage",
        oneDay: "Jour",
        oneWeek: "1 sem",
        twoWeeks: "2 sem",
      },
    },
    urgend: "Urgent",
  },
  searchIresDevice: {
    message: "Veuillez spécifier le numéro de série de l’appareil",
    title: "Rechercher appareil HyDry",
  },
  selectProjectType: {
    drying: "Séchage",
    dryingDirectOrder: "Séchage - ordre direct",
    dryingInsuranceCase: "Séchage - risque assuré",
    flexProject: "Ordre flex",
    formatProjectTypes: "Type de projet : {0} | Types de projets : {0}",
    leakDetection: "Détection de fuites",
    leakDetectionDirectOrder: "Détection de fuites/ordre direct",
    leakDetectionInsuranceCase: "Détection de fuites/risque assuré",
    websiteOnly: "Portail",
  },
  settings: {
    administration: {
      allDevicesSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Les membres (filiales) peuvent-ils utiliser leurs propres PARAMÈTRES D’APPAREIL ?",
        clients: "Quelle(s) filiale(s) ?",
        title: "Distribution réglages TOUS APPAREILS",
      },
      companySettings: {
        allowMemberClientsToDefineOwnSettings:
          "Les membres (filiales) peuvent-ils utiliser leurs propres PARAMÈTRES DE FILIALE ?",
        clients: "Quelle(s) filiale(s) ?",
        title: "Distribution réglages FILIALES",
      },
      deviceSettings: {
        title: "Gestion des appareils",
      },
      hyDryDeviceSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Les membres (filiales) peuvent-ils utiliser leurs propres PARAMÈTRES D’APPAREIL HyDry ?",
        clients: "Quelle(s) filiale(s) ?",
        title: "Distribution réglages APPAREILS HYDRY",
      },
      hyDryMessagesSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Les membres (filiales) peuvent-ils utiliser leurs propres PARAMÈTRES DE MESSAGE ?",
        clients: "Quelle(s) filiale(s) ?",
        title: "Distribution réglages MESSAGES",
      },
      projectManagementSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Les membres (filiales) peuvent-ils utiliser leurs propres réglages pour les PROJETS ?",
        clients: "Quelle(s) filiale(s) ?",
        title: "Distribution réglages PROJETS",
      },
      reportSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Les membres (filiales) peuvent-ils utiliser leurs propres PARAMÈTRES DE RAPPORT ?",
        clients: "Quelle(s) filiale(s) ?",
        title: "Distribution réglages RAPPORTS",
      },
      roleSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Les membres (filiales) peuvent-ils utiliser leurs propres PARAMÈTRES DE RÔLE ?",
        clients: "Quelle(s) filiale(s) ?",
        enforcedMessage: "Les paramètres de rôle du client principal sont automatiquement appliqués à toutes les filiales. Les filiales ne peuvent pas définir leurs propres paramètres de rôle.",
        title: "Distribution réglages RÔLES",
      },
      userSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Les membres (filiales) peuvent-ils utiliser leurs propres PARAMÈTRES UTILISATEUR ?",
        clients: "Quelle(s) filiale(s) ?",
        title: "Distribution réglages UTILISATEURS",
      },
      sectionTitle: "Administration",
      systemConfiguration: {
        allowMemberClientsToDefineOwnSettings:
          "Les membres (filiales) peuvent-ils utiliser leur propre CONFIGURATION SYSTÈME ?",
        clients: "Quelle(s) filiale(s) ?",
        title: "Distribution réglages CONFIGURATION SYSTÈME",
      },
    },
    allDevices: {
      projectDevicesSettings: {
        enforceMeterReading:
          "Toujours saisir et vérifier le relevé du compteur ?",
        standardIdentification: "Standard pour l’identification",
        title: "Réglages appareils",
      },
      title: "Tous les appareils",
    },
    allDevicesManagement: {
      title: "Gérer tous les appareils",
    },
    branches: {
      branchNumber: "Id du site",
      branchSortValue: "Numéro de tri",
      confirmDeleteBranchMessage:
        "Êtes-vous sûr de vouloir supprimer ce site ?",
      confirmDeleteBranchTitle: "Supprimer site",
      editTitle: "Modifier site",
      viewTitle: "Site",
      errorDuplicateBranchNumber: "Ce numéro est déjà attribué au site {0}.",
      errorMissingBranchNumber: "Veuillez spécifier le numéro > 0",
      fullName: "Nom long",
      location: "Lieu",
      name: "Nom abrégé",
      title: "Sites",
      useInReport: "Dans rapport",
    },
    buttons: {
      change: "MODIFIER",
    },
    changeLogo: "Modifier logo",
    comBoxHumidityUnit: {
      absoluteHumidity: "Humidité absolue (g/m3)",
      mixingRatio: "Rapport de mélange (g/kg)",
      relativeHumidity: "Humidité relative (%)",
      title: "Unité humidité",
    },
    comBoxes: "Box HyDry",
    company: "Filiale",
    companySettings: {
      addressFormat: {
        availableFields: "Champs disponibles",
        commaNotAllowedAtEdge: "La virgule ne peut pas être au début ni à la fin",
        defaultUsed: "Sans champ, le format par défaut est utilisé.",
        hint: "Définit l’ordre dans lequel les parties d’une adresse sont écrites.",
        preview: "Aperçu",
        templateFields: {
          CITY: "Ville",
          COMMA: "Virgule",
          COUNTRY: "Pays",
          HOUSE_NUMBER: "Numéro de maison",
          STREET: "Rue",
          ZIP_CODE: "Code postal",
        },
        title: "Format d’adresse",
      },
      addressGeocoding: "Géocoder les adresses",
      companyData: "Données de la filiale",
      companyEmailAddress: "Adresse e-mail",
      companyIdentifier: "Code de la filiale",
      companyName: "Nom de la filiale",
      companySettingsTitle: "Réglages filiale",
      errorCompanyIdentifier:
        "Saisie non valide. Veuillez utiliser uniquement des caractères alphanumériques.",
      errorEmailAddress: "Veuillez spécifier une adresse e-mail valide",
      primaryLanguage: "Langue primaire",
      shortName: "Nom abrégé",
      timezone: "Fuseau horaire",
      usePrimaryLanguageForReports:
        "Utiliser la langue primaire pour les rapports ?",
    },
    currentUser: {
      formatCurrentUser: "Utilisateur actuel : {0}, rôle : {1},",
      formatCurrentUserValidationLevel: "Vérification : {0}",
      setPassword: "Modifier mot de passe utilisateur",
      showCurrentUserSettings: "Afficher mes données d’utilisateur",
      title: "Utilisateur actuel",
    },
    aiPredictions: {
      title: "ASSIST",
      mode: {
        OFF: "Non",
        ALL_DRYINGS: "Oui, avec tous les assèchements",
        ACTIVE_AND_NEW_ONLY: "Oui, uniquement les assèchements actifs et nouveaux",
      },
      activationBackfill: {
        started: "L’activation ASSIST a été enregistrée. Le calcul historique a démarré.",
        alreadyRunning: "L’activation ASSIST a été enregistrée. Le calcul historique est déjà en cours.",
        noOp: "L’activation ASSIST a été enregistrée, mais le backend n’a pas démarré le calcul historique.",
        triggerFailed: "L’activation ASSIST a été enregistrée, mais le calcul historique n’a pas pu être démarré.",
      },
    },
    billingCatalogs: {
      title: "Gérer les catalogues de facturation",
      sectionTitle: "Catalogues de facturation",
      listTitle: "Catalogues de facturation",
      noCatalogs: "Aucun catalogue de facturation disponible.",
      syncFromApi: "Synchroniser depuis l’API",
      syncSuccess: "{0} articles importés dans {1} catalogues.",
      syncError: "Échec de la synchronisation des catalogues de facturation.",
      updateError: "Échec de l’enregistrement de la modification.",
      noPriceClassName: "Sans classe de prix",
      columns: {
        catalogName: "Émetteur",
        tenant: "Source des prix",
        version: "Version",
        fileName: "Nom du fichier",
        numberOfEntries: "Entrées",
        branchNumber: "Filiale",
        validFrom: "Valable à partir du",
        validUntil: "Valable jusqu'au",
        importedAt: "Importé le",
      },
      detail: {
        title: "Catalogue de facturation",
        validityOpenEnded: "indéterminé",
        loading: "Chargement du catalogue de facturation...",
        loadError: "Échec du chargement du catalogue de facturation",
        uncategorized: "Sans catégorie",
        columns: {
          articleId: "Position",
          headline: "Titre",
          text: "Description",
          unit: "Unité",
          price: "Prix",
          limit: "Limite",
          qualifier: "Qualificateur",
        },
        download: "Télécharger",
      },
    },
    devices: {
      allowCategoryTemplateCreate:
        "Autoriser la création de nouvelles catégories/types d’appareils lors de l’importation CSV ?",
      allowCategoryTemplateUpdate:
        "Autoriser l’actualisation de la catégorie/du type d’appareil lors de l’importation CSV ?",
      allowNewCategory:
        "Autoriser l’ajout de nouvelles catégories d’appareils lors de l’importation CSV ?",
      allowNewTemplate:
        "Autoriser l’ajout de nouveaux types d’appareils lors de l’importation CSV ?",
    },
    dryRuns: "Séchages",
    errorInvalidNumber: "Veuillez spécifier un nombre entier",
    errorNumberRange: "Veuillez saisir un nombre entier entre {0} et {1}",
    exportSettings: {
      allDevices: "Tous les appareils",
      deviceFilter: "Sélection de l’état de l’appareil",
      devicesSelection: "Sélection des appareils",
      exportDialog: {
        message: "1 appareil traité | {count} appareils traités",
        title: "Exporter informations",
      },
      hyDryDevices: "Appareils HyDry",
      otherDevices: "Tous les appareils",
    },
    hyDryBox: "Box HyDry",
    hyDryDevice: {
      cancel: "ANNULER",
      configurations: "Réglages appareils HyDry",
      configurationsImportExport: "Configurer importation",
      date: "Date",
      deviceError:
        "1 appareil contient des erreurs | {count} appareils contiennent des erreurs",
      deviceImportHistory: "Progression de l’importation",
      devicesCategorySettings: "Catégories et types d’appareils",
      devicesDetected: "1 appareil détecté | {count} appareils détectés",
      devicesDuplicated: "1 doublon trouvé | {count} doublons trouvés",
      devicesExport: "Exporter appareils",
      devicesImport: "Importer appareils",
      devicesNew:
        "1 nouvel appareil ajouté | {count} nouveaux appareils ajoutés",
      devicesProcessed: "1 appareil traité | {count} appareils traités",
      devicesUpdated:
        "1 appareil existant mis à jour | {count} appareils existants mis à jour",
      devicesUpload: "Téléversement d’appareils ...",
      editComBoxClientConfig: "Modifier configuration du mandant BOX HyDry",
      errorMessageCategoryNotFound: "Catégorie introuvable",
      errorMessageCategoryUpdateNotAllowed:
        "Impossible de modifier la catégorie",
      errorMessageDeviceAssignedToProject: "Appareil affecté au projet",
      errorMessageDeviceDoesNotExist: "L’appareil n’existe pas",
      errorMessageBranchNotFound: "Le site n’existe pas",
      errorMessageInvalidDevicePowerUsageType: "Compteur non valide",
      errorMessageInvalidElectricityMeterManufacturer:
        "Le fabricant de compteurs n’est pas valide",
      errorMessageInvalidInventoryNumber:
        "Le numéro d’inventaire n’est pas valide",
      errorMessageInvalidManufacturer: "Le fabricant n’est pas valide",
      errorMessageInvalidPowerConsumptionPerHour:
        "La puissance caractéristique n’est pas valable",
      errorMessageInvalidQrCode: "Code QR non valide",
      errorMessageInventoryNumberAlreadyExists:
        "Le numéro d’inventaire existe déjà (conflit: {conflictId})",
      errorMessageInventoryNumberNotUnique:
        "Plusieurs appareils portant le même numéro d’inventaire ont été trouvés.",
      errorMessageIresDevice: "Impossible d’importer un nouvel appareil HyDry",
      errorMessageMissingCategory: "Catégorie manquante",
      errorMessageMissingCategoryColumn:
        "Le fichier d’importation ne contient aucune colonne pour la catégorie d’appareil.",
      errorMessageMissingInventoryNumber: "Numéro d’inventaire manquant",
      errorMessageMissingInventoryNumberColumn:
        "Le fichier d’importation ne contient aucune colonne pour le numéro d’inventaire.",
      errorMessageMissingSerialNumberColumn:
        "Le fichier d’importation ne contient aucune colonne pour le numéro de série.",
      errorMessageMissingTemplate: "Type manquant",
      errorMessageMissingTemplateColumn:
        "Le fichier d’importation ne contient aucune colonne pour le type d’appareil.",
      errorMessageQrCodeAlreadyExists: "Le code QR existe déjà (conflit: {conflictId})",
      errorMessageSerialNumberNotUnique:
        "Plusieurs appareils portant le même numéro de série ont été trouvés.",
      errorMessageTemplateNotFound: "Le type demeure introuvable",
      errorMessageTemplateUpdateNotAllowed:
        "Impossible de modifier le type d’appareil",
      errorMessageTryAgain:
        "Une erreur s’est produite. Réessayez avec un autre fichier.",
      errorMessageWrongCsvSeparator:
        "Le format de fichier est incorrect. Veuillez suivre les instructions.",
      errorMessageWrongFormat: "Le fichier doit posséder l’extension .CSV",
      errorMessageFileTooLarge: "Le fichier est trop volumineux. Taille maximale : 5 Mo.",
      exportDevice: "Exporter appareils",
      csvHeaders: {
        category: "CATÉGORIE",
        type: "TYPE",
        inventoryNumber: "NUMÉRO D'INVENTAIRE",
        serialNumber: "NUMÉRO DE SÉRIE",
        manufacturer: "FABRICANT",
        code: "CODE",
        power: "PUISSANCE",
        meter: "COMPTEUR",
        electricityMeterManufacturer: "FABRICANT DU COMPTEUR ÉLECTRIQUE",
        electricityMeterNumber: "NUMÉRO DU COMPTEUR ÉLECTRIQUE",
        acquisitionDate: "DATE D'ACQUISITION",
        availability: "DISPONIBILITÉ",
        location: "EMPLACEMENT",
        comment: "COMMENTAIRE",
        meterReading: "RELEVÉ DU COMPTEUR",
        locationName: "NOM DU SITE",
        error: "ERREUR",
      },
      fileName: "Nom de fichier",
      genericError: "Erreur",
      guide: {
        acquisitionDate: "DATE D’ACQUISITION",
        availability: "DISPONIBILITÉ",
        category: "CATÉGORIE",
        code: "CODE",
        comment: "COMMENTAIRE +",
        counter: "COMPTEUR",
        counterReading: "RELEVÉ DU COMPTEUR",
        electricityMeterManufacturer: "FABRICANT DE COMPTEUR",
        electricityMeterNumber: "NUMÉRO DE COMPTEUR",
        inventoryNumber: "NUMÉRO D’INVENTAIRE",
        location: "SITE",
        manufacturer: "FABRICANT",
        power: "PUISSANCE",
        serialNumber: "NUMÉRO DE SÉRIE",
        step1:
          "L’importation est réalisée à l’aide d’un fichier CSV avec les caractéristiques suivantes :",
        step2: "Ordre des champs",
        step3: "Catégories/types d’appareils",
        step4:
          "Impossible de créer les appareils HyDry ou de les modifier via l’importation.",
        step5:
          "Chaque appareil doit posséder soit un numéro d’inventaire unique, soit un numéro de série unique, sinon il ne peut pas être créé.",
        step6: "Les champs vides ne sont pas actualisés.",
        step7: "Formats/sélection",
        subStep1a: "Ligne d’en-tête (non évaluée)",
        subStep1b:
          "Données de l’appareil avec champs correspondant à la ligne d’en-tête.",
        subStep1c: "Séparateur de champ point-virgule (;)",
        subStep1d: "Format des caractères UTF-8",
        subStep3a:
          "Les types et les catégories d’appareil ne sont créés ou mis à jour automatiquement que si cela est spécifié dans CONFIGURATION DE L’IMPORTATION.",
        subStep7a:
          "COMPTEUR : spécification du type de compteur comme 0=Aucun compteur, 1=Heures de fonctionnement, 2=Alimentation électrique, 3=Compteur alimentation externe",
        subStep7b:
          "CODE : spécifier le code-barres, le code QR ou le NFC. Doit être unique.",
        subStep7c: "DATE D’ACQUISITION : à spécifier au format jj.mm.aaaa",
        subStep7d:
          "DISPONIBILITÉ : indication 0=disponible, 1-9=non disponible",
        title: "Importation d’appareils",
        type: "TYPE",
      },
      confirmImport: "Confirmer l'importation",
      import: "importer",
      importCancelled: "Importation de fichiers annulée",
      importDevices: "Importer nouveaux appareils",
      importSuccess: "Le fichier a été importé avec succès",
      importPreview: "Aperçu de l'importation",
      previewComplete: "Aperçu terminé",
      newDevices: "Nouveaux appareils",
      newImport: "Importer nouveau fichier",
      noHistoryData: "--- aucune donnée historique trouvée ---",
      readingFile: "Fichier en cours de lecture ...",
      reportDownload: "Rapport",
      title: "Appareils HyDry",
      updatedDevices: "Appareils actualisés",
      uploadBoxTest1: "Importer fichier par glisser-déposer",
      uploadBoxTest2: "ou",
      uploadBoxTest3: "Rechercher fichier",
      user: "Utilisateur",
    },
    hyDryDevices: "Appareils HyDry",
    hyDryDeviceSettings: {
      minRunDurationForAnalysis:
        "Longueur de course minimale pour les évaluations",
    },
    ires: {
      enableSpecialRightsForIresClientOrAdmin:
        "Activer les droits spéciaux pour les utilisateurs IRES ?",
      ignoreIresAdminOrIresClientCheck:
        "Ignorer le contrôle sur IRES Admin ou IRES Mandant ?",
      ignoreIresAdminOrIresClientCheckShort:
        "Ignorer le contrôle sur IRES Admin ou IRES Mandant ?",
      iresConfiguration: "Réglages IRES",
      title: "IRES",
    },
    logo: "Logo",
    mailbox: {
      confirmDeleteMailboxMessage:
        "Êtes-vous sûr de vouloir supprimer cette boîte de réception ?",
      confirmDeleteMailboxTitle: "Supprimer boîte de réception",
      errorNameAlreadyTaken: "Ce nom est déjà utilisé",
      mailbox: "Boîte de réception",
      memberUsers: "Utilisateur sortant",
      name: "Nom",
      sortValue: "Numéro de tri",
      targetUsers: "Utilisateur entrant",
    },
    mailboxes: "Gérer boîtes de réception",
    messageSelection: "Configurer messages",
    messages: "Messages",
    minProgramChainDurationInMinLabel: "Longueur minimale de séchage",
    minProgramChainDurationInMinMessage:
      "Limite d’affichage des séchages pour les appareils HyDry (les séchages de longueur inférieure sont masqués) :",
    minProgramChainDurationInMinTitle:
      "Longueur de séchage minimale pour les appareils HyDry",
    minGeneralGapDurationInMinLabel: "Écart maximum pour regrouper",
    minGeneralGapDurationInMinMessage:
      "Les entrées consécutives d’un même projet et d’une même phase sont regroupées en une seule lorsque l’écart entre elles est au maximum de cette valeur (en minutes) :",
    minGeneralGapDurationInMinTitle:
      "Seuil de regroupement des entrées identiques",
    travelArrivalRadiusLabel: "Rayon d’arrivée (m)",
    travelArrivalRadiusTitle: "Rayon d’arrivée pour les trajets",
    travelArrivalRadiusMessage:
      "À partir de quelle distance de la destination un trajet compte comme interrompu plutôt " +
      "que comme arrivé. Distance à vol d’oiseau, en mètres. S’applique à tous tes " +
      "collaborateurs.",
    permissions: {
      assignProjectToOthers: "D2 Associer des projets à d’autres",
      basicLicence: "B1 Licence de base projets",
      cancel: "ANNULER",
      clientAdministration: "M1 Gestion des membres",
      createProject: "C2 Créer nouveau projet",
      damageAssessmentLarge: "F2 En charge du relevé des dommages",
      defineDeviceCategories: "E1 Définir catégories d’appareils",
      deleteProject: "C3 Supprimer projets",
      deviceAdministration: "M2 Gestion des appareils",
      drying: "F3 En charge du séchage",
      dryingAndRecording: "B3 Licence séchage",
      editAdmin: "A1 Gérer Admin",
      editDevices: "E3 Gérer appareils",
      editProjects: "C5 Éditer projets",
      editUser: "A2 Gérer utilisateurs",
      editValidation: "A3 Modifier son propre niveau de contrôle",
      haveVehicle: "F5 A le véhicule",
      importDevicesCategories: "E2 Importer appareils",
      leakDetection: "F1 En charge de la détection de fuites",
      manageProduction: "P2 Gérer la production",
      manageClients: "P3 Gérer les clients",
      office: "B4 En charge des tâches de bureau",
      permissions: "Autorisations",
      projectManagement: "B5 En charge de la gestion de projet",
      projectsSuperVision: "D3 En charge de la direction de projet",
      rateDryings: "P1 Évaluer les séchages",
      recording: "B2 Licence relevé",
      reopenCompletedPhases: "C4 Rouvrir projets",
      repair: "F4 En charge de la restauration",
      return: "RETOUR",
      save: "Sauvegarder",
      saveEdit: "SAUVEGARDER MODIFICATIONS",
      saveEditsSuccessfull: "Modifications sauvegardées avec succès",
      seeAllProjects: "C1 Voir tous les projets",
      seeAllSettings: "A4 Gérer configuration",
      selfAssignProjects: "D1 Associer soi-même des projets",
      settingsAdministration: "M3 Réglages généraux",
    },
    permissiontManagement: {
      title: "Gérer rôles",
    },
    projectManagement: {
      projectEditingSettings: {
        defaultDryingDuration: "Prédéfiniton durée de séchage (jours)",
        defaultFollowUpInspectionInterval:
          "Ressoumission toujours après 1 jour | Ressoumission toujours après {count} jours",
        title: "Réglages déroulement du projet",
        automaticProjectNames: "Noms de projet automatiques",
        deviceAssignment: "Affectation des appareils",
        roomLevelDeviceAssignment: "Affectation des appareils au niveau de la pièce",
        projectOverviewTilesForOfficeProjects: "Tuiles pour l'attribution des appareils",
        templateFields: {
          PROJECT_NUMBER: "Numéro de projet",
          ZIP_CODE: "Code postal",
          CITY: "Ville",
          STREET: "Rue",
          HOUSE_NUMBER: "Numéro de maison",
          NAME: "Nom",
          COMMA: "Virgule",
        },
        resetToAuto: "Réinitialiser à automatique",
        availableFields: "Champs disponibles",
        commaNotAllowedAtEdge: "La virgule ne peut pas être placée au début ou à la fin.",
        preview: "Aperçu",
      },
      projectManagerSettings: {
        actionButtons: {
          options: {
            hide: "Cacher",
            red: "Rouge",
            yellow: "Jaune",
          },
          pipeSystem: "K2 Détection de fuites : SYSTÈME DE CONDUITE",
          projectAttendees: "Projet K2 : PERSONNES PRÉSENTES",
          projectCause: "Projet K2 : MOTIF",
          title: "Boutons d’action",
        },
        damageAssessment: {
          enforceFullDamageAssessment:
            "Toujours REPRÉSENTATION COMPLÈTE DES DOMMAGES ?",
          title: "Relevé des dommages",
        },
        measurementPoints: {
          canAddMeasurementPointsInApartment:
            "Autoriser points de mesure dans l’APPARTEMENT ?",
          roomClimateMeasuringPoints: "Point de mesure CLIMAT PIÈCE",
          measurementPointPresetPhase: "Pré-affectation dans DÉTECTION DE FUITES",
          measurementPointPresetPhaseOptions: {
            leakDetection: "Détection de fuites",
            drying: "Séchage",
          },
          title: "Points de mesure",
        },
        sketch: {
          errorPresetWallThickness:
            "Les valeurs doivent être comprises entre 0 et 99.",
          presetInnerWallThickness: "Mur intérieur",
          presetOuterWallThickness: "Mur extérieur",
          presetPartyWallThickness: "Mur mitoyen",
          presetWallThickness: "Épaisseur de mur par défaut (cm) (0 = aucune)",
          sketchInRooms: "C3 Schéma dans pièces",
          title: "Schéma",
        },
        title: "Réglages IRES Project Manager",
        serviceList: {
          title: "Liste de prestations",
          presetFlexibleServiceList: "Pré-affectation liste de prestations flexible",
        },
      },
      projectSettings: {
        editProjectsIn: "Exécuter MODIFIER LES DONNÉES DU PROJET ?",
        finaliseProjectsIn: "Exécuter la CLÔTURE DU PROJET ?",
        newAppointmentsIn: "Exécuter NOUVEAUX RENDEZ-VOUS ?",
        newProjectsIn: "Exécuter NOUVEAUX PROJETS ?",
        title: "Réglages projets",
      },
      title: "Projets",
    },
    report: {
      dataProtection: {
        contactDataInExternalReports: "Coordonnées dans les rapports externes",
        title: "Protection des données",
      },
      emailInboxes: {
        damageReportEmailAddress: "E-mail pour rapports des dommages",
        dryingReportEmailAddress: "E-mail pour rapports de séchage",
        leakDetectionReportEmailAddress:
          "E-mail pour rapports de détection de fuites",
        title: "Boîtes de réception e-mail",
      },
      errorEmailAddress: "Veuillez spécifier une adresse e-mail valide",
      equipmentUsage: {
        includeGenericDeviceAssignments: "Inclure les appareils dans le rapport",
        createCertificate: "Créer un certificat",
        title: "Utilisation des appareils",
      },
      images: {
        contentOrder: "Ordre des blocs dans les rapports",
        contentOrderOptions: {
          sketchImagesText: "Croquis / Images / Texte",
          sketchTextImages: "Croquis / Texte / Images",
          textSketchImages: "Texte / Croquis / Images",
        },
        imageQuality: "Préréglage de la qualité d’image",
        imageQualityHigh: "Haute",
        imageQualityLow: "Faible",
        imageQualityNormal: "Moyen",
        imageReportAfterDamageAssessmentOptions: {
          no: "Aucun rapport d'images",
          selectionAsExternalReport: "Sélection comme rapport externe",
          selectionAsInternalReport: "Sélection comme rapport interne",
        },
        imagesPerRow: "Images par ligne",
        showReportConfigInProject: "Demander configuration des images",
        title: "Images dans rapports",
      },
      logo: {
        dropHint: "Déposez le logo ici ou cliquez",
        expandPreview: "Agrandir l’aperçu",
        hint: "Formats acceptés : JPEG et PNG",
        noLogo: "Pas de logo",
        removeLogo: "Supprimer le logo",
        uploadLogo: "Télécharger le logo",
        scalingFactor: "Échelle Logo (%)",
        selectFile: "Choisir un fichier",
        title: "Logo",
      },
      outgoingReports: {
        saveReport: "dans le répertoire",
        sendAsEmail: "envoyer par e-mail",
        title: "Rapports sortants",
      },
      reportEmailAddress: "E-mail pour rapports",
      reportSettings: "Réglages rapports",
      individualReports: {
        title: "Rapports individuels",
        documentsInReports: "Documents PDF",
        timeEntriesInReports: "Entrées de temps",
        reportInclusionOptions: {
          internalReport: "dans le rapport interne",
          externalReport: "dans le rapport externe",
          separateReport: "comme rapport individuel",
          separateReportTotal: "comme un rapport individuel (total)",
          separateReportIndividual: "comme rapport individuel par entrée",
        },
        measurementProtocolAsSeparateReport: "Protocole de mesure comme rapport séparé",
        measurementProtocolAsSeparateReportOptions: {
          no: "Non",
          yes: "Oui",
        },
        imageReportAfterDamageAssessment: "Rapports d'images et sélection d'images",
      },
      footer: {
        title: "Pied de page",
        footerText: "Texte en pied de page",
        footerTextOptions: {
          appVersion: "Version de l'application",
          company: "Entreprise",
          location: "Emplacement",
        },
        projectInfo: "Info projet en pied de page",
        projectInfoOptions: {
          projectId: "Numéro de projet",
          collectionNumber: "Numéro collectif",
          projectIdAndCollectionNumber: "Numéro de projet / Numéro collectif",
        },
        showTotalPageCount: "Afficher le nombre total de pages (7 sur 13)",
      },
      title: "Rapports",
    },
    roleManagement: {
      cancelMessage:
        "Vous avez déjà effectué des modifications. Rejeter ces modifications ?",
      cancelTitle: "Rejeter modifications ?",
      capabilityOption: {
        conditional: "Éventuellement",
        no: "Non",
        yes: "Oui",
      },
      edit: "Configurer rôles",
      editRole: "Éditer rôle",
      error: {
        activeUserForRole:
          "Il existe encore des utilisateurs actifs avec ce rôle",
        wrongLabel: "Veuillez saisir une désignation de rôle valide",
      },
      roles: {
        description: "Description",
        label: "Nom",
        roleActive: "État",
        roleId: "nº de succession",
        users: "# utilisateur(s)",
      },
      memberClientHint: "Remarque : La configuration des rôles peut être modifiée dans le MASTER.",
      title: "Gérer rôles",
      titleAlt: "Afficher rôles",
      viewRolesConfiguration: "Afficher configuration des rôles",
    },
    scheduling: {
      control: {
        acceptableDelayInMin: "Retard",
        title: "Commande",
      },
      defaultBreakDurations: {
        lunchBreak: "Pause de midi",
        maxTimeWithoutBreak: "Temps jusqu’à la pause",
        title: "Pauses",
      },
      defaultTaskDurations: "Prédéfinition durée du travail (heures)",
      objectiveFunctionParameters: {
        title: "Fonction cible",
        weights: {
          dailyWorkTimeExceedance:
            "Pondération dépassement du temps de travail par jour",
          targetDate: "Pondération date cible",
          targetDateFixed: "Pondération date cible fixe",
          targetQualification: "Pondération qualification cible",
          targetTime: "Pondération temps cible",
          targetTimeFixed: "Pondération heure cible fixe",
          targetUser: "Pondération responsable cible",
          timeGap: "Pondération intervalle de temps",
          total: "Échelle totale",
          travelTime: "Pondération temps de trajet",
          weeklyWorkTimeExceedance:
            "Pondération dépassement du temps de travail par semaine",
        },
      },
      occupiedTimeUsage: {
        breakUsage: "Pause",
        none: "arrêt",
        plan: "planifier",
        show: "afficher",
        travelTimeUsage: "Temps de trajet",
      },
      planningBoard: {
        formatColor: "Couleur {0}",
        taskColors: "Couleurs",
        title: "Présentation du planning d’interventions",
        visibleArea: {
          fourWeeks: "4 semaines",
          from: "Affichage de",
          oneDay: "1 jour",
          oneWeek: "1 semaine",
          title: "Zone visible",
          twoWeeks: "2 semaines",
          until: "Affichage jusqu’à",
        },
        visibleRange: {
          title: "Période d’affichage",
        },
      },
      section: {
        geocodingAndTravelTimes: "Géocodage et temps de trajet",
        planningBoard: "Présentation du planning d’interventions",
        planningControl: "Configuration de la planification",
      },
      title: "Planning d’interventions",
      travelTimeAndPauses: "Temps de trajet et pauses",
      travelTimeSettings: {
        betweenTaskAndDepot: "Prédéfinition accès au client",
        betweenTasks: "Prédéfinition trajet de liaison",
        title: "Géocodage et temps de trajet",
        travelTimeBuffer: "Supplément de temps",
        travelTimeCalculationViaMap: "Temps de trajet sur la carte",
      },
      workingHours: {
        defaultWorkDayEnd: "Temps de travail fin",
        defaultWorkDayStart: "Temps de travail debut",
        defaultWorkingHoursPerDay: "Heures de travail/jour",
        defaultWorkingHoursPerWeek: "Heures de travail/semaine",
        earliestWorkDayStart: "Début au plus tôt",
        latestWorkDayEnd: "Fin au plus tard",
        longBreakDuration: "Durée pause prolongée",
        longBreakThresholdHours: "Heures de travail au-dessus",
        lunchBreakAfter: "Planifier pause après",
        maxWorkingHoursPerDay: "Temps de travail max. par jour",
        maxWorkingHoursPerWeek: "Temps de travail max. par semaine",
        minBreakDuration: "Durée min. de pause",
        shortBreakDuration: "Durée pause normale",
        shortBreakThresholdHours: "Heures de travail au-dessus",
        title: "Horaires de travail et pauses",
      },
    },
    sharedEmailAddress: {
      changePasswordHint:
        "Veuillez spécifier un nouveau mot de passe pour partager votre adresse e-mail.",
      changePasswordHintOld:
        "Veuillez spécifier un nouveau mot de passe pour partager l’adresse e-mail",
      title: "Mot de passe pour partager l’adresse e-mail",
      titleOld: "Partager adresse e-mail",
    },
    sharedEmailAddressOptions: {
      title: "Éditer l’adresse e-mail partagée",
    },
    showDeviceManagementInCockpit: {
      title: "Afficher gestion des appareils dans cockpit",
    },
    system: {
      clientEmailAndPassword:
        "Base de données : adresse e-mail et mot de passe",
      dataStorage: "Configurer le stockage des données",
      dataStorageDatabase: "Stockage des données en base de données",
      dataStorageTablet: "Stockage de données sur la tablette",
      geoEncoding: "Carte",
      moveDevicesDialog: {
        message:
          "Tous les appareils sont ramenés à l’entrepôt d’où ils ont été chargés. Veux-tu continuer ?",
        title: "Ramener les appareils ?",
      },
      tracking: "Suivi",
      operationalPlaning: "Planning d’interventions",
      mira: {
        title: "Mira",
        mode: {
          OFF: "Non",
          IRES_ONLY: "IRES uniquement",
          ON: "Oui",
        },
      },
      systemConfiguration: "Configuration système",
      chat: {
        title: "Activer le chat / la messagerie ?",
        mode: {
          NONE: "Non",
          PERSONAL_ONLY: "Chat personnel uniquement",
          PROJECT_ONLY: "Chat de projet uniquement",
          BOTH: "Les deux chats",
        },
      },
      title: "Système",
    },
    timeTracking: {
      configuration: "Configuration de la saisie des temps",
      createDailyTracking: "Créer clôture journalière",
      dailyTracking: "Clôture de la journée",
      isStartEndMandatory: "Début et fin obligatoires",
      sectionTitle: "Saisie du temps de travail",
      sendDailyTracking: "Envoyer clôture journalière",
      specifyStartEnd: "Spécifier début et fin",
      title: "Saisie des temps",
      workingHours: "Horaires de travail et pauses",
    },
    upload: "Télécharger",
    userManagement: "Utilisateur",
    userSettings: {
      alwaysUseManagerAsSupervisor:
        "Toujours appliquer supérieur hiérarchique en tant que chef de projet",
      cockpitActiveForAllUsers:
        "Afficher le cockpit pour tous les utilisateurs ?",
      keepProjectOwner: "Conserver responsable ",
      strictBranchFilters: "Lien avec le site",
      title: "Réglages utilisateur",
    },
    users: "Gérer utilisateurs",
    vehicleManagement: {
      createVehicle: "Créer véhicule",
      deleteVehicle: "Supprimer véhicule",
      deleteVehicleMessage:
        "Êtes-vous sûr de vouloir supprimer le véhicule {0}?",
      licencePlate: "Numéro d’immatriculation",
      location: "Site",
      size: "Taille",
      sortNumber: "N° de tri.",
      title: "Gérer véhicules",
      user: "Utilisateur",
      vehicleId: "ID du véhicule",
    },
  },
  sharedEmailAddressForm: {
    changeHomeClientButton: "Définir nouveau mandant d’origine",
    changeHomeClientTitle: "Définir nouveau mandant d’origine",
    changePasswordButton:
      "Définir nouveau mot de passe pour l’adresse e-mail partagée",
    changePasswordTitle: "Mot de passe pour partager l’adresse e-mail",
    confirmChangeHomeClient: "Modifier mandant d’origine en {0} ?",
    confirmChangeHomeClientTitle: "En êtes-vous sûr ?",
    quitSharingButton: "Terminer partage de l’adresse e-mail pour ce mandant",
    quitSharingTitle: "Veuillez spécifier une nouvelle adresse e-mail",
  },
  sharedEmailAddressOptionsDialog: {
    message:
      "Inscription multiple à HyDry Portal. Veuillez sélectionner le mandant souhaité.",
    title: "Inscription multiple à HyDry Portal",
    titleForSwitchingSharedUser: "Sélectionner utilisateur partagé",
  },
  userPicker: {
    noMatchingUsers: "Aucun utilisateur correspondant trouvé.",
    noUsers: "Aucun autre utilisateur disponible.",
    selectUser: "Sélectionner utilisateur",
  },
  users: {
    activateCockpit: "Activer cockpit dans app",
    activeFilters: "--- Filtres actifs : {0} ---",
    allRoles: "Tous les rôles",
    admin: "Admin",
    createUser: "Créer utilisateur",
    deleteSharedEmailAddressDialog: {
      message: "L’accès à l’e-mail partagé sera supprimé. Continuer ?",
      title: "Supprimer l’accès partagé à l’e-mail",
    },
    deleteUser: "supprimer",
    deleteUserMessage: "Êtes-vous sûr de vouloir supprimer l’utilisateur {0} ?",
    editUser: "Éditer l’utilisateur",
    emailAddress: "Adresse e-mail",
    error: {
      notAllowedToChangeRole: "Seul un SysAdmin de ce client peut modifier les rôles ou créer des utilisateurs.",
      saveFailed: "L’utilisateur n’a pas pu être enregistré. Réessaie.",
      emailAlreadyUsed: "L’adresse e-mail est déjà utilisée",
      missingNickname: "Veuillez spécifier un nom court",
      missingRole: "Veuillez spécifier le rôle",
      missingValidationLevel:
        "Veuillez spécifier la valeur de la vérification formelle",
      invalidSupervisor:
        "Le manager sélectionné doit disposer de la capacité de supervision de projet",
      nicknameAlreadyTaken: "Le nom court est déjà attribué",
      passwordToShort: "Le mot de passe doit comporter au moins 8 caractères.",
      invalidField: {
        nickname: "Nom court invalide (1–100 caractères)",
        email: "Adresse e-mail invalide",
        role: "Rôle invalide",
        staffNumber: "Numéro de personnel invalide (max. 50 caractères)",
        generic: "Saisie invalide — veuillez vérifier les champs",
      },
    },
    firstName: "Prénom",
    language: "Langue",
    lastEdit: "Dernière mise à jour : {0} {1}",
    lastName: "Nom de famille",
    licences: "Licences",
    lock: "verrouiller",
    lockUser: "Verrouiller utilisateur",
    lockUserMessage:
      "Êtes-vous sûr de vouloir verrouiller l’utilisateur {0} {1} ?",
    mobilePhone: "Mobile",
    nickname: "Nom court",
    noUsersFound: "--- aucun utilisateur trouvé ---",
    postalCode: "Code postal",
    resetUserPassword: "Réinitialiser mot de passe",
    resetUserPasswordMsg:
      "Veuillez spécifier un mot de passe temporaire pour cet utilisateur {0} {1}",
    role: {
      admin: "Admin",
      customRole1: "Rôle défini par l’utilisateur 1",
      customRole2: "Rôle défini par l’utilisateur 2",
      customRole3: "Rôle défini par l’utilisateur 3",
      customRole4: "Rôle défini par l’utilisateur 4",
      customRole5: "Gestionnaire d’appareils",
      editRole: "Éditer rôle",
      isActive: "Rôle actif",
      label: "Désignation du rôle",
      leakDetection: "Détection de fuites",
      na: "",
      notSpecified: "",
      office: "Office",
      projectManager: "Chef de projet",
      sysAdmin: "SysAdmin",
      technicanAndLeakDetection: "Technicien + détection de fuites",
      technician1: "Technicien 1",
      technician2: "Technicien 2",
    },
    staffNumber: "Matricule",
    stationaryPhone: "Téléphone fixe",
    supervisor: "Supérieur hiérarchique",
    temporaryPassword: "Mot de passe temporaire",
    unlock: "déverrouiller",
    unlockUser: "Déverrouiller utilisateur",
    unlockUserMessage:
      "Êtes-vous sûr de vouloir déverrouiller l’utilisateur {0} {1} ?",
    userAddressHousenumber: "Numéro de maison",
    userAddressStreet: "Rue",
    userCountry: "Pays",
    userData: "Données utilisateur",
    userLocation: "Lieu",
    userRole: "Rôle",
    userValidationLevel: "Vérification",
    usesTablet: "Utilisation de la tablette",
    validationLevel: {
      low: "faible",
      normal: "normal",
      strict: "strict",
    },
    vehicle: "Véhicule",
    vehicleAtHome: "Véhicule à domicile",
  },
  quality: {
    title: "RENO Évaluation quotidienne",
    chainTitle: "RENO Évaluation quotidienne : Chaîne {0}",
    tabs: {
      daily: "Résultat quotidien",
      manual: "Résultat manuel",
    },
    windows: {
      all: "Tous",
      days: "{0} Jours",
      selectWindows: "Sélectionner les fenêtres",
    },
    modelVersion: {
      label: "Version du modèle",
    },
    trafficLight: {
      title: "Évaluation",
      good: "Bon",
      needsReview: "À vérifier",
      critical: "Critique",
      unknown: "Inconnu",
    },
    status: {
      probablyDry: "Probablement sec",
      probablyStationary: "Probablement stationnaire",
    },
    binary: {
      title: "Sélection binaire",
      abnormal: "Anormal",
      normal: "Normal",
    },
    groupA: {
      title: "Labels principaux",
      normal: "Normal",
      powerOutages: "Coupures de courant",
      newMoistureIngress: "Nouvelle infiltration d'humidité",
      slowDrying: "Séchage lent",
      unfavorableAmbientConditions: "Conditions ambiantes défavorables",
    },
    groupD: {
      title: "Cause du séchage lent",
      peripheralMoisture: "Humidité périphérique",
      withoutFoil: "Sans film",
      ambientConditions: "Conditions ambiantes",
      lowAirflow: "Faible débit d'air",
    },
    labels: {
      title: "Labels multi-sélection",
      subGroupA: "Problèmes de séchage",
      subGroupB: "Appareil / Méta",
      powerFailure: "Coupures de courant affectant le séchage",
      newMoisture: "Nouvelle infiltration d'humidité",
      slowDrying: "Séchage lent",
      unfavorableConditions: "Température ambiante défavorable",
      ambientHumidityBad: "Humidité ambiante défavorable",
      lowInitialMoisture: "Faible humidité initiale",
      relayDefect: "Défaut de relais",
      notForTraining: "Ne pas utiliser pour l'entraînement",
      clearClass: "Classe claire",
    },
    actions: {
      saveCorrections: "Enregistrer les corrections",
      manualCalculation: "Calcul manuel",
      calculate: "Calculer",
      cancel: "Annuler",
      rerun: "Recalculer",
    },
    messages: {
      correctionSaved: "Correction enregistrée avec succès",
      correctionError: "Erreur lors de l'enregistrement de la correction",
      predictionLoading: "L'évaluation RENO est en cours de calcul...",
      predictionComplete: "Prédiction terminée",
      predictionError: "Erreur de prédiction",
      featureNotActivated: "Les prédictions ne sont pas activées pour ce client.",
      latestModelOnlyRecalculation: "Le recalcul est disponible uniquement pour la version de modèle la plus récente.",
      noData: "Aucune donnée RENO disponible",
      noDailyData: "Aucune évaluation quotidienne disponible",
      noManualData: "Aucune évaluation manuelle disponible",
      programNotSupported: "RENO n’est pas pris en charge pour ce numéro de programme.",
      newerModelAvailable: "Modèle plus récent disponible ({0}). Les résultats peuvent être recalculés avec la nouvelle version.",
      correctedBadge: "Corrigé",
      correctedAt: "Corrigé le {0}",
      correctedBy: "Corrigé par {0}",
    },
    trend: {
      title: "Tendance",
      days: "Derniers {0} jours",
    },
    timeSeries: {
      title: "RENO Série temporelle",
      qualityLabel: "Qualité",
      noData: "Aucune donnée de série temporelle disponible",
      generateHistory: "Générer l’historique",
      backfillProgress: "{0} sur {1} jours calculés",
      targets: {
        dry: "Sec",
        stationary: "Stationnaire",
        newMoistureIngress: "Nouvelle humidité",
        slowDrying: "Lent",
        powerOutage: "Courant",
        relayDefect: "Relais",
        unfavorableAmbient: "Climat",
        lowAirflow: "Flux",
        peripheralMoisture: "Humidité périphérique",
        roomTemperature: "Température",
        roomHumidity: "Humidité rel.",
        moistureLoad: "Humidité abs.",
        deviceOutput: "Puissance",
        favorableWeather: "Aérer",
      },
    },
    noAiModel: "Pas de modèle IA",
  },
  mira: {
    exceptions: {
      leftOut: "{0} écartés comme exceptions",
    },
    landing: {
      comingSoon: "Vue détaillée à venir",
      available: "1 indicateur disponible | {n} indicateurs disponibles",
      waiting: "1 en attente de données | {n} en attente de données",
      ratioLong: "{0} sur {1} indicateurs",
      settings: {
        open: "Paramètres",
        title: "{0} : indicateurs",
        editTitle: "Modifier les indicateurs : {0}",
        availableHeading: "Indicateurs disponibles",
        waitingHeading: "Ce qui débloque d’autres indicateurs",
        defaultChoice: "La tuile affiche les {0} premiers indicateurs de cette section.",
        ownChoice: "La tuile n’affiche que les indicateurs choisis.",
        hint: "Clique sur les indicateurs dans l’ordre où ils doivent apparaître sur la tuile ({0} au maximum). Un deuxième clic en retire un.",
        reset: "Par défaut",
        saved: "Sélection enregistrée",
        saveError: "La sélection n’a pas pu être enregistrée.",
      },
      descriptions: {
        businessDevelopment: "Projets, durée des projets, types de clôture et délai de réaction",
        processFlow: "Combien de temps durent les étapes d’un chantier et où il attend",
        hydry: "Durée de séchage, pauses, fréquence des mesures et surface de séchage",
        devices: "Jours-appareils, heures de fonctionnement, consommation électrique et utilisation du parc",
        insurance: "Délai d’accord, taux d’acceptation et durée de séchage accordée",
        dataQuality: "Dans quelle mesure tes projets et appareils sont saisis",
      },
    },
    unlock: {
      title: "Débloquer plus d’indicateurs",
      waiting: "1 indicateur attend tes données | {n} indicateurs attendent tes données",
      allUnlocked: "Tous les indicateurs sont débloqués",
      showAll: "Tout afficher",
      parts: {
        RECORD: {
          title: "Ce que tu peux saisir",
          subtitle: "Plus ces informations sont complètes, plus tu vois d’indicateurs.",
        },
        CASES: {
          title: "Arrive avec plus de cas",
          subtitle: "Rien à faire ici : l’indicateur apparaît dès qu’il y a assez de cas.",
        },
      },
      shareProgress: "{0} enregistrés · visible à partir de {1}",
      countProgress: "{0} sur {1} cas nécessaires",
      casesInstruction: "Apparaît une fois que {0} cas au moins sont réunis dans la période.",
    },
    periods: {
      rolling12: "12 derniers mois",
      ytd: "Cette année",
      quarter: "T{0} {1}",
      groups: {
        rolling: "Période",
        months: "Mois",
        quarters: "Trimestres",
        years: "Années",
      },
    },
    baseline: {
      heading: "Comparer avec",
      previous: "Période précédente",
      previous12: "12 derniers mois",
      comparedWith: "Comparé avec : {0} ({1} au {2})",
      scaledNote: "totaux ramenés à la durée de la période",
    },
    sections: {
      businessDevelopment: "Développement de l’activité",
      processFlow: "Processus",
      hydry: "Séchage",
      devices: "Appareils",
      insurance: "Assurances",
      dataQuality: "Qualité des données",
    },
    format: {
      hours: "{0} h",
      percent: "{0} %",
      percentBelow: "< {0} %",
      percentAbove: "> {0} %",
      deltaPoints: "{0} pts",
      others: "Autres ({0})",
      spread: "P15 {0} · P85 {1}",
      median: "Médiane {0}",
    },
    allClients: {
      label: "Tous les clients",
    },
    periodTooltip: "Période",
    edition: "{0} · Depuis l’atelier · {1}",
    comparison: {
      upwardTooltip: "Comparaison vers le haut",
      downwardTooltip: "Comparaison vers le bas",
      saved: {
        manage: "Gérer les comparaisons …",
        create: "Nouvelle comparaison",
        editTitle: "Modifier la comparaison",
        reset: "Réinitialiser",
        kindLabel: "Comparer",
        kinds: {
          BRANCHES: "Sites",
          MEMBERS: "Mandants",
          INSURERS: "Assureurs",
        },
        max: "{0} comparaisons au maximum : supprime-en une pour en créer une nouvelle.",
        nameRequired: "Donne un nom à la comparaison.",
        saved: "Comparaison enregistrée",
        deleted: "Comparaison supprimée",
        saveError: "La comparaison n’a pas pu être enregistrée.",
        deleteTitle: "Supprimer la comparaison",
        deleteMessage: "Veux-tu vraiment supprimer la comparaison « {0} » ?",
        listTitle: "Comparaisons",
        empty: "Tu n’as encore créé aucune comparaison. Crée-en une et choisis avec quoi tu veux te comparer.",
        hint: {
          BRANCHES: "Clique sur les sites dans l’ordre où leurs barres doivent apparaître, {0} au maximum.",
          MEMBERS: "Clique sur les mandants dans l’ordre où leurs barres doivent apparaître, {0} au maximum.",
          INSURERS: "Clique sur les assureurs dans l’ordre où leurs barres doivent apparaître, {0} au maximum.",
        },
        noCandidates: {
          BRANCHES: "Ce mandant n’a pas de sites.",
          MEMBERS: "Ce groupe n’a pas de mandants.",
          INSURERS: "Ce mandant n’a pas d’assureur avec assez de projets.",
        },
      },
      choice: "Comparaison : {0}",
      cardTitle: "{0} par mandant",
      referenceGroup: "Groupe total",
      markers: "P15 {0} · médiane {1} · P85 {2}",
      markersLegend: "Traits : {0}, sur les projets de la première ligne",
      withoutValue: "Sans valeur : {0}",
      membersSuffix: "sur {0} des {1} établissements",
      membershipAssumed: "Groupe dans sa composition du {0} : les changements antérieurs ne sont pas pris en compte.",
      showAll: "Tout afficher",
      showLess: "Afficher moins",
      empty: "Aucun mandant du groupe n’a de valeur pour cet indicateur sur la période.",
      cardTitleBranches: "{0} par site",
      cardTitleInsurers: "{0} par assureur",
      emptyInsurers: "Aucun assureur n’a de valeur pour cet indicateur sur la période.",
      insurerOther: "Autres assureurs",
      cardTitleGroupView: "{0} dans le groupe",
      emptyBranches: "Aucun site n’a de valeur pour cet indicateur sur la période.",
      groupView: {
        withheld: "Trop peu d’entreprises ou de cas : {0}",
        empty: "Il n’y a pas de valeur de groupe pour cet indicateur.",
      },
      noMetricForBranches: "Il n’y a pas de comparaison par site pour cet indicateur.",
      noMetricForInsurers: "Il n’y a pas de comparaison par assureur pour cet indicateur.",
      referenceClient: "Total",
      branchNone: "Sans site",
      branchOther: "Autres sites",
      branchUnknown: "Site inconnu",
      headline: "{0} : {1}",
      modes: {
        NONE: "Aucune comparaison",
        MEMBERS: "Mandants du groupe",
        BRANCHES: "Sites du mandant",
        MARKET: "Marché",
        GROUP: "Groupe",
        INSURERS: "Assureurs",
      },
    },
    market: {
      cardTitle: "{0} sur le marché",
      tileCaption: "Marché {0}",
      tooFewCompanies: "Trop peu d’entreprises avec assez de cas : {0}",
      empty: "Il n’y a pas de valeur de marché pour cet indicateur.",
      entities: {
        projects: "Marché",
      },
    },
    trend: {
      title: "Évolution : {0}",
      grains: {
        month: "Mois",
        quarter: "Trimestre",
        year: "Année",
      },
      gapNote: "Trous : trop peu de cas dans la période pour afficher une valeur.",
      partialNote: "Point creux : l’année en cours, pas encore complète.",
      scrollHint: "Périodes précédentes : fais glisser sur le côté.",
      bandNote: "Bande : P15 à P85, les 70 % centraux des cas.",
      rangeNote: "{0} à {1}, quelle que soit la période choisie",
      periodNote: "En gris : la période choisie.",
      medianLineNote: "Ligne : moyenne · ligne fine : médiane",
      partialYear: "{0} (à ce jour)",
      tooFew: "trop peu",
      tooltipBasis: "sur {0}",
      tooltipMedian: "Médiane {0}",
      noData: "Aucune donnée pour cet indicateur sur la période affichée.",
    },
    units: {
      projects: "{0} projets",
      projectsOne: "1 projet",
      dryings: "{0} séchages",
      dryingsOne: "1 séchage",
      assignments: "{0} attributions",
      assignmentsOne: "1 attribution",
      assignmentsWithReading: "{0} attributions avec relevé de compteur",
      assignmentsWithReadingOne: "1 attribution avec relevé de compteur",
      readings: "{0} relevés de compteur",
      readingsOne: "1 relevé de compteur",
      offers: "{0} offres",
      offersOne: "1 offre",
      answers: "{0} réponses",
      answersOne: "1 réponse",
      deviceDays: "{0} jours-appareils",
      deviceDaysOne: "1 jour-appareil",
      devices: "{0} appareils",
      devicesOne: "1 appareil",
    },
    stacked: {
      tooltipTotal: "Total {0}",
      restNote: "{0} autres plus bas dans le classement",
      barFloorNote: "Les barres reposant sur moins de {0} cas sont masquées.",
    },
    levels: {
      best: "Meilleur",
      worst: "Pire",
      highest: "Le plus élevé",
      lowest: "Le plus bas",
      note: "Par période, sur tous ceux qui ont une valeur : les deux valeurs extrêmes et les repères à 25 %, 50 % et 75 % entre elles. Les repères partagent les entrées comparées, pas la valeur ; chaque barre est la valeur d’une entrée. Chacune figure dans le classement ci-dessous.",
      namesFor: "Entre parenthèses : qui occupe cette place sur {0}.",
    },
    caveat: {
      weakestFieldWithGaps: "La valeur correspond au champ le moins rempli. L’assurance, la surface de séchage et le chef de projet ne sont pas encore vérifiés ici.",
      routeRecordedSince2025: "La source de saisie n’est enregistrée que depuis 2025.",
    },
    dataQuality: {
      title: "Qualité des données",
      noData: "Il n’y a pas encore d’analyses Mira pour ton entreprise.",
      loadError: "Les analyses Mira n’ont pas pu être chargées.",
      noValue: "Aucune donnée sur la période",
      periodRange: "{0} : du {1} au {2}",
      generatedAt: "État : {0}",
      weakestField: "Le moins rempli : {0}",
      energyCaption: "sur {0} attributions terminées d’appareils ayant leur propre compteur",
      insurerCaptureCaption: "sur {0} projets hors commande directe",
      fieldsTitle: "Taux de remplissage par champ",
      fieldsSubtitle: "sur {0} projets, champ le moins rempli en premier",
      energyTitle: "Relevés de compteur",
      energyRingCaption: "avec relevés",
      energySubtitle: "comment sont saisies les attributions terminées d’appareils ayant leur propre compteur",
      status: {
        good: "Bien renseigné",
        warning: "Incomplet",
        critical: "Trop peu renseigné",
      },
      legend: {
        good: "à partir de 80 %",
        warning: "de 40 à 79 %",
        critical: "moins de 40 % : les indicateurs qui en dépendent restent masqués",
      },
      fields: {
        branch: "Site",
        projectTypeId: "Type de projet",
        damageDay: "Jour du dommage",
        outcomeState: "Résultat du relevé des dommages",
        rooms: "Pièces dans le relevé des dommages",
        timeline: "Début et fin",
        timeEntries: "Entrées de temps sur le projet",
      },
      energy: {
        withReading: "Avec relevés de compteur",
        unknownReading: "Sans relevé de compteur",
        invalidReading: "Relevé de compteur non valide",
        implausibleReading: "Consommation anormalement élevée",
        onImplausibleProject: "{0} d’entre elles concernent des projets à consommation anormalement élevée ; elles sont comptées ci-dessus.",
      },
      unlocks: {
        title: "Ce qui débloque d’autres indicateurs",
        description: "Ces indicateurs restent masqués pour la période choisie tant que les données saisies ne suffisent pas.",
        none: "Aucun indicateur ne manque de données saisies sur la période choisie.",
        fallback: "Trop peu de données saisies sur la période.",
      },
    },
    drying: {
      title: "Séchage",
      families: {
        box: "Box",
        mini: "Mini",
        panel: "Panel",
      },
      units: {
        day: "{0} jour",
        days: "{0} jours",
        squareMetres: "{0} m²",
        perWeek: "{0} par semaine",
        perProject: "{0} par projet",
      },
      captions: {
        dryingTime: "{0} · sur {1} séchages ({2})",
        pauseShare: "{0} · sur {1} séchages ({2})",
        dryingsWithoutFamily: "{0} · sur {1} séchages",
        projectDryingTime: "{0} · sur {1} projets",
        projectPauseShare: "{0} · sur {1} projets",
        measurementFrequency: "sur {1} séchages, dont {0} sans mesure intermédiaire",
        measurementsPerProject: "sur {1} projets, dont {0} sans mesure intermédiaire",
        dryingArea: "{0} · sur {1} projets",
        forecast: "en moyenne au-delà de la prévision · sur {1} séchages, dont {0} plus longs que prévu",
      },
      cards: {
        dryingTime: "Durée de séchage HyDry par type d’appareil",
        dryingTimeSubtitle: "Chaînes de programme sans projet d’au moins 4 heures, moyenne et médiane",
        pauseShare: "Part des pauses par type d’appareil",
        pauseShareSubtitle: "Pauses en part du temps de séchage, séchages sans projet",
        measurementFrequency: "Fréquence des mesures",
        measurementFrequencySubtitle: "Séries de mesures par semaine de séchage, hors séries à l’installation et au démontage",
        measurementsPerProject: "Mesures intermédiaires par projet",
        measurementsPerProjectSubtitle: "Mesures intermédiaires par projet séché avec une mesure à l’installation du séchage",
        dryingArea: "Surface de séchage",
        dryingAreaSubtitle: "surface moyenne par projet séché",
        forecast: "Prévision et durée réelle de séchage",
        forecastSubtitle: "à quelle fréquence et de combien les séchages dépassent la prévision",
      },
      dotPlot: {
        mean: "Moyenne",
        median: "Médiane",
        count: "Séchages",
      },
      shortChains: "{0} chaînes de programme de moins de 4 heures ne sont pas comptées.",
      shareWithPause: "{0} avec pause",
      pause: {
        dryingPause: "Pause de séchage",
        powerCut: "Coupure de courant",
      },
      measurementGroups: {
        hydry: "Avec appareils HyDry ({0})",
        conventional: "Appareils conventionnels uniquement ({0})",
        noDevices: "Sans appareil attribué ({0})",
      },
      area: {
        floor: "Sol",
        wallCeiling: "Mur / plafond",
      },
      forecast: {
        overForecast: "Plus long que prévu",
      },
      facts: {
        median: "Médiane",
        withoutArea: "Projets sans surface",
        meanOverrun: "En moyenne au-delà de la prévision",
        fromDefault: "Prévision laissée à la valeur par défaut",
        noForecast: "Sans prévision",
        noActual: "Sans durée réelle",
      },
      inPreparation: "En préparation : {0}",
    },
    devices: {
      title: "Appareils",
      controlParts: {
        box: "Box",
        mini: "Mini",
        both: "les deux",
        none: "aucun",
      },
      fleets: {
        own: "Tes appareils",
      },
      units: {
        kWh: "{0} kWh",
        kWhPerDay: "{0} kWh/jour",
        kWhPerSquareMetre: "{0} kWh/m²",
        MWh: "{0} MWh",
        hours: "{0} h",
      },
      captions: {
        fleet: "{0} · plus grand parc",
        energy: "sur {0} attributions avec relevé de compteur",
        energyLeftOut: "sur {0} attributions avec relevé de compteur · {1} projets non comptés",
        energyPerProject: "{0} · sur {1} projets",
        energyPerDryingDay: "{0} · sur {1} projets",
        energyPerArea: "{0} · sur {1} projets",
        partialReadings: "{0} avec des relevés de compteur incomplets",
        deviceDays: "sur {0} attributions",
        devicesPerProject: "{0} · sur {1} projets avec appareils de séchage",
        controlDevicesPerProject: "{0} · sur {1} projets avec une Box ou un Mini",
        controlProjectShare: "{0} sur {1} projets terminés",
        hydryControlLine: "HyDry Control : {0} par projet avec une Box ou un Mini ({1})",
        operatingHours: "sur {0} relevés de compteur",
        operatingHoursDerivedOnly: "uniquement d’après la durée d’attribution : {0}",
      },
      cards: {
        categoryMix: "Jours-appareils par catégorie",
        categoryMixSubtitle: "Part de tous les jours-appareils de tes propres appareils",
        energy: "Consommation électrique",
        energySubtitle: "Appareils avec leur propre compteur électrique, en kWh",
        operatingHours: "Heures de fonctionnement",
        operatingHoursSubtitle: "compteurs relevés et heures d’après la durée d’attribution, jamais additionnés",
      },
      facts: {
        daysInUse: "{0} sur {1} jours",
        total: "Total",
        perProject: "Moyenne par projet",
        leftOutOfTotal: "Projets hors total (consommation invraisemblable)",
        leftOutOfAverage: "Projets hors moyenne (plus de 120 kWh par jour)",
        counterHours: "Heures relevées au compteur",
        derivedConfirmed: "D’après la durée d’attribution, confirmées",
        derivedUnconfirmed: "D’après la durée d’attribution, non confirmées",
        implausibleReadings: "Relevés invraisemblables, non comptés",
      },
      unknownCategory: "Catégorie inconnue",
    },
    businessDevelopment: {
      title: "Développement de l’activité",
      captions: {
        projects: "terminés sur la période",
        duration: "{0} · sur {1} projets terminés",
        rooms: "{0} · sur {1} projets",
        reactionTime: "{0} · sur {1} projets avec date du dommage",
        rejections: "{0} sur {1} projets avec décision",
      },
      cards: {
        outcomes: "Types de clôture",
        outcomesSubtitle: "Résultat du relevé des dommages par projet",
        outcomesRingCaption: "avec résultat",
        branches: "Projets par site",
        branchesSubtitle: "Part de tous les projets avec un site",
        projectTypes: "Répartition des types de projet",
        projectTypesSubtitle: "Part de tous les projets avec un type de projet",
        damageCauses: "Causes du dommage",
        damageCausesSubtitle: "{0} sur {1} projets terminés dans IRES Project avec une cause ; un projet avec plusieurs causes compte pour chacune",
        damageCausesMarketSubtitle: "Part des projets avec une cause ({0} chez toi) ; un projet avec plusieurs causes compte pour chacune, donc plus de 100 % au total",
        damageCausesMore: "Autres causes : {0}",
      },
      facts: {
        rejections: "Refus",
        rejectedOf: "{0} sur {1} ({2})",
        noRejections: "aucun sur la période",
      },
      unknownBranch: "Site inconnu",
      unknownProjectType: "Type de projet inconnu",
      unknownDamageCause: "Cause inconnue",
      services: {
        title: "Prestations",
        caption: "Un projet compte dans chaque prestation terminée sur la période.",
        leakDetection: "Recherche de fuite",
        damageAssessment: "Prise de sinistre",
        drying: "Séchage",
        repair: "Remise en état",
      },
    },
    insurance: {
      title: "Assurances",
      captions: {
        approval: "{0} · sur {1} offres",
        acceptance: "{0} sur {1} réponses acceptées",
        overrun: "{0} · sur {1} séchages avec une offre acceptée",
        directOrders: "{0} sur {1} projets avec une indication",
      },
      cards: {
        answers: "Réponses de l’assurance",
        answersSubtitle: "aux offres d’IRES Project, par mois de la réponse",
        approval: "Accord et séchage",
        approvalSubtitle: "séchages avec une offre acceptée, par mois de fin du projet",
      },
      parts: {
        accepted: "Acceptées",
        rejected: "Refusées",
      },
      bars: {
        overApproved: "Séché plus longtemps qu’accordé",
        cut: "Moins de jours accordés que demandés",
      },
      facts: {
        recordedTogether: "Saisies avec l’offre (sans délai d’accord)",
        implausibleDates: "Dates impossibles",
        meanOverrun: "Moyenne au-delà de l’accord",
        medianOverrun: "Médiane au-delà de l’accord",
        noApprovedDays: "Sans durée de séchage accordée",
        noActual: "Sans durée de séchage réelle",
      },
      insurer: {
        card: "Assureurs",
        cardSubtitle: "Part des projets terminés sur la période",
        insurersHeading: "Par assureur : part des {0} projets avec assurance",
        others: "Autres assureurs",
        unidentified: "non identifié",
        cases: {
          insured: "Avec assurance",
          noInfo: "Non renseigné",
          direct: "Commande directe",
        },
      },
    },
    processFlow: {
      title: "Processus",
      captions: {
        transition: "{0} · sur {1} projets",
      },
      groups: {
        order: "Commande et relevé",
        drying: "Accord et séchage",
        restoration: "Remise en état et clôture",
      },
      cards: {
        order: "Ordre des étapes du projet",
        routes: "Source de saisie",
        routesSubtitle: "avec quoi les étapes du projet ont été saisies",
      },
      routes: {
        viaApp: "IRES Project",
        viaErp: "Système ERP",
        viaPortal: "IRES Office",
      },
      facts: {
        noRoute: "Étapes sans source",
      },
      stack: {
        title: "Déroulé du projet",
        caption: "Sur {0} projets avec toutes les étapes · {1} hors ordre, non comptés",
        insuranceHeader: "Avec accord de l’assurance ({0} projets)",
        damageToApproval: "De la prise de sinistre à l’accord",
        approvalToSetup: "De l’accord au montage de séchage",
        stages: {
          toDamageAssessment: "Jusqu’à la prise de sinistre",
          toDryingSetup: "Jusqu’au montage de séchage",
          drying: "Séchage",
          toProjectEnd: "Jusqu’à la fin du projet",
        },
      },
    },
    metrics: {
      "MIRA-PRJ-003": {
        title: "Répartition des types de clôture",
        unlock: "Clôture le relevé des dommages avec son résultat.",
      },
      "MIRA-PRJ-006": {
        title: "Projets par site",
        unlock: "Attribue un site à chaque projet.",
      },
      "MIRA-PRJ-007": {
        title: "Répartition des types de projet",
        unlock: "Choisis le type de projet pour chaque projet.",
      },
      "MIRA-PRJ-008": {
        title: "Délai de réaction (dommage jusqu’au début du projet)",
        unlock: "Saisis le jour du dommage pour chaque projet.",
      },
      "MIRA-PRJ-011": {
        title: "Nombre de pièces (taille du projet)",
        unlock: "Ajoute les pièces concernées dans le relevé des dommages.",
      },
      "MIRA-PRJ-012": {
        title: "Répartition des types de bâtiment",
        unlock: "Indique le bien / bâtiment dans la description.",
      },
      "MIRA-PRJ-013": {
        title: "Causes du dommage",
        unlock: "Indique la cause du dommage dans le constat.",
      },
      "MIRA-PRJ-015": {
        title: "Caractéristiques du bien",
        unlock: "Renseigne les caractéristiques du bien dans la description.",
      },
      "MIRA-PRJ-016": {
        title: "Répartition des régleurs",
        unlock: "Indique le type de régleur pour chaque projet.",
      },
      "MIRA-PHA-001": {
        title: "Durée des phases",
        unlock: "Démarre et clôture chaque phase dans le déroulement du projet.",
      },
      "MIRA-PHA-002": {
        title: "Temps d’attente entre les phases",
        unlock: "Clôture chaque phase et démarre la suivante dans le déroulement du projet.",
      },
      "MIRA-PHA-003": {
        title: "Délai jusqu’au relevé des dommages",
        unlock: "Enregistre la prise de contact (K1) sur chaque projet.",
      },
      "MIRA-PHA-004": {
        title: "Délai jusqu’à l’attribution des appareils",
        unlock: "Attribue au projet les appareils que tu as installés.",
      },
      "MIRA-PHA-006": {
        title: "Délai jusqu’à la remise en état",
        unlock: "Trop peu de projets avec remise en état sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PHA-010": {
        title: "Source de saisie par phase",
        unlock: "La source de saisie n’est enregistrée que depuis 2025 ; elle manque pour les périodes plus anciennes.",
      },
      "MIRA-PHA-011": {
        title: "Déroulé du projet",
        unlock: "Pour chaque projet, termine la prise de sinistre, le montage de séchage, la fin du séchage et la fin du projet dans l’ordre.",
      },
      "MIRA-PHA-012": {
        title: "Début du projet jusqu’à la commande",
        unlock: "Trop peu de projets terminés avec les deux étapes sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PHA-013": {
        title: "Commande jusqu’à la détection de fuites / au relevé des dommages",
        unlock: "Trop peu de projets terminés avec les deux étapes sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PHA-014": {
        title: "Détection de fuites jusqu’au relevé des dommages",
        unlock: "Trop peu de projets terminés avec les deux étapes sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PHA-015": {
        title: "Relevé des dommages jusqu’au début du séchage",
        unlock: "Trop peu de projets terminés avec les deux étapes sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PHA-016": {
        title: "Relevé des dommages jusqu’à l’accord",
        unlock: "Trop peu de projets terminés avec les deux étapes sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PHA-017": {
        title: "Accord jusqu’au début du séchage / de la remise en état",
        unlock: "Trop peu de projets terminés avec les deux étapes sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PHA-018": {
        title: "Durée du séchage",
        unlock: "Trop peu de projets terminés avec les deux étapes sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PHA-019": {
        title: "Fin du séchage jusqu’à la fin de la remise en état",
        unlock: "Trop peu de projets terminés avec les deux étapes sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PHA-020": {
        title: "Durée de la remise en état",
        unlock: "Trop peu de projets terminés avec les deux étapes sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PHA-021": {
        title: "Jusqu’à la clôture du projet",
        unlock: "Trop peu de projets terminés avec les deux étapes sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PHA-022": {
        title: "Commande jusqu’au début du séchage",
        unlock: "Trop peu de projets terminés avec les deux étapes sur la période. L’indicateur apparaît dès qu’il y en a assez.",
      },
      "MIRA-PRJ-017": {
        title: "Prestations",
        unlock: "Pour chaque projet, termine les prestations réalisées.",
      },
      "MIRA-DRY-001": {
        title: "Durée moyenne de séchage sans projet (HyDry)",
        unlock: "Trop peu de séchages HyDry sans projet avec un début et une fin connus sur la période.",
      },
      "MIRA-DRY-002": {
        title: "Part des pauses sans projet (HyDry)",
        unlock: "Trop peu de séchages HyDry sans projet dont les pauses sont entièrement connues sur la période.",
      },
      "MIRA-DRY-003": {
        title: "Durée moyenne de séchage conventionnel",
        unlock: "Trop peu de projets terminés séchés uniquement avec tes propres appareils. Attribue les appareils pour la durée réelle de séchage.",
      },
      "MIRA-DRY-009": {
        title: "Durée moyenne de séchage par projet (HyDry)",
        unlock: "Trop peu de projets terminés séchés avec des appareils HyDry. Attribue les appareils au projet avec un début et une fin.",
      },
      "MIRA-DRY-010": {
        title: "Durée moyenne de séchage par projet (conventionnel)",
        unlock: "Trop peu de projets terminés séchés uniquement avec des appareils conventionnels. Attribue les appareils au projet avec un début et une fin.",
      },
      "MIRA-DRY-011": {
        title: "Part des pauses par projet (HyDry)",
        unlock: "Trop peu de projets HyDry terminés dont les pauses sont entièrement connues sur la période.",
      },
      "MIRA-DRY-005": {
        title: "Fréquence des mesures",
        unlock: "Saisis dans le protocole de mesure la mesure à l’installation et au démontage du séchage.",
      },
      "MIRA-DRY-012": {
        title: "Mesures intermédiaires par projet",
        unlock: "Saisis dans le protocole de mesure la mesure à l’installation du séchage.",
      },
      "MIRA-DRY-007": {
        title: "Surface moyenne de séchage",
        unlock: "Saisis dans le relevé des dommages les éléments concernés avec leur surface.",
      },
      "MIRA-DRY-008": {
        title: "Prévision et durée réelle de séchage",
        unlock: "Saisis la prévision de durée de séchage et attribue les appareils au projet.",
      },
      "MIRA-DEV-001": {
        title: "Jours-appareils",
        unlock: "Attribue les appareils au projet avec un début et une fin.",
      },
      "MIRA-DEV-002": {
        title: "Heures de fonctionnement",
        unlock: "Saisis les heures de fonctionnement au démontage des autres appareils.",
      },
      "MIRA-DEV-003": {
        title: "Appareils par projet",
        unlock: "Attribue aux projets les appareils utilisés.",
      },
      "MIRA-DEV-015": {
        title: "HyDry Control par projet",
        unlock: "Trop peu de projets terminés avec une Box ou un Mini sur la période.",
      },
      "MIRA-DEV-016": {
        title: "Projets avec HyDry Control",
        unlock: "Attribue les appareils utilisés aux projets.",
      },
      "MIRA-DEV-017": {
        title: "Appareils par projet (entreprises avec leurs propres appareils)",
      },
      "MIRA-DEV-018": {
        title: "Appareils par projet (HyDry uniquement)",
      },
      "MIRA-DEV-004": {
        title: "Consommation électrique",
        unlock: "Saisis les relevés de compteur des appareils à l’installation et au démontage.",
      },
      "MIRA-DEV-005": {
        title: "Consommation électrique moyenne par projet",
        unlock: "Trop peu de projets avec des relevés de compteur complets sur la période.",
      },
      "MIRA-DEV-006": {
        title: "Taux d’utilisation du parc",
        unlock: "Trop peu de données sur ton parc d’appareils sur la période.",
      },
      "MIRA-DEV-011": {
        title: "Taux d’utilisation Box",
        unlock: "Trop peu de données sur tes Box sur la période.",
      },
      "MIRA-DEV-012": {
        title: "Taux d’utilisation Mini",
        unlock: "Trop peu de données sur tes Mini sur la période.",
      },
      "MIRA-DEV-013": {
        title: "Taux d’utilisation Panel",
        unlock: "Trop peu de données sur tes Panel sur la période.",
      },
      "MIRA-DEV-014": {
        title: "Taux d’utilisation de tes appareils",
        unlock: "Trop peu de données sur tes propres appareils sur la période.",
      },
      "MIRA-DEV-009": {
        title: "Consommation électrique moyenne par jour de séchage",
        unlock: "Trop peu de projets avec des relevés de compteur complets sur la période.",
      },
      "MIRA-DEV-010": {
        title: "Consommation électrique par m² de surface de séchage",
        unlock: "Trop peu de projets terminés avec une surface de séchage et des relevés de compteur sur la période.",
      },
      "MIRA-DEV-008": {
        title: "Répartition des catégories / modèles",
        unlock: "Donne à tes appareils une catégorie et un modèle valides.",
      },
      "MIRA-INS-001": {
        title: "Projets par assurance",
      },
      "MIRA-INS-002": {
        title: "Durée moyenne des projets par assurance",
      },
      "MIRA-INS-003": {
        title: "Taux d’attribution des assurances",
        unlock: "Indique l’assurance pour chaque projet.",
      },
      "MIRA-INS-004": {
        title: "Délai d’accord",
        unlock: "Trop peu d’offres avec une réponse de l’assurance sur la période.",
      },
      "MIRA-INS-005": {
        title: "Taux d’acceptation des offres",
        unlock: "Trop peu d’offres avec une réponse de l’assurance sur la période.",
      },
      "MIRA-INS-006": {
        title: "Durée de séchage accordée et réelle",
        unlock: "Trop peu d’offres acceptées avec une durée de séchage accordée sur la période.",
      },
      "MIRA-INS-008": {
        title: "Ordres directs",
        unlock: "Enregistre l’ordre direct sur le projet.",
      },
      "MIRA-DQ-001": {
        title: "Taux de remplissage des champs",
      },
      "MIRA-DQ-002": {
        title: "Couverture des relevés de compteur",
      },
      "MIRA-PRJ-001": {
        title: "Projets",
      },
      "MIRA-PRJ-002": {
        title: "Durée moyenne des projets",
      },
      "MIRA-PRJ-004": {
        title: "Taux de refus",
      },
      "MIRA-PHA-005": {
        title: "Délai jusqu’au démontage du séchage",
      },
      "MIRA-PHA-007": {
        title: "Délai jusqu’à la clôture du projet",
      },
      "MIRA-DRY-004": {
        title: "Avantage HyDry par rapport au séchage conventionnel",
      },
      "MIRA-DRY-006": {
        title: "Réussite du séchage",
      },
    },
  },
  maps: {
    city: "Ville",
    postalCode: "Code postal",
    street: "Rue",
    houseNumber: "Numéro",
    result: "Résultat",
    start: "Départ",
    destination: "Destination",
    deleteMarkers: "Supprimer les marqueurs",
    deleteRoutes: "Supprimer les itinéraires",
    geocode: "Rechercher l’adresse",
    showRoute: "Afficher l’itinéraire",
    noAddress: "Veuillez saisir au moins une ville, une rue ou un code postal.",
    geocodingFailed: "L’adresse n’a pas pu être trouvée.",
    routeMissingAddresses: "Veuillez saisir un départ et une destination.",
    routeFailed: "L’itinéraire n’a pas pu être calculé.",
    distance: "Distance",
    duration: "Temps de trajet",
  },
  timeTrackingHistory: {
    dayEntries: "Entrées du jour",
    noEntries: "Aucune entrée pour ce jour.",
    selectDayHint: "Veuillez sélectionner un jour dans le calendrier.",
    daySummary: "Aperçu du jour",
    dayClosed: "Jour clôturé",
    dayOpen: "Jour ouvert",
    today: "Aujourd'hui",
    projectWork: "Travail de projet",
    projectTime: "Temps de projet",
    activeProjectEntries: "Projet actif – Entrées",
    lastProjectEntries: "Dernier projet – Entrées",
    projectEntries: "Projet – Entrées",
    backToActiveProject: "Retour au projet actif",
    backToLastProject: "Retour au dernier projet",
    noProjectEntries: "Aucune entrée de projet disponible.",
    loadingProjectEntries: "Chargement des entrées de projet…",
    projectArchived: "Archivé",
    projectDeleted: "Supprimé",
    mergedEntriesTooltip: "Regroupé à partir de {count} entrées",
    startOfDay: "Début de journée",
    endOfDay: "Fin de journée",
    columns: {
      time: "Heure",
      duration: "Durée",
      description: "Description",
      timeRange: "Période",
      date: "Date",
      phase: "Phase",
      project: "Projet",
      user: "Utilisateur",
      source: "Source",
    },
    phases: {
      damageAssessment: "Constatation des dégâts",
      leakDetection: "Détection de fuite",
      drying: "Séchage",
      dryingPreparation: "Installation du séchage",
      repair: "Restauration",
    },
    tasks: {
      orderEntry: "Établir le contact",
      firstContact: "Premier contact",
      leakDetection: "Détection de fuite",
      damageAssessment: "Constatation des dégâts",
      insuranceOffer: "Offre d’assurance",
      dryingApproval: "Approbation du séchage",
      dryingPreparation: "Installation du séchage",
      intermediateMeasurement: "Mesure",
      dryingConclusion: "Démontage du séchage",
      repair: "Restauration",
      projectConclusion: "Projet terminé",
    },
    travel: {
      toOffice: "Trajet au bureau",
      toHome: "Trajet à la maison",
      toProject: "Trajet vers l’adresse",
      approach: "Approche",
    },
    autoContext: {
      prepareDrying: "Préparation du séchage",
      finalMeasurement: "Mesure finale",
      finalResubmission: "Représentation finale",
      finalDrying: "Séchage final",
    },
    categories: {
      pause: "Pause",
      travelingTime: "Temps de trajet",
      internal: "Interne",
      other: "Autre",
      general: "Général",
      interruption: "Interruption",
      silentInterruption: "Interruption silencieuse",
    },
    summary: {
      totalTime: "Temps enregistré",
      workingTime: "Temps de travail calculé",
      travelTime: "Temps de trajet",
      projectTime: "Temps de projet",
      internalWork: "Travaux internes",
      pause: "Pause",
      unexplained: "Non expliqué",
    },
    markerReasons: {
      overlapStart: "L'heure de début chevauche une autre entrée.",
      overlapEnd: "L'heure de fin est chevauchée par une autre entrée.",
      dayClamped: "La valeur a été limitée à la frontière du jour sélectionné.",
      crossDay: "L'entrée s'étend sur plusieurs jours.",
      adjustedData: "L'horodatage a été ajusté à cause de données source incohérentes.",
      mergedBoundary: "La limite affichée provient d'entrées adjacentes fusionnées (dans l'intervalle de fusion configuré).",
    },
  },
  staleEntryAutoClose: {
    title: "Entrée de temps clôturée automatiquement",
    subtitle: "Nous avons clôturé cette tâche automatiquement car aucune activité supplémentaire n’a été enregistrée de ta part.\nSouhaites-tu ajuster ton heure de fin ?",
    projectEntryLabel: "Travail sur projet : {project}",
    projectEntryLabelFallback: "Travail sur projet",
    otherEntryLabel: "Entrée générale",
    proposedEndLabel: "Heure de fin proposée",
    editHint: "Ajuster l'heure de fin",
    accept: "Confirmer",
    invalidTime: "Heure invalide.",
    successMessage: "L'entrée de temps a été fermée.",
  },
};
